export default {
  '积石山保安族东乡族撒拉族自治县':'積石山保安族東鄉族撒拉族自治縣',
  '双江拉祜族佤族布朗族傣族自治县':'雙江拉祜族佤族布朗族傣族自治縣',
  '镇沅彝族哈尼族拉祜族自治县':'鎮沅彞族哈尼族拉祜族自治縣',
  '孟连傣族拉祜族佤族自治县':'孟連傣族拉祜族佤族自治縣',
  '元江哈尼族彝族傣族自治县':'元江哈尼族彞族傣族自治縣',
  '塔什库尔干塔吉克自治县':'塔什庫爾乾塔吉克自治縣',
  '莫力达瓦达斡尔族自治旗':'莫力達瓦達斡爾族自治旗',
  '金平苗族瑶族傣族自治县':'金平苗族瑤族傣族自治縣',
  '威宁彝族回族苗族自治县':'威寧彞族回族苗族自治縣',
  '黔西南布依族苗族自治州':'黔西南布依族苗族自治州',
  '前郭尔罗斯蒙古族自治县':'前郭爾羅斯蒙古族自治縣',
  '喀喇沁左翼蒙古族自治县':'喀喇沁左翼蒙古族自治縣',
  '克孜勒苏柯尔克孜自治州':'克孜勒蘇柯爾克孜自治州',
  '红河哈尼族彝族自治州':'紅河哈尼族彞族自治州',
  '兰坪白族普米族自治县':'蘭坪白族普米族自治縣',
  '贡山独龙族怒族自治县':'貢山獨龍族怒族自治縣',
  '德宏傣族景颇族自治州':'德宏傣族景頗族自治州',
  '秀山土家族苗族自治县':'秀山土家族苗族自治縣',
  '海西蒙古族藏族自治州':'海西蒙古族藏族自治州',
  '彭水苗族土家族自治县':'彭水苗族土家族自治縣',
  '道真仡佬族苗族自治县':'道真仡佬族苗族自治縣',
  '务川仡佬族苗族自治县':'務川仡佬族苗族自治縣',
  '镇宁布依族苗族自治县':'鎮寧布依族苗族自治縣',
  '紫云苗族布依族自治县':'紫雲苗族布依族自治縣',
  '关岭布依族苗族自治县':'關嶺布依族苗族自治縣',
  '印江土家族苗族自治县':'印江土家族苗族自治縣',
  '围场满族蒙古族自治县':'圍場滿族蒙古族自治縣',
  '酉阳土家族苗族自治县':'酉陽土家族苗族自治縣',
  '杜尔伯特蒙古族自治县':'杜爾伯特蒙古族自治縣',
  '黔东南苗族侗族自治州':'黔東南苗族侗族自治州',
  '黔南布依族苗族自治州':'黔南布依族苗族自治州',
  '阿克塞哈萨克族自治县':'阿克塞哈薩克族自治縣',
  '普洱哈尼族彝族自治县':'普洱哈尼族彞族自治縣',
  '恩施土家族苗族自治州':'恩施土家族苗族自治州',
  '湘西土家族苗族自治州':'湘西土家族苗族自治州',
  '江城哈尼族彝族自治县':'江城哈尼族彞族自治縣',
  '巴里坤哈萨克自治县':'巴裡坤哈薩克自治縣',
  '博尔塔拉蒙古自治州':'博爾塔拉蒙古自治州',
  '达尔罕茂明安联合旗':'達爾罕茂明安聯合旗',
  '保亭黎族苗族自治县':'保亭黎族苗族自治縣',
  '琼中黎族苗族自治县':'瓊中黎族苗族自治縣',
  '大通回族土族自治县':'大通回族土族自治縣',
  '察布查尔锡伯自治县':'察布查爾錫伯自治縣',
  '靖州苗族侗族自治县':'靖州苗族侗族自治縣',
  '禄劝彝族苗族自治县':'祿勸彞族苗族自治縣',
  '寻甸回族彝族自治县':'尋甸回族彞族自治縣',
  '新平彝族傣族自治县':'新平彞族傣族自治縣',
  '民和回族土族自治县':'民和回族土族自治縣',
  '耿马傣族佤族自治县':'耿馬傣族佤族自治縣',
  '阿坝藏族羌族自治州':'阿壩藏族羌族自治州',
  '西双版纳傣族自治州':'西雙版納傣族自治州',
  '景谷傣族彝族自治县':'景谷傣族彞族自治縣',
  '连山壮族瑶族自治县':'連山壯族瑤族自治縣',
  '巍山彝族回族自治县':'巍山彞族回族自治縣',
  '文山壮族苗族自治州':'文山壯族苗族自治州',
  '巴音郭楞蒙古自治州':'巴音郭楞蒙古自治州',
  '五峰土家族自治县':'五峰土家族自治縣',
  '澜沧拉祜族自治县':'瀾滄拉祜族自治縣',
  '玉龙纳西族自治县':'玉龍納西族自治縣',
  '石柱土家族自治县':'石柱土家族自治縣',
  '怒江傈僳族自治州':'怒江傈僳族自治州',
  '木垒哈萨克自治县':'木壘哈薩克自治縣',
  '环江毛南族自治县':'環江毛南族自治縣',
  '维西傈僳族自治县':'維西傈僳族自治縣',
  '罗城仫佬族自治县':'羅城仫佬族自治縣',
  '伊犁哈萨克自治州':'伊犁哈薩克自治州',
  '长阳土家族自治县':'長陽土家族自治縣',
  '墨江哈尼族自治县':'墨江哈尼族自治縣',
  '循化撒拉族自治县':'循化撒拉族自治縣',
  '梅里斯达斡尔族区':'梅裡斯達斡爾族區',
  '延边朝鲜族自治州':'延邊朝鮮族自治州',
  '张家川回族自治县':'張家川回族自治縣',
  '肃北蒙古族自治县':'肅北蒙古族自治縣',
  '长白朝鲜族自治县':'長白朝鮮族自治縣',
  '肃南裕固族自治县':'肅南裕固族自治縣',
  '阜新蒙古族自治县':'阜新蒙古族自治縣',
  '河南蒙古族自治县':'河南蒙古族自治縣',
  '沿河土家族自治县':'沿河土家族自治縣',
  '宽甸满族自治县':'寬甸滿族自治縣',
  '大厂回族自治县':'大廠回族自治縣',
  '丰宁满族自治县':'豐寧滿族自治縣',
  '伊通满族自治县':'伊通滿族自治縣',
  '昌吉回族自治州':'昌吉回族自治州',
  '焉耆回族自治县':'焉耆回族自治縣',
  '互助土族自治县':'互助土族自治縣',
  '马边彝族自治县':'馬邊彞族自治縣',
  '峨边彝族自治县':'峨邊彞族自治縣',
  '宽城满族自治县':'寬城滿族自治縣',
  '甘孜藏族自治州':'甘孜藏族自治州',
  '凉山彝族自治州':'涼山彞族自治州',
  '木里藏族自治县':'木里藏族自治縣',
  '昌江黎族自治县':'昌江黎族自治縣',
  '玉树藏族自治州':'玉樹藏族自治州',
  '鄂温克族自治旗':'鄂溫克族自治旗',
  '果洛藏族自治州':'果洛藏族自治州',
  '门源回族自治县':'門源回族自治縣',
  '玉屏侗族自治县':'玉屏侗族自治縣',
  '松桃苗族自治县':'松桃苗族自治縣',
  '海北藏族自治州':'海北藏族自治州',
  '景宁畲族自治县':'景寧畲族自治縣',
  '孟村回族自治县':'孟村回族自治縣',
  '化隆回族自治县':'化隆回族自治縣',
  '科尔沁右翼前旗':'科爾沁右翼前旗',
  '科尔沁右翼中旗':'科爾沁右翼中旗',
  '三都水族自治县':'三都水族自治縣',
  '石林彝族自治县':'石林彞族自治縣',
  '科尔沁左翼中旗':'科爾沁左翼中旗',
  '科尔沁左翼后旗':'科爾沁左翼後旗',
  '峨山彝族自治县':'峨山彞族自治縣',
  '城步苗族自治县':'城步苗族自治縣',
  '江华瑶族自治县':'江華瑤族自治縣',
  '新晃侗族自治县':'新晃侗族自治縣',
  '宁蒗彝族自治县':'寧蒗彞族自治縣',
  '芷江侗族自治县':'芷江侗族自治縣',
  '通道侗族自治县':'通道侗族自治縣',
  '景东彝族自治县':'景東彞族自治縣',
  '黄南藏族自治州':'黃南藏族自治州',
  '麻阳苗族自治县':'麻陽苗族自治縣',
  '海南藏族自治州':'海南藏族自治州',
  '乳源瑶族自治县':'乳源瑤族自治縣',
  '察哈尔右翼前旗':'察哈爾右翼前旗',
  '西盟佤族自治县':'西盟佤族自治縣',
  '察哈尔右翼中旗':'察哈爾右翼中旗',
  '连南瑶族自治县':'連南瑤族自治縣',
  '融水苗族自治县':'融水苗族自治縣',
  '沧源佤族自治县':'滄源佤族自治縣',
  '三江侗族自治县':'三江侗族自治縣',
  '龙胜各族自治县':'龍勝各族自治縣',
  '恭城瑶族自治县':'恭城瑤族自治縣',
  '隆林各族自治县':'隆林各族自治縣',
  '迪庆藏族自治州':'迪慶藏族自治州',
  '富川瑶族自治县':'富川瑤族自治縣',
  '大理白族自治州':'大理白族自治州',
  '漾濞彝族自治县':'漾濞彞族自治縣',
  '南涧彝族自治县':'南澗彞族自治縣',
  '都安瑶族自治县':'都安瑤族自治縣',
  '楚雄彝族自治州':'楚雄彞族自治州',
  '察哈尔右翼后旗':'察哈爾右翼後旗',
  '巴马瑶族自治县':'巴馬瑤族自治縣',
  '河口瑶族自治县':'河口瑤族自治縣',
  '屏边苗族自治县':'屏邊苗族自治縣',
  '岫岩满族自治县':'岫岩滿族自治縣',
  '大化瑶族自治县':'大化瑤族自治縣',
  '金秀瑶族自治县':'金秀瑤族自治縣',
  '清原满族自治县':'清原滿族自治縣',
  '新宾满族自治县':'新賓滿族自治縣',
  '天祝藏族自治县':'天祝藏族自治縣',
  '白沙黎族自治县':'白沙黎族自治縣',
  '青龙满族自治县':'青龍滿族自治縣',
  '乐东黎族自治县':'樂東黎族自治縣',
  '临夏回族自治州':'臨夏回族自治州',
  '陵水黎族自治县':'陵水黎族自治縣',
  '本溪满族自治县':'本溪滿族自治縣',
  '甘南藏族自治州':'甘南藏族自治州',
  '桓仁满族自治县':'桓仁滿族自治縣',
  '北川羌族自治县':'北川羌族自治縣',
  '东乡族自治县':'東鄉族自治縣',
  '圣安多尼堂区':'聖安多尼堂區',
  '圣方济各堂区':'聖方濟各堂區',
  '大兴安岭辖区':'大興安嶺轄區',
  '大兴安岭地区':'大興安嶺地區',
  '鹰手营子矿区':'鷹手營子礦區',
  '东乌珠穆沁旗':'東烏珠穆沁旗',
  '新巴尔虎左旗':'新巴爾虎左旗',
  '新巴尔虎右旗':'新巴爾虎右旗',
  '鄂伦春自治旗':'鄂倫春自治旗',
  '阿鲁科尔沁旗':'阿魯科爾沁旗',
  '西乌珠穆沁旗':'西烏珠穆沁旗',
  '乌兰察布盟':'烏蘭察布盟',
  '五大连池市':'五大連池市',
  '阿克苏地区':'阿克蘇地區',
  '呼和浩特市':'呼和浩特市',
  '陈巴尔虎旗':'陳巴爾虎旗',
  '鄂托克前旗':'鄂托克前旗',
  '伊金霍洛旗':'伊金霍洛旗',
  '花地玛堂区':'花地瑪堂區',
  '管城回族区':'管城回族區',
  '顺河回族区':'順河回族區',
  '瀍河回族区':'瀍河回族區',
  '堆龙德庆县':'堆龍德慶縣',
  '墨竹工卡县':'墨竹工卡縣',
  '工布江达县':'工布江達縣',
  '日喀则地区':'日喀則地區',
  '阿勒泰地区':'阿勒泰地區',
  '巴彦淖尔盟':'巴彥淖爾盟',
  '乌拉特前旗':'烏拉特前旗',
  '乌拉特中旗':'烏拉特中旗',
  '吉木萨尔县':'吉木薩爾縣',
  '乌拉特后旗':'烏拉特後旗',
  '神农架林区':'神農架林區',
  '阿拉善左旗':'阿拉善左旗',
  '阿拉善右旗':'阿拉善右旗',
  '乌兰浩特市':'烏蘭浩特市',
  '克什克腾旗':'克什克騰旗',
  '呼伦贝尔市':'呼倫貝爾市',
  '霍林郭勒市':'霍林郭勒市',
  '额尔古纳市':'額爾古納市',
  '土默特左旗':'土默特左旗',
  '锡林郭勒盟':'錫林郭勒盟',
  '二连浩特市':'二連浩特市',
  '锡林浩特市':'錫林浩特市',
  '苏尼特左旗':'蘇尼特左旗',
  '苏尼特右旗':'蘇尼特右旗',
  '和林格尔县':'和林格爾縣',
  '齐齐哈尔市':'齊齊哈爾市',
  '富拉尔基区':'富拉爾基區',
  '香格里拉县':'香格裡拉縣',
  '乌鲁木齐市':'烏魯木齊市',
  '沙依巴克区':'沙依巴克區',
  '乌鲁木齐县':'烏魯木齊縣',
  '克拉玛依市':'克拉瑪依市',
  '克拉玛依区':'克拉瑪依區',
  '吐鲁番地区':'吐魯番地區',
  '土默特右旗':'土默特右旗',
  '丹江口市':'丹江口市',
  '翁牛特旗':'翁牛特旗',
  '禹王台区':'禹王台區',
  '喀喇沁旗':'喀喇沁旗',
  '平顶山市':'平頂山市',
  '三门峡市':'三門峽市',
  '驻马店市':'駐馬店市',
  '东西湖区':'東西湖區',
  '黄石港区':'黃石港區',
  '西塞山区':'西塞山區',
  '石景山区':'石景山區',
  '涉 县':'涉  縣',
  '伍家岗区':'伍家崗區',
  '海拉尔市':'海拉爾市',
  '满洲里市':'滿洲里市',
  '老河口市':'老河口市',
  '梁子湖区':'梁子湖區',
  '扎兰屯市':'扎蘭屯市',
  '塔城地区':'塔城地區',
  '牙克石市':'牙克石市',
  '磁 县':'磁  縣',
  '邱 县':'邱  縣',
  '岳阳楼区':'岳陽樓區',
  '张家界市':'張家界市',
  '武陵源区':'武陵源區',
  '冷水滩区':'冷水灘區',
  '尼勒克县':'尼勒克縣',
  '魏 县':'魏  縣',
  '任 县':'任  縣',
  '威 县':'威  縣',
  '唐 县':'唐  縣',
  '易 县':'易  縣',
  '蠡 县':'蠡  縣',
  '冷水江市':'冷水江市',
  '阿尔山市':'阿爾山市',
  '特克斯县':'特克斯縣',
  '高碑店市':'高碑店市',
  '下花园区':'下花園區',
  '扎赉特旗':'扎賚特旗',
  '科尔沁区':'科爾沁區',
  '图木舒克':'圖木舒克',
  '西乡塘区':'西鄉塘區',
  '蔚 县':'蔚  縣',
  '门头沟区':'門頭溝區',
  '蓟 县':'薊  縣',
  '扎鲁特旗':'扎魯特旗',
  '铁山港区':'鐵山港區',
  '防城港市':'防城港市',
  '石家庄市':'石家莊市',
  '郊 区':'郊  區',
  '金城江区':'金城江區',
  '沧 县':'滄  縣',
  '阿巴嘎旗':'阿巴嘎旗',
  '青 县':'青  縣',
  '献 县':'獻  縣',
  '井陉矿区':'井陘礦區',
  '赵 县':'趙  縣',
  '五指山市':'五指山市',
  '太仆寺旗':'太僕寺旗',
  '正镶白旗':'正鑲白旗',
  '景 县':'景  縣',
  '杏花岭区':'杏花嶺區',
  '尖草坪区':'尖草坪區',
  '万柏林区':'萬柏林區',
  '四子王旗':'四子王旗',
  '伊克昭盟':'伊克昭盟',
  '大渡口区':'大渡口區',
  '沙坪坝区':'沙坪壩區',
  '九龙坡区':'九龍坡區',
  '呼图壁县':'呼圖壁縣',
  '达拉特旗':'達拉特旗',
  '准格尔旗':'準格爾旗',
  '城 区':'城  區',
  '鄂托克旗':'鄂托克旗',
  '矿 区':'礦  區',
  '龙泉驿区':'龍泉驛區',
  '青白江区':'青白江區',
  '都江堰市':'都江堰市',
  '玛纳斯县':'瑪納斯縣',
  '自流井区':'自流井區',
  '攀枝花市':'攀枝花市',
  '龙马潭区':'龍馬潭區',
  '盂 县':'盂  縣',
  '沁 县':'沁  縣',
  '应 县':'應  縣',
  '五通桥区':'五通橋區',
  '金口河区':'金口河區',
  '峨眉山市':'峨眉山市',
  '代 县':'代  縣',
  '杭锦后旗':'杭錦後旗',
  '阿拉善盟':'阿拉善盟',
  '马尔康县':'馬爾康縣',
  '九寨沟县':'九寨溝縣',
  '若尔盖县':'若爾蓋縣',
  '兴 县':'興  縣',
  '临 县':'臨  縣',
  '额济纳旗':'額濟納旗',
  '六盘水市':'六盤水市',
  '库尔勒市':'庫爾勒市',
  '六枝特区':'六枝特區',
  '红花岗区':'紅花崗區',
  '苏家屯区':'蘇家屯區',
  '新城子区':'新城子區',
  '沙河口区':'沙河口區',
  '甘井子区':'甘井子區',
  '旅顺口区':'旅順口區',
  '铜仁地区':'銅仁地區',
  '瓦房店市':'瓦房店市',
  '普兰店市':'普蘭店市',
  '岚 县':'嵐  縣',
  '祁 县':'祁  縣',
  '万山特区':'萬山特區',
  '毕节地区':'畢節地區',
  '古 县':'古  縣',
  '吉 县':'吉  縣',
  '蒲 县':'蒲  縣',
  '隰 县':'隰  縣',
  '鲅鱼圈区':'鮁魚圈區',
  '大石桥市':'大石橋市',
  '清河门区':'清河門區',
  '夏 县':'夏  縣',
  '太子河区':'太子河區',
  '弓长岭区':'弓長嶺區',
  '双台子区':'雙檯子區',
  '兴隆台区':'興隆台區',
  '调兵山市':'調兵山市',
  '绛 县':'絳  縣',
  '葫芦岛市':'葫蘆島市',
  '公主岭市':'公主嶺市',
  '新 区':'新  區',
  '二道江区':'二道江區',
  '梅河口市':'梅河口市',
  '八道江区':'八道江區',
  '滦 县':'灤  縣',
  '托克托县':'托克托縣',
  '秦皇岛市':'秦皇島市',
  '黑龙江省':'黑龍江省',
  '哈尔滨市':'哈爾濱市',
  '清水河县':'清水河縣',
  '昂昂溪区':'昂昂溪區',
  '昆都伦区':'昆都倫區',
  '碾子山区':'碾子山區',
  '石拐矿区':'石拐礦區',
  '四方台区':'四方台區',
  '城子河区':'城子河區',
  '萨尔图区':'薩爾圖區',
  '让胡路区':'讓胡路區',
  '白云矿区':'白雲礦區',
  '金山屯区':'金山屯區',
  '乌马河区':'烏馬河區',
  '上甘岭区':'上甘嶺區',
  '汤旺河区':'湯旺河區',
  '乌伊岭区':'烏伊嶺區',
  '牡丹江市':'牡丹江市',
  '绥芬河市':'綏芬河市',
  '佳木斯市':'佳木斯市',
  '麻栗坡县':'麻慄坡縣',
  '七台河市':'七台河市',
  '阿克陶县':'阿克陶縣',
  '茄子河区':'茄子河區',
  '山海关区':'山海關區',
  '那曲地区':'那曲地區',
  '昌都地区':'昌都地區',
  '类乌齐县':'類烏齊縣',
  '林芝地区':'林芝地區',
  '北戴河区':'北戴河區',
  '阿合奇县':'阿合奇縣',
  '山南地区':'山南地區',
  '浪卡子县':'浪卡子縣',
  '海勃湾区':'海勃灣區',
  '日喀则市':'日喀則市',
  '南木林县':'南木林縣',
  '谢通门县':'謝通門縣',
  '聂拉木县':'聶拉木縣',
  '阿里地区':'阿裡地區',
  '阿图什市':'阿圖什市',
  '浦东新区':'浦東新區',
  '雨花台区':'雨花台區',
  '英吉沙县':'英吉沙縣',
  '麦盖提县':'麥蓋提縣',
  '岳普湖县':'岳普湖縣',
  '七里河区':'七里河區',
  '嘉峪关市':'嘉峪關市',
  '张家港市':'張家港市',
  '戚墅堰区':'戚墅堰區',
  '连云港市':'連雲港市',
  '元宝山区':'元寶山區',
  '龙子湖区':'龍子湖區',
  '喀什地区':'喀什地區',
  '阿瓦提县':'阿瓦提縣',
  '田家庵区':'田家庵區',
  '谢家集区':'謝家集區',
  '八公山区':'八公山區',
  '马鞍山市':'馬鞍山市',
  '金家庄区':'金家莊區',
  '海东地区':'海東地區',
  '铜官山区':'銅官山區',
  '狮子山区':'獅子山區',
  '黄大仙区':'黃大仙區',
  '九龙城区':'九龍城區',
  '油尖旺区':'油尖旺區',
  '深水埗区':'深水埗區',
  '阿克苏市':'阿克蘇市',
  '嘉模堂区':'嘉模堂區',
  '风顺堂区':'風順堂區',
  '武夷山市':'武夷山市',
  '青云谱区':'青雲譜區',
  '曲麻莱县':'曲麻萊縣',
  '青山湖区':'青山湖區',
  '德令哈市':'德令哈市',
  '格尔木市':'格爾木市',
  '石嘴山市':'石嘴山市',
  '大武口区':'大武口區',
  '青铜峡市':'青銅峽市',
  '沙坡头区':'沙坡頭區',
  '景德镇市':'景德鎮市',
  '望德堂区':'望德堂區',
  '水磨沟区':'水磨溝區',
  '头屯河区':'頭屯河區',
  '达坂城区':'達阪城區',
  '井冈山市':'井岡山市',
  '台儿庄区':'台兒莊區',
  '巴林左旗':'巴林左旗',
  '独山子区':'獨山子區',
  '白碱滩区':'白鹼灘區',
  '乌尔禾区':'烏爾禾區',
  '巴林右旗':'巴林右旗',
  '吐鲁番市':'吐魯番市',
  '托克逊县':'托克遜縣',
  '哈密地区':'哈密地區',
  '东昌府区':'東昌府區',
  '和田地区':'和田地區',
  '峰峰矿区':'峰峰礦區',
  '桃城区':'桃城區',
  '临西县':'臨西縣',
  '南宫市':'南宮市',
  '沙河市':'沙河市',
  '保定市':'保定市',
  '辽宁省':'遼寧省',
  '沈阳市':'沈陽市',
  '沈河区':'沈河區',
  '皇姑区':'皇姑區',
  '大东区':'大東區',
  '铁西区':'鐵西區',
  '新市区':'新市區',
  '东陵区':'東陵區',
  '于洪区':'於洪區',
  '新民市':'新民市',
  '法库县':'法庫縣',
  '辽中县':'遼中縣',
  '康平县':'康平縣',
  '北市区':'北市區',
  '大连市':'大連市',
  '西岗区':'西崗區',
  '中山区':'中山區',
  '南市区':'南市區',
  '满城县':'滿城縣',
  '清苑县':'清苑縣',
  '金州区':'金州區',
  '涞水县':'淶水縣',
  '阜平县':'阜平縣',
  '庄河市':'莊河市',
  '长海县':'長海縣',
  '鞍山市':'鞍山市',
  '铁东区':'鐵東區',
  '立山区':'立山區',
  '千山区':'千山區',
  '海城市':'海城市',
  '台安县':'台安縣',
  '徐水县':'徐水縣',
  '抚顺市':'撫順市',
  '顺城区':'順城區',
  '新抚区':'新撫區',
  '东洲区':'東洲區',
  '望花区':'望花區',
  '抚顺县':'撫順縣',
  '定兴县':'定興縣',
  '河东区':'河東區',
  '本溪市':'本溪市',
  '平山区':'平山區',
  '明山区':'明山區',
  '溪湖区':'溪湖區',
  '南芬区':'南芬區',
  '高阳县':'高陽縣',
  '容城县':'容城縣',
  '丹东市':'丹東市',
  '振兴区':'振興區',
  '元宝区':'元寶區',
  '振安区':'振安區',
  '东港市':'東港市',
  '凤城市':'鳳城市',
  '涞源县':'淶源縣',
  '锦州市':'錦州市',
  '太和区':'太和區',
  '古塔区':'古塔區',
  '凌河区':'凌河區',
  '凌海市':'凌海市',
  '黑山县':'黑山縣',
  '葵青区':'葵青區',
  '北宁市':'北寧市',
  '营口市':'營口市',
  '站前区':'站前區',
  '西市区':'西市區',
  '望都县':'望都縣',
  '老边区':'老邊區',
  '安新县':'安新縣',
  '盖州市':'蓋州市',
  '阜新市':'阜新市',
  '海州区':'海州區',
  '新邱区':'新邱區',
  '太平区':'太平區',
  '河西区':'河西區',
  '细河区':'細河區',
  '彰武县':'彰武縣',
  '曲阳县':'曲陽縣',
  '辽阳市':'遼陽市',
  '白塔区':'白塔區',
  '文圣区':'文聖區',
  '宏伟区':'宏偉區',
  '南开区':'南開區',
  '顺平县':'順平縣',
  '灯塔市':'燈塔市',
  '辽阳县':'遼陽縣',
  '荃湾区':'荃灣區',
  '中西区':'中西區',
  '离岛区':'離島區',
  '盘山县':'盤山縣',
  '大洼县':'大窪縣',
  '铁岭市':'鐵嶺市',
  '银州区':'銀州區',
  '清河区':'清河區',
  '涿州市':'涿州市',
  '开原市':'開原市',
  '铁岭县':'鐵嶺縣',
  '昌图县':'昌圖縣',
  '西丰县':'西豐縣',
  '朝阳市':'朝陽市',
  '双塔区':'雙塔區',
  '龙城区':'龍城區',
  '凌源市':'凌源市',
  '北票市':'北票市',
  '朝阳县':'朝陽縣',
  '建平县':'建平縣',
  '定州市':'定州市',
  '安国市':'安國市',
  '龙港区':'龍港區',
  '南票区':'南票區',
  '连山区':'連山區',
  '兴城市':'興城市',
  '绥中县':'綏中縣',
  '建昌县':'建昌縣',
  '吉林省':'吉林省',
  '长春市':'長春市',
  '宽城区':'寬城區',
  '二道区':'二道區',
  '南关区':'南關區',
  '绿园区':'綠園區',
  '双阳区':'雙陽區',
  '九台市':'九台市',
  '榆树市':'榆樹市',
  '德惠市':'德惠市',
  '农安县':'農安縣',
  '吉林市':'吉林市',
  '船营区':'船營區',
  '昌邑区':'昌邑區',
  '龙潭区':'龍潭區',
  '丰满区':'豐滿區',
  '舒兰市':'舒蘭市',
  '桦甸市':'樺甸市',
  '蛟河市':'蛟河市',
  '磐石市':'磐石市',
  '永吉县':'永吉縣',
  '屯门区':'屯門區',
  '河北区':'河北區',
  '双辽市':'雙遼市',
  '梨树县':'梨樹縣',
  '张家口':'張家口',
  '辽源市':'遼源市',
  '龙山区':'龍山區',
  '西安区':'西安區',
  '东辽县':'東遼縣',
  '东丰县':'東豐縣',
  '通化市':'通化市',
  '东昌区':'東昌區',
  '宣化区':'宣化區',
  '红桥区':'紅橋區',
  '集安市':'集安市',
  '通化县':'通化縣',
  '辉南县':'輝南縣',
  '柳河县':'柳河縣',
  '白山市':'白山市',
  '宣化县':'宣化縣',
  '江源区':'江源區',
  '临江市':'臨江市',
  '靖宇县':'靖宇縣',
  '抚松县':'撫松縣',
  '张北县':'張北縣',
  '松原市':'松原市',
  '宁江区':'寧江區',
  '乾安县':'乾安縣',
  '长岭县':'長嶺縣',
  '扶余县':'扶餘縣',
  '康保县':'康保縣',
  '白城市':'白城市',
  '洮北区':'洮北區',
  '大安市':'大安市',
  '洮南市':'洮南市',
  '镇赉县':'鎮賚縣',
  '通榆县':'通榆縣',
  '沽源县':'沽源縣',
  '延吉市':'延吉市',
  '图们市':'圖們市',
  '敦化市':'敦化市',
  '龙井市':'龍井市',
  '珲春市':'琿春市',
  '和龙市':'和龍市',
  '安图县':'安圖縣',
  '汪清县':'汪清縣',
  '尚义县':'尚義縣',
  '塘沽区':'塘沽區',
  '松北区':'松北區',
  '道里区':'道里區',
  '南岗区':'南崗區',
  '平房区':'平房區',
  '香坊区':'香坊區',
  '道外区':'道外區',
  '呼兰区':'呼蘭區',
  '阿城区':'阿城區',
  '双城市':'雙城市',
  '尚志市':'尚志市',
  '五常市':'五常市',
  '元朗区':'元朗區',
  '方正县':'方正縣',
  '通河县':'通河縣',
  '巴彦县':'巴彥縣',
  '延寿县':'延壽縣',
  '木兰县':'木蘭縣',
  '依兰县':'依蘭縣',
  '阳原县':'陽原縣',
  '龙沙区':'龍沙區',
  '怀安县':'懷安縣',
  '铁锋区':'鐵鋒區',
  '建华区':'建華區',
  '万全县':'萬全縣',
  '怀来县':'懷來縣',
  '涿鹿县':'涿鹿縣',
  '讷河市':'訥河市',
  '富裕县':'富裕縣',
  '拜泉县':'拜泉縣',
  '甘南县':'甘南縣',
  '依安县':'依安縣',
  '克山县':'克山縣',
  '泰来县':'泰來縣',
  '克东县':'克東縣',
  '龙江县':'龍江縣',
  '鹤岗市':'鶴崗市',
  '兴山区':'興山區',
  '工农区':'工農區',
  '南山区':'南山區',
  '兴安区':'興安區',
  '向阳区':'向陽區',
  '东山区':'東山區',
  '萝北县':'蘿北縣',
  '绥滨县':'綏濱縣',
  '双鸭山':'雙鴨山',
  '尖山区':'尖山區',
  '岭东区':'嶺東區',
  '赤城县':'赤城縣',
  '宝山区':'寶山區',
  '集贤县':'集賢縣',
  '宝清县':'寶清縣',
  '友谊县':'友誼縣',
  '饶河县':'饒河縣',
  '鸡西市':'雞西市',
  '鸡冠区':'雞冠區',
  '恒山区':'恆山區',
  '崇礼县':'崇禮縣',
  '滴道区':'滴道區',
  '梨树区':'梨樹區',
  '麻山区':'麻山區',
  '密山市':'密山市',
  '虎林市':'虎林市',
  '鸡东县':'雞東縣',
  '大庆市':'大慶市',
  '承德市':'承德市',
  '红岗区':'紅崗區',
  '龙凤区':'龍鳳區',
  '双桥区':'雙橋區',
  '大同区':'大同區',
  '林甸县':'林甸縣',
  '肇州县':'肇州縣',
  '肇源县':'肇源縣',
  '双滦区':'雙灤區',
  '伊春市':'伊春市',
  '伊春区':'伊春區',
  '带岭区':'帶嶺區',
  '南岔区':'南岔區',
  '汉沽区':'漢沽區',
  '西林区':'西林區',
  '美溪区':'美溪區',
  '承德县':'承德縣',
  '翠峦区':'翠巒區',
  '友好区':'友好區',
  '兴隆县':'興隆縣',
  '五营区':'五營區',
  '红星区':'紅星區',
  '新青区':'新青區',
  '平泉县':'平泉縣',
  '滦平县':'灤平縣',
  '铁力市':'鐵力市',
  '嘉荫县':'嘉蔭縣',
  '隆化县':'隆化縣',
  '爱民区':'愛民區',
  '东安区':'東安區',
  '阳明区':'陽明區',
  '大港区':'大港區',
  '宁安市':'寧安市',
  '海林市':'海林市',
  '穆棱市':'穆棱市',
  '林口县':'林口縣',
  '东宁县':'東寧縣',
  '东丽区':'東麗區',
  '前进区':'前進區',
  '东风区':'東風區',
  '西贡区':'西貢區',
  '同江市':'同江市',
  '富锦市':'富錦市',
  '桦川县':'樺川縣',
  '抚远县':'撫遠縣',
  '桦南县':'樺南縣',
  '汤原县':'湯原縣',
  '西青区':'西青區',
  '桃山区':'桃山區',
  '新兴区':'新興區',
  '沧州市':'滄州市',
  '勃利县':'勃利縣',
  '黑河市':'黑河市',
  '爱辉区':'愛輝區',
  '北安市':'北安市',
  '运河区':'運河區',
  '逊克县':'遜克縣',
  '嫩江县':'嫩江縣',
  '孙吴县':'孫吳縣',
  '绥化市':'綏化市',
  '北林区':'北林區',
  '安达市':'安達市',
  '肇东市':'肇東市',
  '海伦市':'海倫市',
  '绥棱县':'綏棱縣',
  '兰西县':'蘭西縣',
  '明水县':'明水縣',
  '青冈县':'青岡縣',
  '庆安县':'慶安縣',
  '望奎县':'望奎縣',
  '津南区':'津南區',
  '呼玛县':'呼瑪縣',
  '塔河县':'塔河縣',
  '漠河县':'漠河縣',
  '北辰区':'北辰區',
  '上海市':'上海市',
  '黄浦区':'黃浦區',
  '卢湾区':'盧灣區',
  '徐汇区':'徐匯區',
  '长宁区':'長寧區',
  '静安区':'靜安區',
  '普陀区':'普陀區',
  '闸北区':'閘北區',
  '虹口区':'虹口區',
  '杨浦区':'楊浦區',
  '闵行区':'閔行區',
  '嘉定区':'嘉定區',
  '松江区':'松江區',
  '金山区':'金山區',
  '青浦区':'青浦區',
  '南汇区':'南匯區',
  '奉贤区':'奉賢區',
  '东光县':'東光縣',
  '崇明县':'崇明縣',
  '江苏省':'江蘇省',
  '南京市':'南京市',
  '玄武区':'玄武區',
  '白下区':'白下區',
  '秦淮区':'秦淮區',
  '建邺区':'建鄴區',
  '鼓楼区':'鼓樓區',
  '下关区':'下關區',
  '栖霞区':'棲霞區',
  '海兴县':'海興縣',
  '浦口区':'浦口區',
  '江宁区':'江寧區',
  '六合区':'六合區',
  '溧水县':'溧水縣',
  '高淳县':'高淳縣',
  '苏州市':'蘇州市',
  '金阊区':'金閶區',
  '平江区':'平江區',
  '沧浪区':'滄浪區',
  '虎丘区':'虎丘區',
  '吴中区':'吳中區',
  '相城区':'相城區',
  '常熟市':'常熟市',
  '盐山县':'鹽山縣',
  '昆山市':'昆山市',
  '吴江市':'吳江市',
  '太仓市':'太倉市',
  '无锡市':'無錫市',
  '崇安区':'崇安區',
  '南长区':'南長區',
  '北塘区':'北塘區',
  '滨湖区':'濱湖區',
  '锡山区':'錫山區',
  '惠山区':'惠山區',
  '江阴市':'江陰市',
  '宜兴市':'宜興市',
  '常州市':'常州市',
  '钟楼区':'鐘樓區',
  '天宁区':'天寧區',
  '肃宁县':'肅寧縣',
  '新北区':'新北區',
  '武进区':'武進區',
  '金坛市':'金壇市',
  '溧阳市':'溧陽市',
  '镇江市':'鎮江市',
  '京口区':'京口區',
  '润州区':'潤州區',
  '丹徒区':'丹徒區',
  '丹阳市':'丹陽市',
  '扬中市':'揚中市',
  '句容市':'句容市',
  '南通市':'南通市',
  '崇川区':'崇川區',
  '港闸区':'港閘區',
  '通州市':'通州市',
  '如皋市':'如皋市',
  '海门市':'海門市',
  '启东市':'啟東市',
  '海安县':'海安縣',
  '如东县':'如東縣',
  '泰州市':'泰州市',
  '海陵区':'海陵區',
  '高港区':'高港區',
  '姜堰市':'薑堰市',
  '泰兴市':'泰興市',
  '靖江市':'靖江市',
  '兴化市':'興化市',
  '扬州市':'揚州市',
  '广陵区':'廣陵區',
  '维扬区':'維揚區',
  '邗江区':'邗江區',
  '江都市':'江都市',
  '仪征市':'儀徵市',
  '高邮市':'高郵市',
  '宝应县':'寶應縣',
  '盐城市':'鹽城市',
  '亭湖区':'亭湖區',
  '盐都区':'鹽都區',
  '大丰市':'大豐市',
  '东台市':'東台市',
  '建湖县':'建湖縣',
  '射阳县':'射陽縣',
  '阜宁县':'阜寧縣',
  '滨海县':'濱海縣',
  '响水县':'響水縣',
  '南皮县':'南皮縣',
  '新浦区':'新浦區',
  '连云区':'連雲區',
  '东海县':'東海縣',
  '灌云县':'灌雲縣',
  '赣榆县':'贛榆縣',
  '灌南县':'灌南縣',
  '徐州市':'徐州市',
  '云龙区':'雲龍區',
  '九里区':'九里區',
  '泉山区':'泉山區',
  '贾汪区':'賈汪區',
  '邳州市':'邳州市',
  '新沂市':'新沂市',
  '铜山县':'銅山縣',
  '睢宁县':'睢寧縣',
  '沙田区':'沙田區',
  '大埔区':'大埔區',
  '淮安市':'淮安市',
  '清浦区':'清浦區',
  '楚州区':'楚州區',
  '淮阴区':'淮陰區',
  '涟水县':'漣水縣',
  '洪泽县':'洪澤縣',
  '金湖县':'金湖縣',
  '盱眙县':'盱眙縣',
  '宿迁市':'宿遷市',
  '宿城区':'宿城區',
  '宿豫区':'宿豫區',
  '沭阳县':'沭陽縣',
  '泗阳县':'泗陽縣',
  '泗洪县':'泗洪縣',
  '浙江省':'浙江省',
  '杭州市':'杭州市',
  '拱墅区':'拱墅區',
  '西湖区':'西湖區',
  '上城区':'上城區',
  '下城区':'下城區',
  '江干区':'江乾區',
  '滨江区':'濱江區',
  '余杭区':'餘杭區',
  '萧山区':'蕭山區',
  '建德市':'建德市',
  '富阳市':'富陽市',
  '临安市':'臨安市',
  '桐庐县':'桐廬縣',
  '淳安县':'淳安縣',
  '宁波市':'寧波市',
  '海曙区':'海曙區',
  '江东区':'江東區',
  '江北区':'江北區',
  '镇海区':'鎮海區',
  '北仑区':'北侖區',
  '鄞州区':'鄞州區',
  '余姚市':'餘姚市',
  '慈溪市':'慈溪市',
  '奉化市':'奉化市',
  '宁海县':'寧海縣',
  '象山县':'象山縣',
  '温州市':'溫州市',
  '鹿城区':'鹿城區',
  '龙湾区':'龍灣區',
  '瓯海区':'甌海區',
  '瑞安市':'瑞安市',
  '乐清市':'樂清市',
  '永嘉县':'永嘉縣',
  '洞头县':'洞頭縣',
  '平阳县':'平陽縣',
  '苍南县':'蒼南縣',
  '文成县':'文成縣',
  '泰顺县':'泰順縣',
  '嘉兴市':'嘉興市',
  '秀城区':'秀城區',
  '秀洲区':'秀洲區',
  '海宁市':'海寧市',
  '平湖市':'平湖市',
  '桐乡市':'桐鄉市',
  '嘉善县':'嘉善縣',
  '海盐县':'海鹽縣',
  '湖州市':'湖州市',
  '吴兴区':'吳興區',
  '南浔区':'南潯區',
  '长兴县':'長興縣',
  '德清县':'德清縣',
  '安吉县':'安吉縣',
  '绍兴市':'紹興市',
  '越城区':'越城區',
  '诸暨市':'諸暨市',
  '上虞市':'上虞市',
  '嵊州市':'嵊州市',
  '绍兴县':'紹興縣',
  '新昌县':'新昌縣',
  '金华市':'金華市',
  '婺城区':'婺城區',
  '金东区':'金東區',
  '兰溪市':'蘭溪市',
  '义乌市':'義烏市',
  '东阳市':'東陽市',
  '永康市':'永康市',
  '武义县':'武義縣',
  '浦江县':'浦江縣',
  '磐安县':'磐安縣',
  '衢州市':'衢州市',
  '柯城区':'柯城區',
  '衢江区':'衢江區',
  '江山市':'江山市',
  '龙游县':'龍游縣',
  '常山县':'常山縣',
  '开化县':'開化縣',
  '舟山市':'舟山市',
  '定海区':'定海區',
  '岱山县':'岱山縣',
  '嵊泗县':'嵊泗縣',
  '台州市':'台州市',
  '椒江区':'椒江區',
  '黄岩区':'黃岩區',
  '路桥区':'路橋區',
  '临海市':'臨海市',
  '温岭市':'溫嶺市',
  '玉环县':'玉環縣',
  '天台县':'天台縣',
  '仙居县':'仙居縣',
  '三门县':'三門縣',
  '丽水市':'麗水市',
  '莲都区':'蓮都區',
  '龙泉市':'龍泉市',
  '缙云县':'縉雲縣',
  '青田县':'青田縣',
  '云和县':'雲和縣',
  '遂昌县':'遂昌縣',
  '松阳县':'松陽縣',
  '庆元县':'慶元縣',
  '吴桥县':'吳橋縣',
  '安徽省':'安徽省',
  '合肥市':'合肥市',
  '庐阳区':'廬陽區',
  '瑶海区':'瑤海區',
  '蜀山区':'蜀山區',
  '包河区':'包河區',
  '长丰县':'長豐縣',
  '肥东县':'肥東縣',
  '肥西县':'肥西縣',
  '芜湖市':'蕪湖市',
  '镜湖区':'鏡湖區',
  '弋江区':'弋江區',
  '鸠江区':'鳩江區',
  '三山区':'三山區',
  '芜湖县':'蕪湖縣',
  '南陵县':'南陵縣',
  '繁昌县':'繁昌縣',
  '蚌埠市':'蚌埠市',
  '蚌山区':'蚌山區',
  '武清区':'武清區',
  '禹会区':'禹會區',
  '淮上区':'淮上區',
  '怀远县':'懷遠縣',
  '固镇县':'固鎮縣',
  '五河县':'五河縣',
  '淮南市':'淮南市',
  '宝坻区':'寶坻區',
  '大通区':'大通區',
  '泊头市':'泊頭市',
  '任丘市':'任丘市',
  '潘集区':'潘集區',
  '凤台县':'鳳台縣',
  '黄骅市':'黃驊市',
  '雨山区':'雨山區',
  '花山区':'花山區',
  '河间市':'河間市',
  '当涂县':'當塗縣',
  '淮北市':'淮北市',
  '相山区':'相山區',
  '杜集区':'杜集區',
  '烈山区':'烈山區',
  '濉溪县':'濉溪縣',
  '铜陵市':'銅陵市',
  '廊坊市':'廊坊市',
  '安次区':'安次區',
  '铜陵县':'銅陵縣',
  '安庆市':'安慶市',
  '迎江区':'迎江區',
  '大观区':'大觀區',
  '宜秀区':'宜秀區',
  '桐城市':'桐城市',
  '宿松县':'宿松縣',
  '枞阳县':'樅陽縣',
  '太湖县':'太湖縣',
  '怀宁县':'懷寧縣',
  '岳西县':'岳西縣',
  '望江县':'望江縣',
  '潜山县':'潛山縣',
  '黄山市':'黃山市',
  '屯溪区':'屯溪區',
  '黄山区':'黃山區',
  '徽州区':'徽州區',
  '休宁县':'休寧縣',
  '观塘区':'觀塘區',
  '祁门县':'祁門縣',
  '固安县':'固安縣',
  '滁州市':'滁州市',
  '琅琊区':'琅琊區',
  '南谯区':'南譙區',
  '天长市':'天長市',
  '明光市':'明光市',
  '全椒县':'全椒縣',
  '来安县':'來安縣',
  '定远县':'定遠縣',
  '凤阳县':'鳳陽縣',
  '阜阳市':'阜陽市',
  '颍州区':'潁州區',
  '颍东区':'潁東區',
  '颍泉区':'潁泉區',
  '界首市':'界首市',
  '临泉县':'臨泉縣',
  '颍上县':'潁上縣',
  '阜南县':'阜南縣',
  '太和县':'太和縣',
  '宿州市':'宿州市',
  '埇桥区':'埇橋區',
  '永清县':'永清縣',
  '香河县':'香河縣',
  '砀山县':'碭山縣',
  '灵璧县':'靈璧縣',
  '巢湖市':'巢湖市',
  '居巢区':'居巢區',
  '含山县':'含山縣',
  '无为县':'無為縣',
  '庐江县':'廬江縣',
  '大城县':'大城縣',
  '六安市':'六安市',
  '金安区':'金安區',
  '裕安区':'裕安區',
  '文安县':'文安縣',
  '霍山县':'霍山縣',
  '霍邱县':'霍邱縣',
  '舒城县':'舒城縣',
  '金寨县':'金寨縣',
  '亳州市':'亳州市',
  '谯城区':'譙城區',
  '利辛县':'利辛縣',
  '涡阳县':'渦陽縣',
  '蒙城县':'蒙城縣',
  '池州市':'池州市',
  '贵池区':'貴池區',
  '东至县':'東至縣',
  '石台县':'石台縣',
  '青阳县':'青陽縣',
  '宣城市':'宣城市',
  '宣州区':'宣州區',
  '宁国市':'寧國市',
  '广德县':'廣德縣',
  '郎溪县':'郎溪縣',
  '宁河县':'寧河縣',
  '旌德县':'旌德縣',
  '绩溪县':'績溪縣',
  '福建省':'福建省',
  '福州市':'福州市',
  '台江区':'台江區',
  '仓山区':'倉山區',
  '马尾区':'馬尾區',
  '晋安区':'晉安區',
  '福清市':'福清市',
  '长乐市':'長樂市',
  '闽侯县':'閩侯縣',
  '闽清县':'閩清縣',
  '永泰县':'永泰縣',
  '连江县':'連江縣',
  '罗源县':'羅源縣',
  '平潭县':'平潭縣',
  '厦门市':'廈門市',
  '思明区':'思明區',
  '海沧区':'海滄區',
  '湖里区':'湖裡區',
  '集美区':'集美區',
  '同安区':'同安區',
  '翔安区':'翔安區',
  '莆田市':'莆田市',
  '城厢区':'城廂區',
  '涵江区':'涵江區',
  '荔城区':'荔城區',
  '秀屿区':'秀嶼區',
  '仙游县':'仙游縣',
  '三明市':'三明市',
  '梅列区':'梅列區',
  '三元区':'三元區',
  '永安市':'永安市',
  '明溪县':'明溪縣',
  '将乐县':'將樂縣',
  '大田县':'大田縣',
  '宁化县':'寧化縣',
  '建宁县':'建寧縣',
  '霸州市':'霸州市',
  '尤溪县':'尤溪縣',
  '清流县':'清流縣',
  '泰宁县':'泰寧縣',
  '泉州市':'泉州市',
  '鲤城区':'鯉城區',
  '丰泽区':'豐澤區',
  '洛江区':'洛江區',
  '泉港区':'泉港區',
  '石狮市':'石獅市',
  '晋江市':'晉江市',
  '南安市':'南安市',
  '惠安县':'惠安縣',
  '永春县':'永春縣',
  '安溪县':'安溪縣',
  '德化县':'德化縣',
  '金门县':'金門縣',
  '漳州市':'漳州市',
  '芗城区':'薌城區',
  '龙文区':'龍文區',
  '龙海市':'龍海市',
  '平和县':'平和縣',
  '南靖县':'南靖縣',
  '诏安县':'詔安縣',
  '漳浦县':'漳浦縣',
  '华安县':'華安縣',
  '东山县':'東山縣',
  '长泰县':'長泰縣',
  '云霄县':'雲霄縣',
  '南平市':'南平市',
  '延平区':'延平區',
  '建瓯市':'建甌市',
  '邵武市':'邵武市',
  '三河市':'三河市',
  '建阳市':'建陽市',
  '松溪县':'松溪縣',
  '光泽县':'光澤縣',
  '顺昌县':'順昌縣',
  '浦城县':'浦城縣',
  '政和县':'政和縣',
  '龙岩市':'龍岩市',
  '新罗区':'新羅區',
  '漳平市':'漳平市',
  '长汀县':'長汀縣',
  '武平县':'武平縣',
  '上杭县':'上杭縣',
  '永定县':'永定縣',
  '连城县':'連城縣',
  '宁德市':'寧德市',
  '蕉城区':'蕉城區',
  '福安市':'福安市',
  '福鼎市':'福鼎市',
  '寿宁县':'壽寧縣',
  '霞浦县':'霞浦縣',
  '柘荣县':'柘榮縣',
  '屏南县':'屏南縣',
  '古田县':'古田縣',
  '周宁县':'周寧縣',
  '江西省':'江西省',
  '南昌市':'南昌市',
  '东湖区':'東湖區',
  '衡水市':'衡水市',
  '湾里区':'灣里區',
  '东城区':'東城區',
  '新建县':'新建縣',
  '南昌县':'南昌縣',
  '进贤县':'進賢縣',
  '安义县':'安義縣',
  '枣强县':'棗強縣',
  '珠山区':'珠山區',
  '昌江区':'昌江區',
  '乐平市':'樂平市',
  '浮梁县':'浮梁縣',
  '萍乡市':'萍鄉市',
  '安源区':'安源區',
  '湘东区':'湘東區',
  '莲花县':'蓮花縣',
  '上栗县':'上慄縣',
  '芦溪县':'蘆溪縣',
  '九江市':'九江市',
  '浔阳区':'潯陽區',
  '庐山区':'廬山區',
  '瑞昌市':'瑞昌市',
  '九江县':'九江縣',
  '星子县':'星子縣',
  '武宁县':'武寧縣',
  '彭泽县':'彭澤縣',
  '永修县':'永修縣',
  '修水县':'修水縣',
  '湖口县':'湖口縣',
  '德安县':'德安縣',
  '都昌县':'都昌縣',
  '新余市':'新餘市',
  '渝水区':'渝水區',
  '分宜县':'分宜縣',
  '鹰潭市':'鷹潭市',
  '月湖区':'月湖區',
  '贵溪市':'貴溪市',
  '余江县':'餘江縣',
  '赣州市':'贛州市',
  '章贡区':'章貢區',
  '瑞金市':'瑞金市',
  '南康市':'南康市',
  '石城县':'石城縣',
  '安远县':'安遠縣',
  '武邑县':'武邑縣',
  '宁都县':'寧都縣',
  '寻乌县':'尋烏縣',
  '兴国县':'興國縣',
  '定南县':'定南縣',
  '上犹县':'上猶縣',
  '于都县':'於都縣',
  '龙南县':'龍南縣',
  '崇义县':'崇義縣',
  '信丰县':'信豐縣',
  '全南县':'全南縣',
  '大余县':'大餘縣',
  '会昌县':'會昌縣',
  '吉安市':'吉安市',
  '吉州区':'吉州區',
  '青原区':'青原區',
  '武强县':'武強縣',
  '吉安县':'吉安縣',
  '永丰县':'永豐縣',
  '永新县':'永新縣',
  '新干县':'新乾縣',
  '泰和县':'泰和縣',
  '峡江县':'峽江縣',
  '遂川县':'遂川縣',
  '安福县':'安福縣',
  '吉水县':'吉水縣',
  '万安县':'萬安縣',
  '宜春市':'宜春市',
  '袁州区':'袁州區',
  '丰城市':'豐城市',
  '樟树市':'樟樹市',
  '高安市':'高安市',
  '铜鼓县':'銅鼓縣',
  '靖安县':'靖安縣',
  '宜丰县':'宜豐縣',
  '奉新县':'奉新縣',
  '万载县':'萬載縣',
  '上高县':'上高縣',
  '抚州市':'撫州市',
  '临川区':'臨川區',
  '南丰县':'南豐縣',
  '乐安县':'樂安縣',
  '金溪县':'金溪縣',
  '南城县':'南城縣',
  '东乡县':'東鄉縣',
  '资溪县':'資溪縣',
  '宜黄县':'宜黃縣',
  '广昌县':'廣昌縣',
  '黎川县':'黎川縣',
  '崇仁县':'崇仁縣',
  '上饶市':'上饒市',
  '信州区':'信州區',
  '德兴市':'德興市',
  '上饶县':'上饒縣',
  '广丰县':'廣豐縣',
  '鄱阳县':'鄱陽縣',
  '婺源县':'婺源縣',
  '铅山县':'鉛山縣',
  '余干县':'餘乾縣',
  '横峰县':'橫峰縣',
  '弋阳县':'弋陽縣',
  '玉山县':'玉山縣',
  '万年县':'萬年縣',
  '山东省':'山東省',
  '济南市':'濟南市',
  '市中区':'市中區',
  '历下区':'歷下區',
  '天桥区':'天橋區',
  '槐荫区':'槐蔭區',
  '历城区':'歷城區',
  '长清区':'長清區',
  '章丘市':'章丘市',
  '平阴县':'平陰縣',
  '济阳县':'濟陽縣',
  '商河县':'商河縣',
  '青岛市':'青島市',
  '市南区':'市南區',
  '市北区':'市北區',
  '城阳区':'城陽區',
  '四方区':'四方區',
  '李沧区':'李滄區',
  '黄岛区':'黃島區',
  '崂山区':'嶗山區',
  '胶南市':'膠南市',
  '胶州市':'膠州市',
  '平度市':'平度市',
  '莱西市':'萊西市',
  '即墨市':'即墨市',
  '淄博市':'淄博市',
  '张店区':'張店區',
  '临淄区':'臨淄區',
  '淄川区':'淄川區',
  '博山区':'博山區',
  '周村区':'周村區',
  '桓台县':'桓台縣',
  '高青县':'高青縣',
  '沂源县':'沂源縣',
  '枣庄市':'棗莊市',
  '山亭区':'山亭區',
  '峄城区':'嶧城區',
  '饶阳县':'饒陽縣',
  '薛城区':'薛城區',
  '滕州市':'滕州市',
  '东营市':'東營市',
  '东营区':'東營區',
  '河口区':'河口區',
  '垦利县':'墾利縣',
  '广饶县':'廣饒縣',
  '利津县':'利津縣',
  '烟台市':'煙臺市',
  '芝罘区':'芝罘區',
  '福山区':'福山區',
  '牟平区':'牟平區',
  '莱山区':'萊山區',
  '龙口市':'龍口市',
  '莱阳市':'萊陽市',
  '莱州市':'萊州市',
  '招远市':'招遠市',
  '蓬莱市':'蓬萊市',
  '栖霞市':'棲霞市',
  '海阳市':'海陽市',
  '长岛县':'長島縣',
  '潍坊市':'濰坊市',
  '潍城区':'濰城區',
  '寒亭区':'寒亭區',
  '坊子区':'坊子區',
  '奎文区':'奎文區',
  '青州市':'青州市',
  '诸城市':'諸城市',
  '寿光市':'壽光市',
  '安丘市':'安丘市',
  '高密市':'高密市',
  '昌邑市':'昌邑市',
  '昌乐县':'昌樂縣',
  '临朐县':'臨朐縣',
  '济宁市':'濟寧市',
  '任城区':'任城區',
  '曲阜市':'曲阜市',
  '兖州市':'兗州市',
  '邹城市':'鄒城市',
  '鱼台县':'魚台縣',
  '金乡县':'金鄉縣',
  '嘉祥县':'嘉祥縣',
  '微山县':'微山縣',
  '汶上县':'汶上縣',
  '泗水县':'泗水縣',
  '梁山县':'梁山縣',
  '泰安市':'泰安市',
  '泰山区':'泰山區',
  '岱岳区':'岱岳區',
  '新泰市':'新泰市',
  '肥城市':'肥城市',
  '宁阳县':'寧陽縣',
  '东平县':'東平縣',
  '威海市':'威海市',
  '环翠区':'環翠區',
  '乳山市':'乳山市',
  '文登市':'文登市',
  '荣成市':'榮成市',
  '日照市':'日照市',
  '东港区':'東港區',
  '岚山区':'嵐山區',
  '五莲县':'五蓮縣',
  '大堂区':'大堂區',
  '莱芜市':'萊蕪市',
  '莱城区':'萊城區',
  '钢城区':'鋼城區',
  '临沂市':'臨沂市',
  '兰山区':'蘭山區',
  '罗庄区':'羅莊區',
  '沂南县':'沂南縣',
  '郯城县':'郯城縣',
  '沂水县':'沂水縣',
  '苍山县':'蒼山縣',
  '安平县':'安平縣',
  '平邑县':'平邑縣',
  '莒南县':'莒南縣',
  '蒙阴县':'蒙陰縣',
  '临沭县':'臨沭縣',
  '德州市':'德州市',
  '德城区':'德城區',
  '乐陵市':'樂陵市',
  '禹城市':'禹城市',
  '故城县':'故城縣',
  '宁津县':'寧津縣',
  '齐河县':'齊河縣',
  '武城县':'武城縣',
  '庆云县':'慶雲縣',
  '平原县':'平原縣',
  '夏津县':'夏津縣',
  '临邑县':'臨邑縣',
  '聊城市':'聊城市',
  '静海县':'靜海縣',
  '临清市':'臨清市',
  '高唐县':'高唐縣',
  '阳谷县':'陽谷縣',
  '茌平县':'茌平縣',
  '高雄市':'高雄市',
  '东阿县':'東阿縣',
  '台南市':'臺南市',
  '滨州市':'濱州市',
  '滨城区':'濱城區',
  '邹平县':'鄒平縣',
  '沾化县':'沾化縣',
  '惠民县':'惠民縣',
  '博兴县':'博興縣',
  '阳信县':'陽信縣',
  '无棣县':'無棣縣',
  '菏泽市':'菏澤市',
  '牡丹区':'牡丹區',
  '鄄城县':'鄄城縣',
  '台中市':'臺中市',
  '郓城县':'鄆城縣',
  '桃园市':'桃園市',
  '定陶县':'定陶縣',
  '巨野县':'巨野縣',
  '东明县':'東明縣',
  '成武县':'成武縣',
  '河南省':'河南省',
  '郑州市':'鄭州市',
  '中原区':'中原區',
  '金水区':'金水區',
  '二七区':'二七區',
  '阜城县':'阜城縣',
  '上街区':'上街區',
  '惠济区':'惠濟區',
  '巩义市':'鞏義市',
  '新郑市':'新鄭市',
  '新密市':'新密市',
  '登封市':'登封市',
  '荥阳市':'滎陽市',
  '中牟县':'中牟縣',
  '开封市':'開封市',
  '龙亭区':'龍亭區',
  '冀州市':'冀州市',
  '深州市':'深州市',
  '金明区':'金明區',
  '开封县':'開封縣',
  '尉氏县':'尉氏縣',
  '兰考县':'蘭考縣',
  '新店区':'新店區',
  '通许县':'通許縣',
  '洛阳市':'洛陽市',
  '西工区':'西工區',
  '老城区':'老城區',
  '涧西区':'澗西區',
  '山西省':'山西省',
  '洛龙区':'洛龍區',
  '吉利区':'吉利區',
  '偃师市':'偃師市',
  '孟津县':'孟津縣',
  '汝阳县':'汝陽縣',
  '伊川县':'伊川縣',
  '洛宁县':'洛寧縣',
  '汐止区':'汐止區',
  '宜阳县':'宜陽縣',
  '新安县':'新安縣',
  '栾川县':'欒川縣',
  '太原市':'太原市',
  '卫东区':'衛東區',
  '湛河区':'湛河區',
  '石龙区':'石龍區',
  '汝州市':'汝州市',
  '舞钢市':'舞鋼市',
  '宝丰县':'寶豐縣',
  '板桥区':'板橋區',
  '新北市':'新北市',
  '鲁山县':'魯山縣',
  '安阳市':'安陽市',
  '北关区':'北關區',
  '文峰区':'文峰區',
  '殷都区':'殷都區',
  '龙安区':'龍安區',
  '林州市':'林州市',
  '安阳县':'安陽縣',
  '北投区':'北投區',
  '内黄县':'內黃縣',
  '汤阴县':'湯陰縣',
  '鹤壁市':'鶴壁市',
  '淇滨区':'淇濱區',
  '山城区':'山城區',
  '鹤山区':'鶴山區',
  '士林区':'士林區',
  '文山区':'文山區',
  '新乡市':'新鄉市',
  '卫滨区':'衛濱區',
  '红旗区':'紅旗區',
  '凤泉区':'鳳泉區',
  '牧野区':'牧野區',
  '卫辉市':'衛輝市',
  '辉县市':'輝縣市',
  '新乡县':'新鄉縣',
  '获嘉县':'獲嘉縣',
  '原阳县':'原陽縣',
  '长垣县':'長垣縣',
  '封丘县':'封丘縣',
  '延津县':'延津縣',
  '焦作市':'焦作市',
  '解放区':'解放區',
  '中站区':'中站區',
  '马村区':'馬村區',
  '山阳区':'山陽區',
  '沁阳市':'沁陽市',
  '孟州市':'孟州市',
  '修武县':'修武縣',
  '信义区':'信義區',
  '武陟县':'武陟縣',
  '博爱县':'博愛縣',
  '濮阳市':'濮陽市',
  '华龙区':'華龍區',
  '濮阳县':'濮陽縣',
  '南乐县':'南樂縣',
  '台前县':'台前縣',
  '清丰县':'清豐縣',
  '万华区':'萬華區',
  '许昌市':'許昌市',
  '魏都区':'魏都區',
  '禹州市':'禹州市',
  '长葛市':'長葛市',
  '许昌县':'許昌縣',
  '鄢陵县':'鄢陵縣',
  '襄城县':'襄城縣',
  '漯河市':'漯河市',
  '源汇区':'源匯區',
  '郾城区':'郾城區',
  '召陵区':'召陵區',
  '临颍县':'臨潁縣',
  '舞阳县':'舞陽縣',
  '小店区':'小店區',
  '湖滨区':'湖濱區',
  '义马市':'義馬市',
  '灵宝市':'靈寶市',
  '渑池县':'澠池縣',
  '卢氏县':'盧氏縣',
  '中正区':'中正區',
  '南阳市':'南陽市',
  '卧龙区':'卧龍區',
  '宛城区':'宛城區',
  '邓州市':'鄧州市',
  '桐柏县':'桐柏縣',
  '方城县':'方城縣',
  '淅川县':'淅川縣',
  '镇平县':'鎮平縣',
  '唐河县':'唐河縣',
  '南召县':'南召縣',
  '内乡县':'內鄉縣',
  '新野县':'新野縣',
  '社旗县':'社旗縣',
  '西峡县':'西峽縣',
  '商丘市':'商丘市',
  '梁园区':'梁園區',
  '睢阳区':'睢陽區',
  '永城市':'永城市',
  '宁陵县':'寧陵縣',
  '虞城县':'虞城縣',
  '民权县':'民權縣',
  '夏邑县':'夏邑縣',
  '柘城县':'柘城縣',
  '南港区':'南港區',
  '信阳市':'信陽市',
  '浉河区':'浉河區',
  '平桥区':'平橋區',
  '潢川县':'潢川縣',
  '淮滨县':'淮濱縣',
  '内湖区':'內湖區',
  '台北市':'臺北市',
  '商城县':'商城縣',
  '固始县':'固始縣',
  '罗山县':'羅山縣',
  '光山县':'光山縣',
  '周口市':'周口市',
  '川汇区':'川匯區',
  '项城市':'項城市',
  '商水县':'商水縣',
  '淮阳县':'淮陽縣',
  '太康县':'太康縣',
  '鹿邑县':'鹿邑縣',
  '西华县':'西華縣',
  '扶沟县':'扶溝縣',
  '沈丘县':'沈丘縣',
  '郸城县':'鄲城縣',
  '迎泽区':'迎澤區',
  '驿城区':'驛城區',
  '确山县':'確山縣',
  '新蔡县':'新蔡縣',
  '上蔡县':'上蔡縣',
  '西平县':'西平縣',
  '泌阳县':'泌陽縣',
  '平舆县':'平輿縣',
  '汝南县':'汝南縣',
  '遂平县':'遂平縣',
  '正阳县':'正陽縣',
  '济源市':'濟源市',
  '湖北省':'湖北省',
  '武汉市':'武漢市',
  '江岸区':'江岸區',
  '武昌区':'武昌區',
  '江汉区':'江漢區',
  '硚口区':'硚口區',
  '汉阳区':'漢陽區',
  '洪山区':'洪山區',
  '崇文区':'崇文區',
  '汉南区':'漢南區',
  '蔡甸区':'蔡甸區',
  '江夏区':'江夏區',
  '黄陂区':'黃陂區',
  '新洲区':'新洲區',
  '黄石市':'黃石市',
  '河北省':'河北省',
  '宣武区':'宣武區',
  '下陆区':'下陸區',
  '铁山区':'鐵山區',
  '大冶市':'大冶市',
  '阳新县':'陽新縣',
  '十堰市':'十堰市',
  '张湾区':'張灣區',
  '茅箭区':'茅箭區',
  '晋源区':'晉源區',
  '台湾省':'臺灣省',
  '竹山县':'竹山縣',
  '清徐县':'清徐縣',
  '郧西县':'鄖西縣',
  '竹溪县':'竹溪縣',
  '荆州市':'荊州市',
  '沙市区':'沙市區',
  '荆州区':'荊州區',
  '洪湖市':'洪湖市',
  '石首市':'石首市',
  '松滋市':'松滋市',
  '监利县':'監利縣',
  '公安县':'公安縣',
  '江陵县':'江陵縣',
  '宜昌市':'宜昌市',
  '西陵区':'西陵區',
  '阳曲县':'陽曲縣',
  '点军区':'點軍區',
  '猇亭区':'猇亭區',
  '夷陵区':'夷陵區',
  '宜都市':'宜都市',
  '当阳市':'當陽市',
  '枝江市':'枝江市',
  '秭归县':'秭歸縣',
  '远安县':'遠安縣',
  '兴山县':'興山縣',
  '娄烦县':'婁煩縣',
  '古交市':'古交市',
  '襄樊市':'襄樊市',
  '襄城区':'襄城區',
  '樊城区':'樊城區',
  '襄阳区':'襄陽區',
  '大同市':'大同市',
  '枣阳市':'棗陽市',
  '宜城市':'宜城市',
  '南漳县':'南漳縣',
  '谷城县':'谷城縣',
  '保康县':'保康縣',
  '鄂州市':'鄂州市',
  '鄂城区':'鄂城區',
  '华容区':'華容區',
  '长安区':'長安區',
  '荆门市':'荊門市',
  '东宝区':'東寶區',
  '掇刀区':'掇刀區',
  '钟祥市':'鐘祥市',
  '京山县':'京山縣',
  '沙洋县':'沙洋縣',
  '孝感市':'孝感市',
  '孝南区':'孝南區',
  '应城市':'應城市',
  '安陆市':'安陸市',
  '汉川市':'漢川市',
  '云梦县':'雲夢縣',
  '大悟县':'大悟縣',
  '孝昌县':'孝昌縣',
  '黄冈市':'黃岡市',
  '黄州区':'黃州區',
  '麻城市':'麻城市',
  '武穴市':'武穴市',
  '红安县':'紅安縣',
  '罗田县':'羅田縣',
  '浠水县':'浠水縣',
  '蕲春县':'蘄春縣',
  '黄梅县':'黃梅縣',
  '英山县':'英山縣',
  '团风县':'團風縣',
  '咸宁市':'咸寧市',
  '咸安区':'咸安區',
  '赤壁市':'赤壁市',
  '嘉鱼县':'嘉魚縣',
  '通山县':'通山縣',
  '崇阳县':'崇陽縣',
  '通城县':'通城縣',
  '随州市':'隨州市',
  '曾都区':'曾都區',
  '广水市':'廣水市',
  '桥东区':'橋東區',
  '恩施市':'恩施市',
  '利川市':'利川市',
  '建始县':'建始縣',
  '来凤县':'來鳳縣',
  '巴东县':'巴東縣',
  '鹤峰县':'鶴峰縣',
  '宣恩县':'宣恩縣',
  '咸丰县':'咸豐縣',
  '仙桃市':'仙桃市',
  '南郊区':'南郊區',
  '天门市':'天門市',
  '新荣区':'新榮區',
  '潜江市':'潛江市',
  '巩留县':'鞏留縣',
  '阳高县':'陽高縣',
  '湖南省':'湖南省',
  '长沙市':'長沙市',
  '岳麓区':'岳麓區',
  '芙蓉区':'芙蓉區',
  '天心区':'天心區',
  '开福区':'開福區',
  '雨花区':'雨花區',
  '浏阳市':'瀏陽市',
  '长沙县':'長沙縣',
  '望城县':'望城縣',
  '宁乡县':'寧鄉縣',
  '株洲市':'株洲市',
  '天元区':'天元區',
  '荷塘区':'荷塘區',
  '芦淞区':'蘆淞區',
  '石峰区':'石峰區',
  '醴陵市':'醴陵市',
  '株洲县':'株洲縣',
  '炎陵县':'炎陵縣',
  '茶陵县':'茶陵縣',
  '霍城县':'霍城縣',
  '湘潭市':'湘潭市',
  '岳塘区':'岳塘區',
  '雨湖区':'雨湖區',
  '湘乡市':'湘鄉市',
  '韶山市':'韶山市',
  '湘潭县':'湘潭縣',
  '衡阳市':'衡陽市',
  '雁峰区':'雁峰區',
  '珠晖区':'珠暉區',
  '石鼓区':'石鼓區',
  '蒸湘区':'蒸湘區',
  '南岳区':'南嶽區',
  '耒阳市':'耒陽市',
  '常宁市':'常寧市',
  '衡阳县':'衡陽縣',
  '衡东县':'衡東縣',
  '衡山县':'衡山縣',
  '衡南县':'衡南縣',
  '祁东县':'祁東縣',
  '邵阳市':'邵陽市',
  '双清区':'雙清區',
  '大祥区':'大祥區',
  '北塔区':'北塔區',
  '武冈市':'武岡市',
  '邵东县':'邵東縣',
  '洞口县':'洞口縣',
  '新邵县':'新邵縣',
  '绥宁县':'綏寧縣',
  '新宁县':'新寧縣',
  '邵阳县':'邵陽縣',
  '隆回县':'隆回縣',
  '天镇县':'天鎮縣',
  '岳阳市':'岳陽市',
  '广灵县':'廣靈縣',
  '云溪区':'雲溪區',
  '君山区':'君山區',
  '临湘市':'臨湘市',
  '汨罗市':'汨羅市',
  '岳阳县':'岳陽縣',
  '湘阴县':'湘陰縣',
  '平江县':'平江縣',
  '华容县':'華容縣',
  '常德市':'常德市',
  '武陵区':'武陵區',
  '鼎城区':'鼎城區',
  '津市市':'津市市',
  '新源县':'新源縣',
  '临澧县':'臨澧縣',
  '桃源县':'桃源縣',
  '汉寿县':'漢壽縣',
  '安乡县':'安鄉縣',
  '石门县':'石門縣',
  '灵丘县':'靈丘縣',
  '永定区':'永定區',
  '浑源县':'渾源縣',
  '慈利县':'慈利縣',
  '桑植县':'桑植縣',
  '益阳市':'益陽市',
  '赫山区':'赫山區',
  '资阳区':'資陽區',
  '沅江市':'沅江市',
  '桃江县':'桃江縣',
  '昭苏县':'昭蘇縣',
  '安化县':'安化縣',
  '郴州市':'郴州市',
  '北湖区':'北湖區',
  '苏仙区':'蘇仙區',
  '资兴市':'資興市',
  '宜章县':'宜章縣',
  '汝城县':'汝城縣',
  '安仁县':'安仁縣',
  '嘉禾县':'嘉禾縣',
  '临武县':'臨武縣',
  '桂东县':'桂東縣',
  '永兴县':'永興縣',
  '桂阳县':'桂陽縣',
  '永州市':'永州市',
  '左云县':'左雲縣',
  '零陵区':'零陵區',
  '祁阳县':'祁陽縣',
  '蓝山县':'藍山縣',
  '宁远县':'寧遠縣',
  '新田县':'新田縣',
  '东安县':'東安縣',
  '江永县':'江永縣',
  '大同县':'大同縣',
  '双牌县':'雙牌縣',
  '阳泉市':'陽泉市',
  '怀化市':'懷化市',
  '鹤城区':'鶴城區',
  '洪江市':'洪江市',
  '会同县':'會同縣',
  '沅陵县':'沅陵縣',
  '辰溪县':'辰溪縣',
  '溆浦县':'漵浦縣',
  '中方县':'中方縣',
  '平定县':'平定縣',
  '桥西区':'橋西區',
  '长治市':'長治市',
  '长治县':'長治縣',
  '襄垣县':'襄垣縣',
  '娄底市':'婁底市',
  '娄星区':'婁星區',
  '屯留县':'屯留縣',
  '涟源市':'漣源市',
  '新化县':'新化縣',
  '双峰县':'雙峰縣',
  '平顺县':'平順縣',
  '吉首市':'吉首市',
  '古丈县':'古丈縣',
  '龙山县':'龍山縣',
  '永顺县':'永順縣',
  '凤凰县':'鳳凰縣',
  '泸溪县':'瀘溪縣',
  '保靖县':'保靖縣',
  '花垣县':'花垣縣',
  '广东省':'廣東省',
  '广州市':'廣州市',
  '越秀区':'越秀區',
  '荔湾区':'荔灣區',
  '海珠区':'海珠區',
  '天河区':'天河區',
  '白云区':'白雲區',
  '黄埔区':'黃埔區',
  '番禺区':'番禺區',
  '花都区':'花都區',
  '南沙区':'南沙區',
  '萝岗区':'蘿崗區',
  '增城市':'增城市',
  '从化市':'從化市',
  '深圳市':'深圳市',
  '福田区':'福田區',
  '罗湖区':'羅湖區',
  '宝安区':'寶安區',
  '龙岗区':'龍崗區',
  '盐田区':'鹽田區',
  '东莞市':'東莞市',
  '黎城县':'黎城縣',
  '伊宁县':'伊寧縣',
  '奎屯市':'奎屯市',
  '中山市':'中山市',
  '伊宁市':'伊寧市',
  '潮州市':'潮州市',
  '湘桥区':'湘橋區',
  '潮安县':'潮安縣',
  '饶平县':'饒平縣',
  '揭阳市':'揭陽市',
  '榕城区':'榕城區',
  '揭东县':'揭東縣',
  '揭西县':'揭西縣',
  '惠来县':'惠來縣',
  '普宁市':'普寧市',
  '云浮市':'雲浮市',
  '云城区':'雲城區',
  '新兴县':'新興縣',
  '郁南县':'鬱南縣',
  '云安县':'雲安縣',
  '罗定市':'羅定市',
  '珠海市':'珠海市',
  '香洲区':'香洲區',
  '斗门区':'斗門區',
  '金湾区':'金灣區',
  '汕头市':'汕頭市',
  '金平区':'金平區',
  '濠江区':'濠江區',
  '龙湖区':'龍湖區',
  '潮阳区':'潮陽區',
  '潮南区':'潮南區',
  '澄海区':'澄海區',
  '南澳县':'南澳縣',
  '韶关市':'韶關市',
  '浈江区':'湞江區',
  '武江区':'武江區',
  '曲江区':'曲江區',
  '乐昌市':'樂昌市',
  '南雄市':'南雄市',
  '始兴县':'始興縣',
  '仁化县':'仁化縣',
  '翁源县':'翁源縣',
  '新丰县':'新豐縣',
  '壶关县':'壺關縣',
  '佛山市':'佛山市',
  '禅城区':'禪城區',
  '南海区':'南海區',
  '顺德区':'順德區',
  '三水区':'三水區',
  '高明区':'高明區',
  '江门市':'江門市',
  '蓬江区':'蓬江區',
  '江海区':'江海區',
  '新会区':'新會區',
  '恩平市':'恩平市',
  '台山市':'台山市',
  '开平市':'開平市',
  '鹤山市':'鶴山市',
  '湛江市':'湛江市',
  '赤坎区':'赤坎區',
  '霞山区':'霞山區',
  '坡头区':'坡頭區',
  '麻章区':'麻章區',
  '吴川市':'吳川市',
  '廉江市':'廉江市',
  '雷州市':'雷州市',
  '遂溪县':'遂溪縣',
  '徐闻县':'徐聞縣',
  '茂名市':'茂名市',
  '茂南区':'茂南區',
  '茂港区':'茂港區',
  '化州市':'化州市',
  '信宜市':'信宜市',
  '高州市':'高州市',
  '电白县':'電白縣',
  '肇庆市':'肇慶市',
  '端州区':'端州區',
  '鼎湖区':'鼎湖區',
  '高要市':'高要市',
  '四会市':'四會市',
  '广宁县':'廣寧縣',
  '怀集县':'懷集縣',
  '封开县':'封開縣',
  '德庆县':'德慶縣',
  '惠州市':'惠州市',
  '惠城区':'惠城區',
  '惠阳区':'惠陽區',
  '博罗县':'博羅縣',
  '惠东县':'惠東縣',
  '龙门县':'龍門縣',
  '梅州市':'梅州市',
  '梅江区':'梅江區',
  '兴宁市':'興寧市',
  '长子县':'長子縣',
  '大埔县':'大埔縣',
  '丰顺县':'豐順縣',
  '五华县':'五華縣',
  '平远县':'平遠縣',
  '蕉岭县':'蕉嶺縣',
  '汕尾市':'汕尾市',
  '五家渠':'五家渠',
  '陆丰市':'陸豐市',
  '海丰县':'海豐縣',
  '陆河县':'陸河縣',
  '河源市':'河源市',
  '源城区':'源城區',
  '紫金县':'紫金縣',
  '龙川县':'龍川縣',
  '连平县':'連平縣',
  '和平县':'和平縣',
  '东源县':'東源縣',
  '阳江市':'陽江市',
  '江城区':'江城區',
  '阳春市':'陽春市',
  '阳西县':'陽西縣',
  '阳东县':'陽東縣',
  '清远市':'清遠市',
  '清城区':'清城區',
  '英德市':'英德市',
  '连州市':'連州市',
  '佛冈县':'佛岡縣',
  '阳山县':'陽山縣',
  '清新县':'清新縣',
  '武乡县':'武鄉縣',
  '新华区':'新華區',
  '沁源县':'沁源縣',
  '南宁市':'南寧市',
  '青秀区':'青秀區',
  '兴宁区':'興寧區',
  '潞城市':'潞城市',
  '良庆区':'良慶區',
  '江南区':'江南區',
  '邕宁区':'邕寧區',
  '武鸣县':'武鳴縣',
  '隆安县':'隆安縣',
  '马山县':'馬山縣',
  '上林县':'上林縣',
  '宾阳县':'賓陽縣',
  '阿拉尔':'阿拉爾',
  '柳州市':'柳州市',
  '城中区':'城中區',
  '鱼峰区':'魚峰區',
  '柳北区':'柳北區',
  '柳南区':'柳南區',
  '柳江县':'柳江縣',
  '柳城县':'柳城縣',
  '鹿寨县':'鹿寨縣',
  '融安县':'融安縣',
  '晋城市':'晉城市',
  '沁水县':'沁水縣',
  '桂林市':'桂林市',
  '象山区':'象山區',
  '秀峰区':'秀峰區',
  '叠彩区':'疊彩區',
  '七星区':'七星區',
  '雁山区':'雁山區',
  '阳朔县':'陽朔縣',
  '临桂县':'臨桂縣',
  '灵川县':'靈川縣',
  '全州县':'全州縣',
  '平乐县':'平樂縣',
  '兴安县':'興安縣',
  '灌阳县':'灌陽縣',
  '荔浦县':'荔浦縣',
  '资源县':'資源縣',
  '永福县':'永福縣',
  '阳城县':'陽城縣',
  '陵川县':'陵川縣',
  '梧州市':'梧州市',
  '万秀区':'萬秀區',
  '蝶山区':'蝶山區',
  '长洲区':'長洲區',
  '岑溪市':'岑溪市',
  '苍梧县':'蒼梧縣',
  '石河子':'石河子',
  '蒙山县':'蒙山縣',
  '北海市':'北海市',
  '海城区':'海城區',
  '银海区':'銀海區',
  '泽州县':'澤州縣',
  '合浦县':'合浦縣',
  '高平市':'高平市',
  '港口区':'港口區',
  '防城区':'防城區',
  '东兴市':'東興市',
  '上思县':'上思縣',
  '钦州市':'欽州市',
  '钦南区':'欽南區',
  '钦北区':'欽北區',
  '灵山县':'靈山縣',
  '浦北县':'浦北縣',
  '贵港市':'貴港市',
  '港北区':'港北區',
  '港南区':'港南區',
  '覃塘区':'覃塘區',
  '桂平市':'桂平市',
  '平南县':'平南縣',
  '玉林市':'玉林市',
  '玉州区':'玉州區',
  '北流市':'北流市',
  '温泉县':'溫泉縣',
  '陆川县':'陸川縣',
  '博白县':'博白縣',
  '兴业县':'興業縣',
  '百色市':'百色市',
  '右江区':'右江區',
  '凌云县':'凌雲縣',
  '平果县':'平果縣',
  '西林县':'西林縣',
  '乐业县':'樂業縣',
  '德保县':'德保縣',
  '田林县':'田林縣',
  '田阳县':'田陽縣',
  '靖西县':'靖西縣',
  '田东县':'田東縣',
  '那坡县':'那坡縣',
  '朔州市':'朔州市',
  '贺州市':'賀州市',
  '八步区':'八步區',
  '钟山县':'鐘山縣',
  '昭平县':'昭平縣',
  '朔城区':'朔城區',
  '河池市':'河池市',
  '平鲁区':'平魯區',
  '宜州市':'宜州市',
  '天峨县':'天峨縣',
  '凤山县':'鳳山縣',
  '南丹县':'南丹縣',
  '东兰县':'東蘭縣',
  '山阴县':'山陰縣',
  '朝阳区':'朝陽區',
  '右玉县':'右玉縣',
  '怀仁县':'懷仁縣',
  '忻州市':'忻州市',
  '来宾市':'來賓市',
  '兴宾区':'興賓區',
  '合山市':'合山市',
  '象州县':'象州縣',
  '武宣县':'武宣縣',
  '忻城县':'忻城縣',
  '忻府区':'忻府區',
  '崇左市':'崇左市',
  '江州区':'江州區',
  '凭祥市':'憑祥市',
  '宁明县':'寧明縣',
  '扶绥县':'扶綏縣',
  '龙州县':'龍州縣',
  '大新县':'大新縣',
  '天等县':'天等縣',
  '海南省':'海南省',
  '海口市':'海口市',
  '龙华区':'龍華區',
  '秀英区':'秀英區',
  '琼山区':'瓊山區',
  '美兰区':'美蘭區',
  '三亚市':'三亞市',
  '原平市':'原平市',
  '五指山':'五指山',
  '琼海市':'瓊海市',
  '精河县':'精河縣',
  '儋州市':'儋州市',
  '博乐市':'博樂市',
  '文昌市':'文昌市',
  '定襄县':'定襄縣',
  '万宁市':'萬寧市',
  '米泉市':'米泉市',
  '东方市':'東方市',
  '五台县':'五台縣',
  '澄迈县':'澄邁縣',
  '定安县':'定安縣',
  '屯昌县':'屯昌縣',
  '临高县':'臨高縣',
  '丰台区':'丰台區',
  '繁峙县':'繁峙縣',
  '宁武县':'寧武縣',
  '静乐县':'靜樂縣',
  '神池县':'神池縣',
  '五寨县':'五寨縣',
  '重庆市':'重慶市',
  '渝中区':'渝中區',
  '岢岚县':'岢嵐縣',
  '南岸区':'南岸區',
  '北碚区':'北碚區',
  '渝北区':'渝北區',
  '巴南区':'巴南區',
  '长寿区':'長壽區',
  '河曲县':'河曲縣',
  '万盛区':'萬盛區',
  '万州区':'萬州區',
  '涪陵区':'涪陵區',
  '黔江区':'黔江區',
  '永川区':'永川區',
  '合川区':'合川區',
  '江津区':'江津區',
  '保德县':'保德縣',
  '南川区':'南川區',
  '綦江县':'綦江縣',
  '潼南县':'潼南縣',
  '荣昌县':'榮昌縣',
  '璧山县':'璧山縣',
  '大足县':'大足縣',
  '铜梁县':'銅梁縣',
  '梁平县':'梁平縣',
  '偏关县':'偏關縣',
  '吕梁市':'呂梁市',
  '城口县':'城口縣',
  '垫江县':'墊江縣',
  '武隆县':'武隆縣',
  '丰都县':'豐都縣',
  '奉节县':'奉節縣',
  '云阳县':'雲陽縣',
  '巫溪县':'巫溪縣',
  '巫山县':'巫山縣',
  '离石区':'離石區',
  '孝义市':'孝義市',
  '汾阳市':'汾陽市',
  '文水县':'文水縣',
  '四川省':'四川省',
  '成都市':'成都市',
  '青羊区':'青羊區',
  '锦江区':'錦江區',
  '金牛区':'金牛區',
  '武侯区':'武侯區',
  '成华区':'成華區',
  '交城县':'交城縣',
  '井陉县':'井陘縣',
  '新都区':'新都區',
  '温江区':'溫江區',
  '正定县':'正定縣',
  '彭州市':'彭州市',
  '邛崃市':'邛崍市',
  '崇州市':'崇州市',
  '金堂县':'金堂縣',
  '柳林县':'柳林縣',
  '新津县':'新津縣',
  '双流县':'雙流縣',
  '蒲江县':'蒲江縣',
  '大邑县':'大邑縣',
  '自贡市':'自貢市',
  '大安区':'大安區',
  '石楼县':'石樓縣',
  '贡井区':'貢井區',
  '沿滩区':'沿灘區',
  '奇台县':'奇台縣',
  '富顺县':'富順縣',
  '栾城县':'欒城縣',
  '仁和区':'仁和區',
  '米易县':'米易縣',
  '盐边县':'鹽邊縣',
  '阜康市':'阜康市',
  '昌吉市':'昌吉市',
  '泸州市':'瀘州市',
  '江阳区':'江陽區',
  '纳溪区':'納溪區',
  '方山县':'方山縣',
  '中阳县':'中陽縣',
  '合江县':'合江縣',
  '叙永县':'敘永縣',
  '古蔺县':'古藺縣',
  '德阳市':'德陽市',
  '旌阳区':'旌陽區',
  '广汉市':'廣漢市',
  '什邡市':'什邡市',
  '绵竹市':'綿竹市',
  '罗江县':'羅江縣',
  '中江县':'中江縣',
  '绵阳市':'綿陽市',
  '涪城区':'涪城區',
  '游仙区':'游仙區',
  '江油市':'江油市',
  '盐亭县':'鹽亭縣',
  '三台县':'三台縣',
  '平武县':'平武縣',
  '交口县':'交口縣',
  '梓潼县':'梓潼縣',
  '晋中市':'晉中市',
  '广元市':'廣元市',
  '元坝区':'元壩區',
  '朝天区':'朝天區',
  '青川县':'青川縣',
  '旺苍县':'旺蒼縣',
  '剑阁县':'劍閣縣',
  '苍溪县':'蒼溪縣',
  '遂宁市':'遂寧市',
  '船山区':'船山區',
  '安居区':'安居區',
  '射洪县':'射洪縣',
  '蓬溪县':'蓬溪縣',
  '大英县':'大英縣',
  '内江市':'內江市',
  '东兴区':'東興區',
  '资中县':'資中縣',
  '隆昌县':'隆昌縣',
  '威远县':'威遠縣',
  '乐山市':'樂山市',
  '榆次市':'榆次市',
  '沙湾区':'沙灣區',
  '介休市':'介休市',
  '榆社县':'榆社縣',
  '夹江县':'夾江縣',
  '井研县':'井研縣',
  '犍为县':'犍為縣',
  '沐川县':'沐川縣',
  '左权县':'左權縣',
  '和顺县':'和順縣',
  '若羌县':'若羌縣',
  '顺庆区':'順慶區',
  '高坪区':'高坪區',
  '嘉陵区':'嘉陵區',
  '阆中市':'閬中市',
  '营山县':'營山縣',
  '蓬安县':'蓬安縣',
  '仪陇县':'儀隴縣',
  '南部县':'南部縣',
  '西充县':'西充縣',
  '眉山市':'眉山市',
  '东坡区':'東坡區',
  '仁寿县':'仁壽縣',
  '彭山县':'彭山縣',
  '洪雅县':'洪雅縣',
  '丹棱县':'丹棱縣',
  '青神县':'青神縣',
  '宜宾市':'宜賓市',
  '翠屏区':'翠屏區',
  '宜宾县':'宜賓縣',
  '兴文县':'興文縣',
  '南溪县':'南溪縣',
  '轮台县':'輪台縣',
  '长宁县':'長寧縣',
  '博湖县':'博湖縣',
  '江安县':'江安縣',
  '筠连县':'筠連縣',
  '屏山县':'屏山縣',
  '广安市':'廣安市',
  '广安区':'廣安區',
  '华蓥市':'華鎣市',
  '岳池县':'岳池縣',
  '邻水县':'鄰水縣',
  '武胜县':'武勝縣',
  '达州市':'達州市',
  '通川区':'通川區',
  '万源市':'萬源市',
  '且末县':'且末縣',
  '和硕县':'和碩縣',
  '宣汉县':'宣漢縣',
  '开江县':'開江縣',
  '大竹县':'大竹縣',
  '雅安市':'雅安市',
  '雨城区':'雨城區',
  '芦山县':'蘆山縣',
  '石棉县':'石棉縣',
  '名山县':'名山縣',
  '天全县':'天全縣',
  '荥经县':'滎經縣',
  '宝兴县':'寶興縣',
  '汉源县':'漢源縣',
  '巴中市':'巴中市',
  '巴州区':'巴州區',
  '南江县':'南江縣',
  '平昌县':'平昌縣',
  '通江县':'通江縣',
  '资阳市':'資陽市',
  '雁江区':'雁江區',
  '简阳市':'簡陽市',
  '安岳县':'安岳縣',
  '乐至县':'樂至縣',
  '昔阳县':'昔陽縣',
  '寿阳县':'壽陽縣',
  '太谷县':'太谷縣',
  '红原县':'紅原縣',
  '汶川县':'汶川縣',
  '阿坝县':'阿壩縣',
  '尉犁县':'尉犁縣',
  '行唐县':'行唐縣',
  '小金县':'小金縣',
  '黑水县':'黑水縣',
  '金川县':'金川縣',
  '松潘县':'松潘縣',
  '壤塘县':'壤塘縣',
  '和静县':'和靜縣',
  '平遥县':'平遙縣',
  '康定县':'康定縣',
  '丹巴县':'丹巴縣',
  '炉霍县':'爐霍縣',
  '九龙县':'九龍縣',
  '甘孜县':'甘孜縣',
  '雅江县':'雅江縣',
  '新龙县':'新龍縣',
  '道孚县':'道孚縣',
  '白玉县':'白玉縣',
  '理塘县':'理塘縣',
  '德格县':'德格縣',
  '乡城县':'鄉城縣',
  '石渠县':'石渠縣',
  '稻城县':'稻城縣',
  '色达县':'色達縣',
  '巴塘县':'巴塘縣',
  '泸定县':'瀘定縣',
  '得荣县':'得榮縣',
  '灵石县':'靈石縣',
  '西昌市':'西昌市',
  '美姑县':'美姑縣',
  '昭觉县':'昭覺縣',
  '金阳县':'金陽縣',
  '甘洛县':'甘洛縣',
  '布拖县':'布拖縣',
  '雷波县':'雷波縣',
  '普格县':'普格縣',
  '宁南县':'寧南縣',
  '喜德县':'喜德縣',
  '会东县':'會東縣',
  '越西县':'越西縣',
  '会理县':'會理縣',
  '盐源县':'鹽源縣',
  '德昌县':'德昌縣',
  '冕宁县':'冕寧縣',
  '临汾市':'臨汾市',
  '贵州省':'貴州省',
  '贵阳市':'貴陽市',
  '南明区':'南明區',
  '云岩区':'雲岩區',
  '花溪区':'花溪區',
  '乌当区':'烏當區',
  '小河区':'小河區',
  '清镇市':'清鎮市',
  '开阳县':'開陽縣',
  '修文县':'修文縣',
  '息烽县':'息烽縣',
  '侯马市':'侯馬市',
  '钟山区':'鐘山區',
  '水城县':'水城縣',
  '霍州市':'霍州市',
  '曲沃县':'曲沃縣',
  '遵义市':'遵義市',
  '翼城县':'翼城縣',
  '汇川区':'匯川區',
  '赤水市':'赤水市',
  '仁怀市':'仁懷市',
  '遵义县':'遵義縣',
  '绥阳县':'綏陽縣',
  '桐梓县':'桐梓縣',
  '习水县':'習水縣',
  '凤冈县':'鳳岡縣',
  '正安县':'正安縣',
  '余庆县':'餘慶縣',
  '湄潭县':'湄潭縣',
  '襄汾县':'襄汾縣',
  '洪洞县':'洪洞縣',
  '安顺市':'安順市',
  '西秀区':'西秀區',
  '普定县':'普定縣',
  '平坝县':'平壩縣',
  '灵寿县':'靈壽縣',
  '安泽县':'安澤縣',
  '浮山县':'浮山縣',
  '高邑县':'高邑縣',
  '铜仁市':'銅仁市',
  '德江县':'德江縣',
  '江口县':'江口縣',
  '思南县':'思南縣',
  '石阡县':'石阡縣',
  '乡宁县':'鄉寧縣',
  '深泽县':'深澤縣',
  '大宁县':'大寧縣',
  '永和县':'永和縣',
  '赞皇县':'贊皇縣',
  '汾西县':'汾西縣',
  '毕节市':'畢節市',
  '黔西县':'黔西縣',
  '大方县':'大方縣',
  '织金县':'織金縣',
  '金沙县':'金沙縣',
  '赫章县':'赫章縣',
  '纳雍县':'納雍縣',
  '运城市':'運城市',
  '永济市':'永濟市',
  '兴义市':'興義市',
  '望谟县':'望謨縣',
  '兴仁县':'興仁縣',
  '普安县':'普安縣',
  '册亨县':'冊亨縣',
  '晴隆县':'晴隆縣',
  '贞丰县':'貞豐縣',
  '安龙县':'安龍縣',
  '河津市':'河津市',
  '凯里市':'凱里市',
  '施秉县':'施秉縣',
  '从江县':'從江縣',
  '锦屏县':'錦屏縣',
  '镇远县':'鎮遠縣',
  '麻江县':'麻江縣',
  '台江县':'台江縣',
  '天柱县':'天柱縣',
  '黄平县':'黃平縣',
  '榕江县':'榕江縣',
  '剑河县':'劍河縣',
  '三穗县':'三穗縣',
  '雷山县':'雷山縣',
  '黎平县':'黎平縣',
  '岑巩县':'岑鞏縣',
  '丹寨县':'丹寨縣',
  '芮城县':'芮城縣',
  '都匀市':'都勻市',
  '福泉市':'福泉市',
  '贵定县':'貴定縣',
  '惠水县':'惠水縣',
  '罗甸县':'羅甸縣',
  '瓮安县':'瓮安縣',
  '荔波县':'荔波縣',
  '龙里县':'龍里縣',
  '平塘县':'平塘縣',
  '长顺县':'長順縣',
  '独山县':'獨山縣',
  '临猗县':'臨猗縣',
  '云南省':'雲南省',
  '昆明市':'昆明市',
  '盘龙区':'盤龍區',
  '五华区':'五華區',
  '官渡区':'官渡區',
  '西山区':'西山區',
  '东川区':'東川區',
  '安宁市':'安寧市',
  '呈贡县':'呈貢縣',
  '晋宁县':'晉寧縣',
  '富民县':'富民縣',
  '宜良县':'宜良縣',
  '嵩明县':'嵩明縣',
  '万荣县':'萬榮縣',
  '新绛县':'新絳縣',
  '稷山县':'稷山縣',
  '曲靖市':'曲靖市',
  '麒麟区':'麒麟區',
  '宣威市':'宣威市',
  '马龙县':'馬龍縣',
  '沾益县':'沾益縣',
  '富源县':'富源縣',
  '罗平县':'羅平縣',
  '师宗县':'師宗縣',
  '陆良县':'陸良縣',
  '会泽县':'會澤縣',
  '玉溪市':'玉溪市',
  '红塔区':'紅塔區',
  '江川县':'江川縣',
  '澄江县':'澄江縣',
  '通海县':'通海縣',
  '华宁县':'華寧縣',
  '易门县':'易門縣',
  '闻喜县':'聞喜縣',
  '无极县':'無極縣',
  '平山县':'平山縣',
  '保山市':'保山市',
  '隆阳区':'隆陽區',
  '施甸县':'施甸縣',
  '腾冲县':'騰衝縣',
  '龙陵县':'龍陵縣',
  '昌宁县':'昌寧縣',
  '昭通市':'昭通市',
  '昭阳区':'昭陽區',
  '鲁甸县':'魯甸縣',
  '巧家县':'巧家縣',
  '盐津县':'鹽津縣',
  '大关县':'大關縣',
  '永善县':'永善縣',
  '绥江县':'綏江縣',
  '镇雄县':'鎮雄縣',
  '彝良县':'彞良縣',
  '威信县':'威信縣',
  '水富县':'水富縣',
  '丽江市':'麗江市',
  '古城区':'古城區',
  '永胜县':'永勝縣',
  '华坪县':'華坪縣',
  '平陆县':'平陸縣',
  '垣曲县':'垣曲縣',
  '普洱市':'普洱市',
  '思茅区':'思茅區',
  '内蒙古':'內蒙古',
  '元氏县':'元氏縣',
  '新城区':'新城區',
  '回民区':'回民區',
  '玉泉区':'玉泉區',
  '北京市':'北京市',
  '辛集市':'辛集市',
  '湾仔区':'灣仔區',
  '晋州市':'晉州市',
  '临沧市':'臨滄市',
  '临翔区':'臨翔區',
  '凤庆县':'鳳慶縣',
  '武川县':'武川縣',
  '永德县':'永德縣',
  '镇康县':'鎮康縣',
  '包头市':'包頭市',
  '东河区':'東河區',
  '新乐市':'新樂市',
  '青山区':'青山區',
  '潞西市':'潞西市',
  '瑞丽市':'瑞麗市',
  '梁河县':'梁河縣',
  '盈江县':'盈江縣',
  '陇川县':'隴川縣',
  '鹿泉市':'鹿泉市',
  '泸水县':'瀘水縣',
  '福贡县':'福貢縣',
  '唐山市':'唐山市',
  '路南区':'路南區',
  '固阳县':'固陽縣',
  '路北区':'路北區',
  '德钦县':'德欽縣',
  '乌海市':'烏海市',
  '古冶区':'古冶區',
  '大理市':'大理市',
  '祥云县':'祥雲縣',
  '宾川县':'賓川縣',
  '弥渡县':'彌渡縣',
  '永平县':'永平縣',
  '云龙县':'雲龍縣',
  '洱源县':'洱源縣',
  '剑川县':'劍川縣',
  '鹤庆县':'鶴慶縣',
  '海南区':'海南區',
  '乌达区':'烏達區',
  '赤峰市':'赤峰市',
  '红山区':'紅山區',
  '楚雄市':'楚雄市',
  '双柏县':'雙柏縣',
  '牟定县':'牟定縣',
  '南华县':'南華縣',
  '姚安县':'姚安縣',
  '大姚县':'大姚縣',
  '永仁县':'永仁縣',
  '元谋县':'元謀縣',
  '武定县':'武定縣',
  '禄丰县':'祿豐縣',
  '开平区':'開平區',
  '蒙自县':'蒙自縣',
  '个旧市':'個舊市',
  '开远市':'開遠市',
  '绿春县':'綠春縣',
  '建水县':'建水縣',
  '石屏县':'石屏縣',
  '弥勒县':'彌勒縣',
  '泸西县':'瀘西縣',
  '元阳县':'元陽縣',
  '红河县':'紅河縣',
  '松山区':'松山區',
  '海淀区':'海澱區',
  '丰润县':'豐潤縣',
  '西城区':'西城區',
  '文山县':'文山縣',
  '砚山县':'硯山縣',
  '西畴县':'西疇縣',
  '林西县':'林西縣',
  '马关县':'馬關縣',
  '丘北县':'丘北縣',
  '广南县':'廣南縣',
  '富宁县':'富寧縣',
  '滦南县':'灤南縣',
  '景洪市':'景洪市',
  '勐海县':'勐海縣',
  '勐腊县':'勐臘縣',
  '乐亭县':'樂亭縣',
  '拉萨市':'拉薩市',
  '城关区':'城關區',
  '林周县':'林周縣',
  '当雄县':'當雄縣',
  '尼木县':'尼木縣',
  '曲水县':'曲水縣',
  '迁西县':'遷西縣',
  '达孜县':'達孜縣',
  '宁城县':'寧城縣',
  '敖汉旗':'敖漢旗',
  '那曲县':'那曲縣',
  '嘉黎县':'嘉黎縣',
  '比如县':'比如縣',
  '聂荣县':'聶榮縣',
  '安多县':'安多縣',
  '申扎县':'申扎縣',
  '乌恰县':'烏恰縣',
  '班戈县':'班戈縣',
  '巴青县':'巴青縣',
  '尼玛县':'尼瑪縣',
  '玉田县':'玉田縣',
  '昌都县':'昌都縣',
  '江达县':'江達縣',
  '贡觉县':'貢覺縣',
  '唐海县':'唐海縣',
  '丁青县':'丁青縣',
  '察雅县':'察雅縣',
  '八宿县':'八宿縣',
  '左贡县':'左貢縣',
  '芒康县':'芒康縣',
  '洛隆县':'洛隆縣',
  '边坝县':'邊壩縣',
  '遵化市':'遵化市',
  '林芝县':'林芝縣',
  '丰南市':'丰南市',
  '米林县':'米林縣',
  '墨脱县':'墨脫縣',
  '波密县':'波密縣',
  '察隅县':'察隅縣',
  '迁安市':'遷安市',
  '根河市':'根河市',
  '乃东县':'乃東縣',
  '扎囊县':'扎囊縣',
  '贡嘎县':'貢嘎縣',
  '桑日县':'桑日縣',
  '琼结县':'瓊結縣',
  '曲松县':'曲松縣',
  '措美县':'措美縣',
  '洛扎县':'洛扎縣',
  '加查县':'加查縣',
  '隆子县':'隆子縣',
  '错那县':'錯那縣',
  '房山区':'房山區',
  '阿荣旗':'阿榮旗',
  '海港区':'海港區',
  '通州区':'通州區',
  '江孜县':'江孜縣',
  '定日县':'定日縣',
  '萨迦县':'薩迦縣',
  '拉孜县':'拉孜縣',
  '昂仁县':'昂仁縣',
  '顺义区':'順義區',
  '白朗县':'白朗縣',
  '仁布县':'仁布縣',
  '康马县':'康馬縣',
  '定结县':'定結縣',
  '仲巴县':'仲巴縣',
  '亚东县':'亞東縣',
  '吉隆县':'吉隆縣',
  '昌平区':'昌平區',
  '萨嘎县':'薩嘎縣',
  '岗巴县':'崗巴縣',
  '昌黎县':'昌黎縣',
  '噶尔县':'噶爾縣',
  '普兰县':'普蘭縣',
  '札达县':'札達縣',
  '日土县':'日土縣',
  '革吉县':'革吉縣',
  '改则县':'改則縣',
  '措勤县':'措勤縣',
  '陕西省':'陝西省',
  '西安市':'西安市',
  '莲湖区':'蓮湖區',
  '碑林区':'碑林區',
  '雁塔区':'雁塔區',
  '灞桥区':'灞橋區',
  '未央区':'未央區',
  '阎良区':'閻良區',
  '临潼区':'臨潼區',
  '高陵县':'高陵縣',
  '蓝田县':'藍田縣',
  '抚宁县':'撫寧縣',
  '周至县':'周至縣',
  '铜川市':'銅川市',
  '耀州区':'耀州區',
  '王益区':'王益區',
  '印台区':'印台區',
  '宜君县':'宜君縣',
  '宝鸡市':'寶雞市',
  '渭滨区':'渭濱區',
  '金台区':'金台區',
  '陈仓区':'陳倉區',
  '岐山县':'岐山縣',
  '凤翔县':'鳳翔縣',
  '兴安盟':'興安盟',
  '太白县':'太白縣',
  '麟游县':'麟游縣',
  '扶风县':'扶風縣',
  '千阳县':'千陽縣',
  '卢龙县':'盧龍縣',
  '疏附县':'疏附縣',
  '咸阳市':'咸陽市',
  '秦都区':'秦都區',
  '渭城区':'渭城區',
  '杨陵区':'楊陵區',
  '兴平市':'興平市',
  '礼泉县':'禮泉縣',
  '泾阳县':'涇陽縣',
  '永寿县':'永壽縣',
  '三原县':'三原縣',
  '莎车县':'莎車縣',
  '旬邑县':'旬邑縣',
  '长武县':'長武縣',
  '邯郸市':'邯鄲市',
  '武功县':'武功縣',
  '淳化县':'淳化縣',
  '渭南市':'渭南市',
  '临渭区':'臨渭區',
  '韩城市':'韓城市',
  '华阴市':'華陰市',
  '蒲城县':'蒲城縣',
  '潼关县':'潼關縣',
  '白水县':'白水縣',
  '澄城县':'澄城縣',
  '邯山区':'邯山區',
  '合阳县':'合陽縣',
  '富平县':'富平縣',
  '大荔县':'大荔縣',
  '延安市':'延安市',
  '宝塔区':'寶塔區',
  '安塞县':'安塞縣',
  '洛川县':'洛川縣',
  '子长县':'子長縣',
  '黄陵县':'黃陵縣',
  '延川县':'延川縣',
  '疏勒县':'疏勒縣',
  '延长县':'延長縣',
  '甘泉县':'甘泉縣',
  '宜川县':'宜川縣',
  '志丹县':'志丹縣',
  '黄龙县':'黃龍縣',
  '吴起县':'吳起縣',
  '汉中市':'漢中市',
  '汉台区':'漢台區',
  '留坝县':'留壩縣',
  '镇巴县':'鎮巴縣',
  '城固县':'城固縣',
  '南郑县':'南鄭縣',
  '丛台区':'叢台區',
  '宁强县':'寧強縣',
  '佛坪县':'佛坪縣',
  '叶城县':'葉城縣',
  '西乡县':'西鄉縣',
  '略阳县':'略陽縣',
  '榆林市':'榆林市',
  '榆阳区':'榆陽區',
  '清涧县':'清澗縣',
  '绥德县':'綏德縣',
  '神木县':'神木縣',
  '伽师县':'伽師縣',
  '府谷县':'府谷縣',
  '子洲县':'子洲縣',
  '靖边县':'靖邊縣',
  '横山县':'橫山縣',
  '米脂县':'米脂縣',
  '吴堡县':'吳堡縣',
  '定边县':'定邊縣',
  '安康市':'安康市',
  '汉滨区':'漢濱區',
  '紫阳县':'紫陽縣',
  '岚皋县':'嵐皋縣',
  '旬阳县':'旬陽縣',
  '镇坪县':'鎮坪縣',
  '平利县':'平利縣',
  '石泉县':'石泉縣',
  '宁陕县':'寧陝縣',
  '白河县':'白河縣',
  '汉阴县':'漢陰縣',
  '商洛市':'商洛市',
  '商州区':'商州區',
  '镇安县':'鎮安縣',
  '山阳县':'山陽縣',
  '洛南县':'洛南縣',
  '商南县':'商南縣',
  '丹凤县':'丹鳳縣',
  '柞水县':'柞水縣',
  '甘肃省':'甘肅省',
  '兰州市':'蘭州市',
  '复兴区':'復興區',
  '西固区':'西固區',
  '安宁区':'安寧區',
  '红古区':'紅古區',
  '永登县':'永登縣',
  '皋兰县':'皋蘭縣',
  '榆中县':'榆中縣',
  '突泉县':'突泉縣',
  '金昌市':'金昌市',
  '金川区':'金川區',
  '永昌县':'永昌縣',
  '白银市':'白銀市',
  '白银区':'白銀區',
  '平川区':'平川區',
  '靖远县':'靖遠縣',
  '会宁县':'會寧縣',
  '景泰县':'景泰縣',
  '天水市':'天水市',
  '清水县':'清水縣',
  '秦安县':'秦安縣',
  '甘谷县':'甘谷縣',
  '武山县':'武山縣',
  '通辽市':'通遼市',
  '北道区':'北道區',
  '秦城区':'秦城區',
  '武威市':'武威市',
  '凉州区':'涼州區',
  '民勤县':'民勤縣',
  '古浪县':'古浪縣',
  '大兴区':'大興區',
  '酒泉市':'酒泉市',
  '肃州区':'肅州區',
  '玉门市':'玉門市',
  '敦煌市':'敦煌市',
  '金塔县':'金塔縣',
  '邯郸县':'邯鄲縣',
  '临漳县':'臨漳縣',
  '安西县':'安西縣',
  '张掖市':'張掖市',
  '甘州区':'甘州區',
  '民乐县':'民樂縣',
  '临泽县':'臨澤縣',
  '高台县':'高臺縣',
  '山丹县':'山丹縣',
  '成安县':'成安縣',
  '庆阳市':'慶陽市',
  '西峰区':'西峰區',
  '庆城县':'慶城縣',
  '泽普县':'澤普縣',
  '华池县':'華池縣',
  '合水县':'合水縣',
  '正宁县':'正寧縣',
  '巴楚县':'巴楚縣',
  '镇原县':'鎮原縣',
  '平凉市':'平涼市',
  '崆峒区':'崆峒區',
  '泾川县':'涇川縣',
  '灵台县':'靈臺縣',
  '崇信县':'崇信縣',
  '华亭县':'華亭縣',
  '庄浪县':'莊浪縣',
  '静宁县':'靜寧縣',
  '定西市':'定西市',
  '安定区':'安定區',
  '通渭县':'通渭縣',
  '临洮县':'臨洮縣',
  '喀什市':'喀什市',
  '开鲁县':'開魯縣',
  '渭源县':'渭源縣',
  '陇西县':'隴西縣',
  '陇南市':'隴南市',
  '武都区':'武都區',
  '乌什县':'烏什縣',
  '宕昌县':'宕昌縣',
  '新和县':'新和縣',
  '柯坪县':'柯坪縣',
  '西和县':'西和縣',
  '库车县':'庫車縣',
  '两当县':'兩當縣',
  '库伦旗':'庫倫旗',
  '奈曼旗':'奈曼旗',
  '临夏市':'臨夏市',
  '临夏县':'臨夏縣',
  '康乐县':'康樂縣',
  '永靖县':'永靖縣',
  '广河县':'廣河縣',
  '和政县':'和政縣',
  '大名县':'大名縣',
  '平谷区':'平谷區',
  '怀柔区':'懷柔區',
  '合作市':'合作市',
  '临潭县':'臨潭縣',
  '卓尼县':'卓尼縣',
  '舟曲县':'舟曲縣',
  '迭部县':'迭部縣',
  '玛曲县':'瑪曲縣',
  '碌曲县':'碌曲縣',
  '夏河县':'夏河縣',
  '青海省':'青海省',
  '西宁市':'西寧市',
  '城东区':'城東區',
  '城西区':'城西區',
  '城北区':'城北區',
  '湟源县':'湟源縣',
  '湟中县':'湟中縣',
  '肥乡县':'肥鄉縣',
  '永年县':'永年縣',
  '平安县':'平安縣',
  '乐都县':'樂都縣',
  '密云县':'密雲縣',
  '鸡泽县':'雞澤縣',
  '广平县':'廣平縣',
  '馆陶县':'館陶縣',
  '延庆县':'延慶縣',
  '海晏县':'海晏縣',
  '祁连县':'祁連縣',
  '刚察县':'剛察縣',
  '镶黄旗':'鑲黃旗',
  '曲周县':'曲周縣',
  '共和县':'共和縣',
  '同德县':'同德縣',
  '贵德县':'貴德縣',
  '兴海县':'興海縣',
  '贵南县':'貴南縣',
  '正蓝旗':'正藍旗',
  '同仁县':'同仁縣',
  '尖扎县':'尖扎縣',
  '泽库县':'澤庫縣',
  '多伦县':'多倫縣',
  '武安市':'武安市',
  '玛沁县':'瑪沁縣',
  '班玛县':'班瑪縣',
  '甘德县':'甘德縣',
  '达日县':'達日縣',
  '久治县':'久治縣',
  '玛多县':'瑪多縣',
  '集宁市':'集寧市',
  '玉树县':'玉樹縣',
  '杂多县':'雜多縣',
  '称多县':'稱多縣',
  '治多县':'治多縣',
  '囊谦县':'囊謙縣',
  '丰镇市':'豐鎮市',
  '卓资县':'卓資縣',
  '化德县':'化德縣',
  '商都县':'商都縣',
  '乌兰县':'烏蘭縣',
  '都兰县':'都蘭縣',
  '天峻县':'天峻縣',
  '拜城县':'拜城縣',
  '银川市':'銀川市',
  '兴庆区':'興慶區',
  '西夏区':'西夏區',
  '金凤区':'金鳳區',
  '灵武市':'靈武市',
  '永宁县':'永寧縣',
  '贺兰县':'賀蘭縣',
  '兴和县':'興和縣',
  '凉城县':'涼城縣',
  '惠农区':'惠農區',
  '平罗县':'平羅縣',
  '吴忠市':'吳忠市',
  '利通区':'利通區',
  '邢台市':'邢台市',
  '盐池县':'鹽池縣',
  '同心县':'同心縣',
  '固原市':'固原市',
  '原州区':'原州區',
  '西吉县':'西吉縣',
  '隆德县':'隆德縣',
  '泾源县':'涇源縣',
  '彭阳县':'彭陽縣',
  '中卫市':'中衛市',
  '邢台县':'邢台縣',
  '中宁县':'中寧縣',
  '海原县':'海原縣',
  '沙雅县':'沙雅縣',
  '临城县':'臨城縣',
  '天山区':'天山區',
  '内丘县':'內丘縣',
  '柏乡县':'柏鄉縣',
  '东胜市':'東勝市',
  '隆尧县':'隆堯縣',
  '天津市':'天津市',
  '南和县':'南和縣',
  '宁晋县':'寧晉縣',
  '杭锦旗':'杭錦旗',
  '乌审旗':'烏審旗',
  '巨鹿县':'巨鹿縣',
  '新河县':'新河縣',
  '临河市':'臨河市',
  '五原县':'五原縣',
  '鄯善县':'鄯善縣',
  '磴口县':'磴口縣',
  '哈密市':'哈密市',
  '伊吾县':'伊吾縣',
  '广宗县':'廣宗縣',
  '平乡县':'平鄉縣',
  '和田市':'和田市',
  '和田县':'和田縣',
  '洛浦县':'洛浦縣',
  '民丰县':'民豐縣',
  '皮山县':'皮山縣',
  '策勒县':'策勒縣',
  '于田县':'於田縣',
  '墨玉县':'墨玉縣',
  '和平区':'和平區',
  '清河县':'清河縣',
  '温宿县':'溫宿縣',
  '常平':'常平',
  '新疆':'新疆',
  '徽县':'徽縣',
  '礼县':'禮縣',
  '文县':'文縣',
  '康县':'康縣',
  '成县':'成縣',
  '岷县':'岷縣',
  '漳县':'漳縣',
  '宁县':'寧縣',
  '环县':'環縣',
  '佳县':'佳縣',
  '勉县':'勉縣',
  '洋县':'洋縣',
  '富县':'富縣',
  '华县':'華縣',
  '乾县':'乾縣',
  '彬县':'彬縣',
  '凤县':'鳳縣',
  '眉县':'眉縣',
  '陇县':'隴縣',
  '户县':'戶縣',
  '朗县':'朗縣',
  '索县':'索縣',
  '西藏':'西藏',
  '云县':'雲縣',
  '盘县':'盤縣',
  '茂县':'茂縣',
  '理县':'理縣',
  '渠县':'渠縣',
  '达县':'達縣',
  '高县':'高縣',
  '珙县':'珙縣',
  '南充':'南充',
  '安县':'安縣',
  '泸县':'瀘縣',
  '西区':'西區',
  '东区':'東區',
  '荣县':'榮縣',
  '郫县':'郫縣',
  '忠县':'忠縣',
  '开县':'開縣',
  '东方':'東方',
  '万宁':'萬寧',
  '文昌':'文昌',
  '儋州':'儋州',
  '琼海':'瓊海',
  '容县':'容縣',
  '藤县':'藤縣',
  '横县':'橫縣',
  '广西':'廣西',
  '城区':'城區',
  '梅县':'梅縣',
  '中山':'中山',
  '塘厦':'塘廈',
  '宁夏':'寧夏',
  '莞城':'莞城',
  '道县':'道縣',
  '南县':'南縣',
  '澧县':'澧縣',
  '攸县':'攸縣',
  '潜江':'潛江',
  '天门':'天門',
  '仙桃':'仙桃',
  '房县':'房縣',
  '郧县':'鄖縣',
  '新县':'新縣',
  '息县':'息縣',
  '睢县':'睢縣',
  '陕县':'陝縣',
  '范县':'範縣',
  '温县':'溫縣',
  '淇县':'淇縣',
  '浚县':'浚縣',
  '滑县':'滑縣',
  '郏县':'郟縣',
  '叶县':'葉縣',
  '嵩县':'嵩縣',
  '杞县':'杞縣',
  '曹县':'曹縣',
  '单县':'單縣',
  '冠县':'冠縣',
  '莘县':'莘縣',
  '澳门':'澳門',
  '陵县':'陵縣',
  '费县':'費縣',
  '莒县':'莒縣',
  '赣县':'贛縣',
  '沙县':'沙縣',
  '泾县':'涇縣',
  '寿县':'壽縣',
  '路凼':'路凼',
  '香港':'香港',
  '和县':'和縣',
  '泗县':'泗縣',
  '萧县':'蕭縣',
  '黟县':'黟縣',
  '歙县':'歙縣',
  '北区':'北區',
  '丰县':'豐縣',
  '沛县':'沛縣',
  '郊区':'郊區',
  '宾县':'賓縣',
  '四平':'四平',
  '盘锦':'盤錦',
  '义县':'義縣',
  '雄县':'雄縣',
  '博野':'博野',
  '南区':'南區',
  '其他':'其他',
  '藁':'藁',
  '云数据库 RDS SQL Server':'雲數據庫 RDS SQL Server',
  '云数据库 RDS PostgreSQL':'雲數據庫 RDS PostgreSQL',
  '云数据库 RDS Oracle':'雲數據庫 RDS Oracle',
  '云数据库 RDS MySQL':'雲數據庫 RDS MySQL',
  '云数据库 MongoDB':'雲數據庫 MongoDB',
  '云原生运行时基础与设施':'雲原生運行時基礎與設施',
  '一键服务One Key':'一鍵服務One Key',
  '云数据库 Redis':'雲數據庫 Redis',
  '数据传输 DTS':'數據傳輸 DTS',
  '端到端 COSMOS':'端到端 COSMOS',
  '综合金融移动展业平台':'綜合金融移動展業平臺',
  '数据迁移 DTS':'數據遷移 DTS',
  '专有宿主机 CDH':'專有宿主機 CDH',
  '容器服务 Caas':'容器服務 Caas',
  '物理服务器 BMS':'物理服務器 BMS',
  '多域云解析 DNS':'多域雲解析 DNS',
  '对象存储 OSS':'對象存儲 OSS',
  '文件存储 NAS':'文件存儲 NAS',
  'DevOps平台':'DevOps平臺',
  'IT服务管理系统':'IT服務管理系統',
  '研发敏捷流程平台':'研發敏捷流程平臺',
  '保险上云解决方案':'保險上雲解決方案',
  '用户行为分析平台':'用戶行為分析平臺',
  '专有网络 VPC':'專有網絡 VPC',
  '负载均衡 SLB':'負載均衡 SLB',
  'CDN':'CDN',
  '弹性伸缩 AS':'彈性伸縮 AS',
  '新保险公司开业':'新保險公司開業',
  '自动化测试平台':'自動化測試平臺',
  '全站加速CDN':'全站加速CDN',
  '云裸机 BMS':'雲裸機 BMS',
  '公共组件与服务':'公共組件與服務',
  '云计算基础服务':'雲計算基礎服務',
  '云硬盘 CBS':'雲硬盤 CBS',
  '云主机 ECS':'雲主機 ECS',
  '桌面安全服务':'桌面安全服務',
  '防火墙 FW':'防火牆 FW',
  '网络安全服务':'網絡安全服務',
  '快速原型平台':'快速原型平臺',
  '应用安全服务':'應用安全服務',
  '安全专家服务':'安全專家服務',
  '消息推送中心':'消息推送中心',
  '企业通用服务':'企業通用服務',
  '任务调度平台':'任務調度平臺',
  '保险移动展业':'保險移動展業',
  '自然语言处理':'自然語言處理',
  '智能语音交互':'智能語音交互',
  '移动开发平台':'移動開發平臺',
  '邮件推送服务':'郵件推送服務',
  '热门产品:':'熱門產品:',
  'NAT网关':'NAT網關',
  '互联网金融':'互聯網金融',
  '云备份':'雲備份',
  '微服务平台':'微服務平臺',
  'API网关':'API網關',
  '互联网医疗':'互聯網醫療',
  '数据库备份':'數據庫備份',
  '大数据行业':'大數據行業',
  '音视频服务':'音視頻服務',
  '金融大数据':'金融大數據',
  '新保险展业':'新保險展業',
  '新保险中介':'新保險中介',
  '自动化运维':'自動化運維',
  '软件正版化':'軟件正版化',
  '供应链金融':'供應鏈金融',
  '可用性运维':'可用性運維',
  '小安机器人':'小安機器人',
  '金橙展业宝':'金橙展業寶',
  '微服务支撑':'微服務支撐',
  '帮助与支持':'幫助與支持',
  '视频软电话':'視頻軟電話',
  '运维服务':'運維服務',
  '用户接触':'用戶接觸',
  '容器服务':'容器服務',
  '版本发布':'版本發佈',
  '研发支持':'研發支持',
  '数据采集':'數據採集',
  '数据调整':'數據調整',
  '精益敏捷':'精益敏捷',
  '已登出!':'已登出!',
  '办公服务':'辦公服務',
  '医疗行业':'醫療行業',
  '代码管理':'代碼管理',
  '服务公告':'服務公告',
  '工单支持':'工單支持',
  '文档中心':'文檔中心',
  '客户案例':'客戶案例',
  '容器平台':'容器平臺',
  '上云迁移':'上雲遷移',
  '日志平台':'日誌平臺',
  '人工智能':'人工智能',
  '用户中心':'用戶中心',
  '影像平台':'影像平臺',
  '立即注册':'立即註冊',
  '免费注册':'免費註冊',
  '数据集成':'數據集成',
  '合作伙伴':'合作夥伴',
  '招商云播':'招商雲播',
  '弹性计算':'彈性計算',
  '帮助支持':'幫助支持',
  '星云数据':'星雲數據',
  '欧拉图谱':'歐拉圖譜',
  '金融行业':'金融行業',
  '智能投资':'智能投資',
  '友情链接':'友情鏈接',
  '归档存储':'歸檔存儲',
  '机器学习':'機器學習',
  '数字化社区':'數字化社區',
  '智能客服':'智能客服',
  '人脸识别':'人臉識別',
  '解决方案':'解決方案',
  '图像搜索':'圖像搜索',
  '短信服务':'短信服務',
  '智能联络':'智能聯絡',
  '平台服务':'平臺服務',
  '指尖办公':'指尖辦公',
  '电子发票':'電子發票',
  '电子签名':'電子簽名',
  '集成协作':'集成協作',
  '保险行业':'保險行業',
  '云视讯':'雲視訊',
  '招商云':'招商雲',
  '数据库':'數據庫',
  '流计算':'流計算',
  '平安脑':'平安腦',
  '云打印':'雲打印',
  '微表情':'微表情',
  '云桌面':'雲桌面',
  '云硬盘':'雲硬盤',
  '控制台':'控制臺',
  '大数据':'大數據',
  '云咨询':'雲咨詢',
  '知鸟':'知鳥',
  '银行':'銀行',
  '投资':'投資',
  '安全':'安全',
  '网络':'網絡',
  '云通':'雲通',
  '存储':'存儲',
  '登录':'登錄',
  '金融':'金融',
  '退出':'退出',
  '产品':'產品',
  '网盘':'網盤',
  '迁移':'遷移',
  '正在根据权限进行跳转，请稍等':'正在根據權限進行跳轉，請稍等',
  '云数据库 RDS':'雲數據庫 RDS',
  '租户账单概览':'租戶賬單概覽',
  '项目账单明细':'項目賬單明細',
  '可视化编辑器':'可視化編輯器',
  '操作日志查询':'操作日誌查詢',
  '租户账单明细':'租戶賬單明細',
  '项目账单概览':'項目賬單概覽',
  '堡垒机 TS':'堡壘機 TS',
  '资源栈管理':'資源棧管理',
  'ECS备份':'ECS備份',
  '策略组管理':'策略組管理',
  '云主机管理':'雲主機管理',
  '云主机镜像':'雲主機鏡像',
  'ISP备案':'ISP備案',
  '云硬盘快照':'雲硬盤快照',
  '云主机快照':'雲主機快照',
  '授权管理':'授權管理',
  '反馈建议':'反饋建議',
  '运营服务':'運營服務',
  '安全服务':'安全服務',
  '消息设置':'消息設置',
  '提交工单':'提交工單',
  '标签管理':'標簽管理',
  '项目管理':'項目管理',
  '服务目录':'服務目錄',
  '目录设置':'目錄設置',
  '资源编排':'資源編排',
  '企业认证':'企業認證',
  '模板管理':'模板管理',
  '部署单元':'部署單元',
  '资源配置':'資源配置',
  '费用中心':'費用中心',
  '订单管理':'訂單管理',
  '工单列表':'工單列表',
  '工单管理':'工單管理',
  '用户信息':'用戶信息',
  '账号信息':'賬號信息',
  '认证授权':'認證授權',
  '证书服务':'證書服務',
  'VIP':'VIP',
  'EIP':'EIP',
  '云管理':'雲管理',
  '站内信':'站內信',
  '服务':'服務',
  '子网':'子網',
  '建议':'建議',
  '日志':'日誌',
  '计算':'計算',
  '返回首页':'返迴首頁',
  '对象存储OSS 操作指南':'對象存儲OSS 操作指南',
  '互联网访问DNAT':'互聯網訪問DNAT',
  '出互联网SNAT':'出互聯網SNAT',
  '文档型数据库':'文檔型數據庫',
  '对象存储详情':'對象存儲詳情',
  '数据库管理':'數據庫管理',
  '缓存数据库':'緩存數據庫',
  '自定义镜像':'自定義鏡像',
  '备份管理':'備份管理',
  '恢复记录':'恢復記錄',
  '备份记录':'備份記錄',
  '账户管理':'賬戶管理',
  '同步管理':'同步管理',
  '基本信息':'基本信息',
  '备份策略':'備份策略',
  '恢复任务':'恢復任務',
  '文件管理':'文件管理',
  '同步策略':'同步策略',
  '参数设置':'參數設置',
  '未读消息':'未讀消息',
  '公共镜像':'公共鏡像',
  '云数据库':'雲數據庫',
  '域名管理':'域名管理',
  '监控查询':'監控查詢',
  '快照链':'快照鏈',
  '存储桶':'存儲桶',
  '容量包':'容量包',
  '快照':'快照',
  '全部':'全部',
  '密钥':'密鑰',
  '概览':'概覽',
  '请先选择参数，再填入相应值！':'請先選擇參數，再填入相應值！',
  '请选择资源属性进行过滤':'請選擇資源屬性進行過濾',
  '当前选项下暂无可用区，请修改配置':'當前選項下暫無可用區，請修改配置',
  '计费模式':'計費模式',
  '计价时长':'計價時長',
  '5个月':'5個月',
  '可用区':'可用區',
  '2个月':'2個月',
  '1个月':'1個月',
  '6个月':'6個月',
  '3个月':'3個月',
  '4个月':'4個月',
  '1年':'1年',
  '2年':'2年',
  '3年':'3年',
  '公':'公',
  '取消':'取消',
  '确定':'確定',
  '联 系 我 们':'聯 系 我 們',
  '一键意见反馈':'一鍵意見反饋',
  '电话':'電話',
  '邮箱':'郵箱',
  '反馈':'反饋',
  '确定删除资源吗':'確定刪除資源嗎',
  '确定删除资源':'確定刪除資源',
  '关闭':'關閉',
  '吗':'嗎',
  '当前查询条件尚无数据,您可以':'當前查詢條件尚無數據,您可以',
  '列数据已复制至剪切板！':'列數據已複製至剪切板！',
  '当前查询条件尚无数据':'當前查詢條件尚無數據',
  '该数据无可用操作！':'該數據無可用操作！',
  '无可用操作':'無可用操作',
  '复制列':'複製列',
  '请搜索':'請搜索',
  '操作':'操作',
  '更多':'更多',
  '批量操作':'批量操作',
  '每月最后一天':'每月最後一天',
  ',最后一天':',最後一天',
  '请选择日期':'請選擇日期',
  '增量备份':'增量備份',
  '开始时间':'開始時間',
  '计划名称':'計劃名稱',
  '备份周期':'備份周期',
  '全量备份':'全量備份',
  '最后一天':'最後一天',
  '备份类型':'備份類型',
  '保留时间':'保留時間',
  '15年':'15年',
  '星期一':'星期一',
  '星期二':'星期二',
  '星期三':'星期三',
  '星期四':'星期四',
  '星期五':'星期五',
  '星期六':'星期六',
  '星期日':'星期日',
  '请选择':'請選擇',
  '输入阈值':'輸入閾值',
  '20年':'20年',
  '10年':'10年',
  '周二':'周二',
  '5年':'5年',
  '每月':'每月',
  '永久':'永久',
  '日期':'日期',
  '全量':'全量',
  '增量':'增量',
  '周一':'周一',
  '周三':'周三',
  '周四':'周四',
  '周五':'周五',
  '周六':'周六',
  '周日':'周日',
  '日':'日',
  '月':'月',
  '周':'周',
  '暂无数据':'暫無數據',
  '删除':'刪除',
  '该套配置仅支持线下询价':'該套配置僅支持線下詢價',
  '正在计算价格':'正在計算價格',
  '查看优惠':'查看優惠',
  '元/年':'元/年',
  '费用':'費用',
  '省':'省',
  '至':'至',
  '计费模式:':'計費模式:',
  '计价时长:':'計價時長:',
  '不能为空':'不能為空',
  '不能少于2字符':'不能少於2字符', 
  '不能超出60字符':'不能超出60字符',
  '新增':'新增',
  '编辑':'編輯',
  '保存':'保存',
  '设置不符合要求，请重新设置':'設置不符合要求，請重新設置',
  '设置不符合要求，请重新输入':'設置不符合要求，請重新輸入',
  '两次输入的密码不一致':'兩次輸入的密碼不一致',
  '密码安全程度：中':'密碼安全程度：中',
  '请再次输入密码':'請再次輸入密碼',
  '请重新输入密码':'請重新輸入密碼',
  '请输入密码':'請輸入密碼',
  '安全程度:':'安全程度:',
  '确认密码':'確認密碼',
  '值可包含大小写字母、数字、点、-、_、汉字，长度不超过60个字符！':'值可包含大小寫字母、數字、點、-、_、漢字，長度不超過60個字符！',
  '键可包含大小写字母、数字、点，长度不超过32个字符！':'鍵可包含大小寫字母、數字、點，長度不超過32個字符！',
  '编辑标签 --':'編輯標簽 --',
  '请检查书写格式':'請檢查書寫格式',
  '标签修改成功！':'標簽修改成功！',
  '请先填写键！':'請先填寫鍵！',
  '新建标签':'新建標簽',
  '标签键:':'標簽鍵:',
  '暂无标签':'暫無標簽',
  '编辑标签':'編輯標簽',
  '取消标签':'取消標簽',
  '添加标签':'添加標簽',
  '已选中':'已選中',
  '待选择':'待選擇',
  '值:':'值:',
  '该操作需要验证手机号码，请您立即验证':'該操作需要驗證手機號碼，請您立即驗證',
  '验证码已发送至:':'驗證碼已發送至:',
  '请先获取验证码':'請先獲取驗證碼',
  '请先输入验证码':'請先輸入驗證碼',
  '验证码已发送':'驗證碼已發送',
  '获取验证码':'獲取驗證碼',
  '输入验证码':'輸入驗證碼',
  '删除成功':'刪除成功',
  '验证码：':'驗證碼：',
  '删除资源':'刪除資源',
  '立即验证':'立即驗證',
  '重新获取':'重新獲取',
  '成功':'成功',
  '返回上一级':'返回上一級',
  '表格生成预计需要20-60s,请耐心等待！':'表格生成預計需要20-60s,請耐心等待！',
  '自定义列表字段':'自定義列表字段',
  '列表刷新入口':'列表刷新入口',
  '列管理入口':'列管理入口',
  '表格生成中':'表格生成中',
  '筛选':'篩選',
  '刷新':'刷新',
  '导出':'導出',
  '重置':'重置',
  '租户':'租戶',
  '项目':'項目',
  '升级后价格':'升級後價格',
  '升级前价格:':'升級前價格:',
  '请输入xxx-xxx-xxx格式，且不输入数字。eg. VMS-VMS-example':'請輸入xxx-xxx-xxx格式，且不輸入數字。eg. VMS-VMS-example',
  '请输入xxx-xxx格式，且不输入数字。eg. VMS-example':'請輸入xxx-xxx格式，且不輸入數字。eg. VMS-example',
  '主备模式开启时，后端服务器最多可以添加7台!':'主備模式開啟時，後端服務器最多可以添加7台!',
  '请配置监听端口范围在1-65535整数!':'請配置監聽端口範圍在1-65535整數!',
  '请配置端口范围在1-65535整数!':'請配置端口範圍在1-65535整數!',
  '请先填写正确格式的发布单元!':'請先填寫正確格式的發佈單元!',
  '请选择租户、项目信息 !':'請選擇租戶、項目信息 !',
  '请选择有效的区域信息 !':'請選擇有效的區域信息 !',
  '请先填写正确格式的名称!':'請先填寫正確格式的名稱!',
  '请先配置健康检查协议!':'請先配置健康檢查協議!',
  '填写正确格式的ip地址':'填寫正確格式的ip地址',
  '请先配置后端服务器!':'請先配置後端服務器!',
  '不允许同IP同端口：':'不允許同IP同端口：',
  '请先配置服务器端口!':'請先配置服務器端口!',
  '请选择VPC信息 !':'請選擇VPC信息 !',
  '请先配置SSL证书!':'請先配置SSL證書!',
  '请先配置发布单元!':'請先配置發佈單元!',
  '请先填写发布单元!':'請先填寫發佈單元!',
  '请先配置监听端口!':'請先配置監聽端口!',
  '请先选择会话保持!':'請先選擇會話保持!',
  '请先选择带宽峰值!':'請先選擇帶寬峰值!',
  '请选择主服务器！':'請選擇主服務器！',
  '请先选择服务器!':'請先選擇服務器!',
  '请先填写名称!':'請先填寫名稱!',
  '请先配置名称!':'請先配置名稱!',
  '选择区域与配置':'選擇區域與配置',
  '后端服务器端口':'後端服務器端口',
  '添加配置项成功':'添加配置項成功',
  '请先配置协议!':'請先配置協議!',
  '连接超时时间':'連接超時時間',
  '添加配置向导':'添加配置嚮導',
  '健康检查端口':'健康檢查端口',
  '负载均衡购买':'負載均衡購買',
  '健康检查协议':'健康檢查協議',
  '响应超时时间':'響應超時時間',
  '获取真实IP':'獲取真實IP',
  '云主机IP:':'雲主機IP:',
  '后端服务器':'後端服務器',
  '区域与配置':'區域與配置',
  '是否ftp':'是否ftp',
  '是否重定向':'是否重定向',
  'SSL证书':'SSL證書',
  '自定义名称':'自定義名稱',
  '协议&监听':'協議&監聽',
  '请检查配置':'請檢查配置',
  '云主机IP':'雲主機IP',
  '被配置在第':'被配置在第',
  '发布单元':'發佈單元',
  '配置校验':'配置校驗',
  '调度算法':'調度算法',
  '带宽峰值':'帶寬峰值',
  '新增成功':'新增成功',
  '立即购买':'立即購買',
  '会话保持':'會話保持',
  '高级配置':'高級配置',
  '返回列表':'返回列表',
  '配置审核':'配置審核',
  '间隔时间':'間隔時間',
  '备服务器':'備服務器',
  '健康检查':'健康檢查',
  '监听端口':'監聽端口',
  '主服务器':'主服務器',
  '机器类型':'機器類型',
  '主备模式':'主備模式',
  '端口:':'端口:',
  '下一步':'下一步',
  '上一步':'上一步',
  '轮询':'輪詢',
  '收起':'收起',
  '添加':'添加',
  '开启':'開啟',
  '展开':'展開',
  '端口':'端口',
  '名称':'名稱',
  '启用':'啟用',
  '协议':'協議',
  '行':'行',
  '否':'否',
  '是':'是',
  '秒':'秒',
  '当前状态不允许禁启用!':'當前狀態不允許禁啟用!',
  '启/禁用状态修改成功 !':'啟/禁用狀態修改成功 !',
  '当前状态不允许删除!':'當前狀態不允許刪除!',
  '当前状态不允许编辑!':'當前狀態不允許編輯!',
  '当前状态不允新增!':'當前狀態不允新增!',
  '响应超时时间(s)':'響應超時時間(s)',
  '连接超时时间(s)':'連接超時時間(s)',
  '宽带峰值(M)':'寬帶峰值(M)',
  '新增后端服务器':'新增後端服務器',
  '间隔时间(s)':'間隔時間(s)',
  'http重定向':'http重定向',
  '负载均衡详情':'負載均衡詳情',
  '编辑健康检查':'編輯健康檢查',
  '所属可用区':'所屬可用區',
  '所属宿主机':'所屬宿主機',
  '所属VPC':'所屬VPC',
  '是否FTP':'是否FTP',
  '所属租户':'所屬租戶',
  '创建时间':'創建時間',
  '更新时间':'更新時間',
  '初始状态':'初始狀態',
  '编辑协议':'編輯協議',
  '所属项目':'所屬項目',
  '申请人':'申請人',
  '创建中':'創建中',
  '16秒':'16秒',
  '标签名称:':'標簽名稱:',
  '标签名称':'標簽名稱',
  '关键字':'關鍵字',
  '状态':'狀態',
  '台':'臺',
  '台数(台)':'臺數(臺)',
  '是否计算节点':'是否計算節點',
  'cpu核数':'cpu核數',
  '网卡入口流量p95(B/s)':'網卡入口流量p95(B/s)',
  '网卡出口流量p95(B/s)':'網卡出口流量p95(B/s)',
  '磁盘iops读取p95(B/s)':'磁盤iops讀取p95(B/s)',
  '磁盘iops写入p95(B/s)':'磁盤iops寫入p95(B/s)',
  '数据库主机类型':'數據庫主機類型',
  '磁盘总容量(GB)':'磁盤總容量(GB)',
  '已分配数据库容量(GB)':'已分配數據庫容量(GB)',
  '剩余可使用磁盘(GB)':'剩余可使用磁盤(GB)',
  '数据库磁盘剩余率(%)':'數據庫磁盤剩余率(%)',
  '数据库磁盘使用率(%)':'數據庫磁盤使用率(%)',
  '读IOPS':'讀IOPS',
  '写IOPS':'寫IOPS',
  '读带宽(MB/S)':'讀帶寬(MB/S)',
  '写带宽(MB/S)':'寫帶寬(MB/S)',
  'IO延时(ms)':'IO延時(ms)',
  '概要':'概要',
  '禁用':'禁用',
  '监听':'監聽',
  '5秒':'5秒',
  '失败':'失敗',
  '负载均衡SLB 操作指南':'負載均衡SLB 操作指南',
  '禁用指令已发出！':'禁用指令已發出！',
  '配置项列表':'配置項列表',
  '确定要禁用':'確定要禁用',
  '添加配置':'添加配置',
  '启用成功':'啟用成功',
  '负载均衡':'負載均衡',
  '删 除':'刪 除',
  '禁 用':'禁 用',
  '启 用':'啟 用',
  '搜索':'搜索',
  '购买':'購買',
  '标签':'標簽',
  'HBA卡的类型和数量需要同时配置!':'HBA卡的類型和數量需要同時配置!',
  '请选择有效的pool类型信息 !':'請選擇有效的pool類型信息 !',
  '请选择有效的VPC及子网信息 !':'請選擇有效的VPC及子網信息 !',
  '申请请求已发送成功 !':'申請請求已發送成功 !',
  '两次密码输入不一致 !':'兩次密碼輸入不一致 !',
  '密码中不能包含中文 !':'密碼中不能包含中文 !',
  '请选择有效的区域信息!':'請選擇有效的區域信息!',
  '请先选择租户和项目!':'請先選擇租戶和項目!',
  '请再次输入主机密码':'請再次輸入主機密碼',
  '没有可选HBA卡':'沒有可選HBA卡',
  '请先选择机型!':'請先選擇機型!',
  '可用ip数为0,无法购买 !':'可用ip數為0,無法購買 !',
  '请先选择镜像!':'請先選擇鏡像!',
  '请输入主机密码':'請輸入主機密碼',
  '选择存储与网络':'選擇存儲與網絡',
  '选择镜像与机型':'選擇鏡像與機型',
  '选择区域与项目':'選擇區域與項目',
  'HBA卡数量':'HBA卡數量',
  '没有可选机型':'沒有可選機型',
  '磁盘(GB)':'磁盤(GB)',
  '没有可选镜像':'沒有可選鏡像',
  '内存(GB)':'內存(GB)',
  'pool类型':'pool類型',
  'HBA卡类型':'HBA卡類型',
  '可用IP数':'可用IP數',
  '云裸机购买':'雲裸機購買',
  '已选配置':'已選配置',
  '设置信息':'設置信息',
  '镜像':'鏡像',
  '备注':'備註',
  '数量':'數量',
  '密码':'密碼',
  '内存':'內存',
  '磁盘':'磁盤',
  '机型':'機型',
  '核':'核',
  '云裸机详情':'雲裸機詳情',
  '主IP':'主IP',
  '安装中':'安裝中',
  '开机中':'開機中',
  '重启中':'重啟中',
  '创建人':'創建人',
  '主机名':'主機名',
  '运行':'運行',
  '隔离中':'隔離中',
  '用途':'用途',
  '配置':'配置',
  '核-':'核-',
  '关机':'關機',
  '云裸机BMS 操作指南':'雲裸機BMS 操作指南',
  '密码已复制至剪切板！':'密碼已複製至剪切板！',
  '请先选择账户！':'請先選擇賬戶！',
  '指令已发出！':'指令已發出！',
  '已取消纳管！':'已取消納管！',
  '修改成功!':'修改成功!',
  '纳管成功！':'納管成功！',
  '过期时间':'過期時間',
  '启动主机':'啟動主機',
  '查询密码':'查詢密碼',
  '重启主机':'重啟主機',
  '关闭主机':'關閉主機',
  '取消纳管':'取消納管',
  '未纳管':'未納管',
  '云裸机':'雲裸機',
  '监控图':'監控圖',
  '云堡垒机':'雲堡壘機',
  '堡垒机':'堡壘機',
  '已纳管':'已納管',
  '开机':'開機',
  '纳管':'納管',
  '账号':'賬號',
  '通用':'通用',
  '重启':'重啟',
  '查询':'查詢',
  '复制':'複製',
  'cpu使用率':'cpu使用率',
  '内存使用率':'內存使用率',
  '云裸机信息':'雲裸機信息',
  '监控图表':'監控圖表',
  '系统负载':'系統負載',
  '监控视图':'監控視圖',
  '12小时':'12小時',
  '3小时':'3小時',
  '6小时':'6小時',
  '近一月':'近一月',
  '近1天':'近1天',
  '近3天':'近3天',
  '近一周':'近一周',
  '1小时':'1小時',
  '基础':'基礎',
  '重启实例会造成连接中断，重启前请做好业务安排，谨慎操作。':'重啟實例會造成連接中斷，重啟前請做好業務安排，謹慎操作。',
  '大小写字母、数字、特殊字符!@#$%^&*()_+=':'大小寫字母、數字、特殊字符!@#$%^&*()_+=',
  '缓存数据库 操作指南':'緩存數據庫 操作指南',
  '请填写数据库描述！':'請填寫數據庫描述！',
  '编辑应用环境成功！':'編輯應用環境成功！',
  '保存成功！':'保存成功！',
  'Flavor规格':'Flavor規格',
  '数据库规格ID':'數據庫規格ID',
  '8-32位字符':'8-32位字符',
  '12-32位字符':'12-32位字符',
  '数据库实例名':'數據庫實例名',
  '数据库描述':'數據庫描述',
  '数据库端口':'數據庫端口',
  '请检查密码':'請檢查密碼',
  '重置成功！':'重置成功！',
  '特殊字符为':'特殊字符為',
  '主机ID':'主機ID',
  'IP地址':'IP地址',
  '高可用版':'高可用版',
  '应用环境':'應用環境',
  '重置密码':'重置密碼',
  '指令发送':'指令發送',
  '基础版':'基礎版',
  '金融版':'金融版',
  '虚拟机':'虛擬機',
  '物理机':'物理機',
  '初始化':'初始化',
  '删除中':'刪除中',
  '更新中':'更新中',
  '停止中':'停止中',
  '启动中':'啟動中',
  '等待中':'等待中',
  '未知':'未知',
  '错误':'錯誤',
  '停止':'停止',
  '管理':'管理',
  '启动':'啟動',
  '您订购的云数据库正在努力创建中，一般需要1-15分钟，请您耐心等待！':'您訂購的雲數據庫正在努力創建中，一般需要1-15分鐘，請您耐心等待！',
  '云数据库暂不支持外网直接访问，外网访问需搭配云主机使用':'雲數據庫暫不支持外網直接訪問，外網訪問需搭配雲主機使用',
  '请选择有效的数据库规格 !':'請選擇有效的數據庫規格 !',
  '根分区大小(GB)':'根分區大小(GB)',
  '请先填写实例描述！':'請先填寫實例描述！',
  '请选择可用区 !':'請選擇可用區 !',
  '请先填写实例名！':'請先填寫實例名！',
  '请先选择租户！':'請先選擇租戶！',
  '请输入实例描述':'請輸入實例描述',
  'G根分区大小':'G根分區大小',
  '内存(MB)':'內存(MB)',
  '新增云数据库':'新增雲數據庫',
  '数据库创建中':'數據庫創建中',
  '请输入实例名':'請輸入實例名',
  '开启持久化':'開啟持久化',
  '核CPU、':'核CPU、',
  '选择数据库':'選擇數據庫',
  '数据库类型':'數據庫類型',
  '主机类型':'主機類型',
  'M内存、':'M內存、',
  '实例描述':'實例描述',
  '下一步：':'下一步：',
  '实例名':'實例名',
  '版本':'版本',
  '系列':'系列',
  '故障自动迁移开关打开后，专属宿主机发生故障时会自动迁移至其它可用的宿主机或者是共享宿主机':'故障自動遷移開關打開後，專屬宿主機發生故障時會自動遷移至其它可用的宿主機或者是共享宿主機',
  '密码必须包含数字、大小写字母，且长度为8到64位 !':'密碼必須包含數字、大小寫字母，且長度為8到64位 !',
  '可购买数量不足，请咨询后台管理员！':'可購買數量不足，請咨詢後臺管理員！',
  '部署单元名称长度范围为2-32！':'部署單元名稱長度範圍為2-32！',
  'qos限制在公有云区域不生效':'qos限制在公有雲區域不生效',
  '部署单元名称不能为空！':'部署單元名稱不能為空！',
  '请选择有效的规格 !':'請選擇有效的規格 !',
  '请选择有效的机型!':'請選擇有效的機型!',
  '无可用主机规格':'無可用主機規格',
  '专有宿主机购买':'專有宿主機購買',
  '故障自动迁移':'故障自動遷移',
  '-1为不限！':'-1為不限！',
  'cpu超分比':'cpu超分比',
  '根分区大小':'根分區大小',
  '云主机规格':'雲主機規格',
  '可用数量':'可用數量',
  '选择机型':'選擇機型',
  '内存、':'內存、',
  '关':'關',
  '开':'開',
  '此宿主机上所有的云主机都进行关机操作':'此宿主機上所有的雲主機都進行關機操作',
  '请在专业宿主机关机前备份所有数据':'請在專業宿主機關機前備份所有數據',
  '-保存用户新增、编辑时数据':'-保存用戶新增、編輯時數據',
  '超分比设置成功！':'超分比設置成功！',
  '专有宿主机名称':'專有宿主機名稱',
  '专有宿主机详情':'專有宿主機詳情',
  'cpu超分比:':'cpu超分比:',
  '443端口:':'443端口:',
  '重启宿主机':'重啟宿主機',
  '80端口:':'80端口:',
  'ECS实例':'ECS實例',
  '关闭宿主机':'關閉宿主機',
  '设置超分比':'設置超分比',
  '启动宿主机':'啟動宿主機',
  '已过期:':'已過期:',
  '已开启:':'已開啟:',
  '申请中:':'申請中:',
  '新建实例':'新建實例',
  '重置状态':'重置狀態',
  '未开启:':'未開啟:',
  '释放成功':'釋放成功',
  '正常:':'正常:',
  'IP:':'IP:',
  '域名:':'域名:',
  '关机中':'關機中',
  '超分比':'超分比',
  '已删除':'已刪除',
  '运行中':'運行中',
  '备:':'備:',
  '主:':'主:',
  '释放':'釋放',
  '专有宿主机CDH 操作指南':'專有宿主機CDH 操作指南',
  '您确定要释放专有宿主机吗？请在释放前确认数据已备份，专有宿主机释放后您将无法再获得该台宿主机。':'您確定要釋放專有宿主機嗎？請在釋放前確認數據已備份，專有宿主機釋放後您將無法再獲得該台宿主機。',
  '重置状态修改成功！':'重置狀態修改成功！',
  '故障自动迁移:':'故障自動遷移:',
  '专有宿主机':'專有宿主機',
  '编辑成功！':'編輯成功！',
  'ip地址':'ip地址',
  '运行状态':'運行狀態',
  '修改配置':'修改配置',
  '下线中':'下線中',
  '监控':'監控',
  '专有宿主机信息':'專有宿主機信息',
  '请输入单个域名，也支持添加泛域名：*.test.com':'請輸入單個域名，也支持添加泛域名：*.test.com',
  '请正确填写记录值为域名，如“test.com” !':'請正確填寫記錄值為域名，如“test.com” !',
  '请输入单个域名，也支持添加泛域名：':'請輸入單個域名，也支持添加泛域名：',
  '请正确填写记录值为IP地址 !':'請正確填寫記錄值為IP地址 !',
  '加速域名与源站域名不能相同 !':'加速域名與源站域名不能相同 !',
  '中国境外 (无需备案)':'中國境外 (無需備案)',
  '域名长度需1-63 !':'域名長度需1-63 !',
  '全球加速 (需备案)':'全球加速 (需備案)',
  'IP地址不能相同 !':'IP地址不能相同 !',
  '中国大陆 (需备案)':'中國大陸 (需備案)',
  '请填写加速域名 !':'請填寫加速域名 !',
  '请求已发送成功 !':'請求已發送成功 !',
  '请正确填写记录值':'請正確填寫記錄值',
  '大文件下载':'大文件下載',
  '视音频点播':'視音頻點播',
  '图片小文件':'圖片小文件',
  '请输入单个':'請輸入單個',
  '443端口':'443端口',
  '添加域名':'添加域名',
  '业务类型':'業務類型',
  '加速域名':'加速域名',
  '关联证书':'關聯證書',
  '源站信息':'源站信息',
  '创建证书':'創建證書',
  '加速区域':'加速區域',
  '80端口':'80端口',
  '确认添加':'確認添加',
  '优先级':'優先級',
  '域名':'域名',
  '类型':'類型',
  '修改':'修改',
  '主':'主',
  '备':'備',
  '请先关联证书！':'請先關聯證書！',
  '供应商类型':'供應商類型',
  '免费证书':'免費證書',
  '域名详情':'域名詳情',
  '正常运行':'正常運行',
  '证书名称':'證書名稱',
  '证书类型':'證書類型',
  '证书状态':'證書狀態',
  '自有证书':'自有證書',
  '中国境外':'中國境外',
  '中国大陆':'中國大陸',
  '已停止':'已停止',
  '腾讯云':'騰訊雲',
  '阿里云':'阿裡雲',
  '已过期':'已過期',
  '未开启':'未開啟',
  '申请中':'申請中',
  '审核中':'審核中',
  '配置中':'配置中',
  '未备案':'未備案',
  '已开启':'已開啟',
  '证书':'證書',
  '正常':'正常',
  '全球':'全球',
  '地址':'地址',
  '全站加速CDN 操作指南':'全站加速CDN 操作指南',
  '禁用状态修改成功 !':'禁用狀態修改成功 !',
  '启用状态修改成功 !':'啟用狀態修改成功 !',
  '无':'無',
  '请先选择时间范围!':'請先選擇時間範圍!',
  '没有符合条件域名!':'沒有符合條件域名!',
  '请先选择域名!':'請先選擇域名!',
  '带宽峰值 ':'帶寬峰值 ',
  '统计粒度':'統計粒度',
  '结束时间':'結束時間',
  '流量总值':'流量總值',
  '流量带宽':'流量帶寬',
  '近30天':'近30天',
  '自定义':'自定義',
  '5分钟':'5分鐘',
  '近7天':'近7天',
  '流量':'流量',
  '带宽':'帶寬',
  '带宽类型':'帶寬類型',
  '1天':'1天',
  '昨天':'昨天',
  '今天':'今天',
  '温馨提示：申请免费证书只能关联一个域名':'溫馨提示：申請免費證書只能關聯一個域名',
  '请先配置公钥和私钥!':'請先配置公鑰和私鑰!',
  'pem编码参考样例':'pem編碼參考樣例',
  '请先配置证书名称':'請先配置證書名稱',
  '创建成功 !':'創建成功 !',
  '已关联域名':'已關聯域名',
  '未关联域名':'未關聯域名',
  '关联域名':'關聯域名',
  '替换证书':'替換證書',
  '关联':'關聯',
  '移除':'移除',
  '私钥':'私鑰',
  '公钥':'公鑰',
  '链接已复制至剪切板！':'鏈接已複製至剪切板！',
  '选择日期时间':'選擇日期時間',
  '编辑成功 !':'編輯成功 !',
  '证书状态：':'證書狀態：',
  '证书名称：':'證書名稱：',
  '过期时间：':'過期時間：',
  '复制名称':'複製名稱',
  '复制私钥':'複製私鑰',
  '复制公钥':'複製公鑰',
  '查看证书':'查看證書',
  '私钥：':'私鑰：',
  '公钥：':'公鑰：',
  '替换':'替換',
  '(根据已购买产品消费预估)':'(根據已購買產品消費預估)',
  '充值金额最多两位小数!':'充值金額最多兩位小數!',
  '修改阈值最多两位小数!':'修改閾值最多兩位小數!',
  '阈值预警修改成功!':'閾值預警修改成功!',
  '21元(共11个)':'21元(共11個)',
  '充值金额(元)：':'充值金額(元)：',
  '预估本月项目消费':'預估本月項目消費',
  '预估本月产品消费':'預估本月產品消費',
  '预测7天后账单：':'預測7天后賬單：',
  '预警阈值(元)：':'預警閾值(元)：',
  '预测本月账单：':'預測本月賬單：',
  '项目余额(元)':'項目餘額(元)',
  '本月当前账单：':'本月當前賬單：',
  '获取最新余额':'獲取最新餘額',
  '(单位:元)':'(單位:元)',
  '暂无充值记录':'暫無充值記錄',
  '可用余额预警':'可用餘額預警',
  '可用信用额度':'可用信用額度',
  '充值成功!':'充值成功!',
  '费用(元)':'費用(元)',
  '预警阈值：':'預警閾值：',
  '昨日账单：':'昨日賬單：',
  '充值金额':'充值金額',
  '切换租户':'切換租戶',
  '费用趋势':'費用趨勢',
  '租户余额':'租戶餘額',
  '充值记录':'充值記錄',
  '预警阈值':'預警閾值',
  '充值时间':'充值時間',
  '可用余额':'可用餘額',
  '项目名称':'項目名稱',
  '数据库实例名称':'數據庫實例名稱',
  '充值账号':'充值賬號',
  '消费预测':'消費預測',
  '总费用':'總費用',
  '近一年':'近一年',
  '近半年':'近半年',
  '充值':'充值',
  '元':'元',
  '具有DML(增、删、改、查)可对库增、删、改、查、创建和删除表和索引、修改表结构、查看进程操作，默认用于数据库版本部署(版本发布)账号':'具有DML(增、刪、改、查)可對庫增、刪、改、查、創建和刪除表和索引、修改表結構、查看進程操作，默認用於數據庫版本部署(版本發佈)賬號',
  '可对库增、删、改、查;表、索引、外键、视图、存储过程、触发器、临时表、锁表、进程、事件的DDL和DML操作':'可對庫增、刪、改、查;表、索引、外鍵、視圖、存儲過程、觸發器、臨時表、鎖表、進程、事件的DDL和DML操作',
  '可对库增、删、改、查、创建和执行存储过程、创建临时表、锁表、查看视图和进程信息操作':'可對庫增、刪、改、查、創建和執行存儲過程、創建臨時表、鎖表、查看視圖和進程信息操作',
  '可对库增、删、改、查;表、索引、外键、视图、存储过程、触发器等DDL和DML操作':'可對庫增、刪、改、查;表、索引、外鍵、視圖、存儲過程、觸發器等DDL和DML操作',
  '可对库增、删、改、查操作，默认用于应用系统配置数据源':'可對庫增、刪、改、查操作，默認用於應用系統配置數據源',
  '请输入关键字进行过滤':'請輸入關鍵字進行過濾',
  '源库名':'源庫名',
  '源表名':'源表名',
  '已选择对象':'已選擇對象',
  '可对库查询操作':'可對庫查詢操作',
  '授权':'授權',
  '默认分配空间':'默認分配空間',
  '自定义空间':'自定義空間',
  '数据磁盘':'數據磁盤',
  '归档磁盘':'歸檔磁盤',
  '字符集':'字符集',
  '数据盘':'數據盤',
  '块大小':'塊大小',
  '用户名由小写字母，数字、下划线组成、字母开头， 字母或数字结尾，最长16个字符':'用戶名由小寫字母，數字、下劃線組成、字母開頭， 字母或數字結尾，最長16個字符',
  '用户名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长19个字符':'用戶名由字母開頭，小寫字母，數字、下劃線組成， 字母或數字結尾，最長19個字符',
  '不能设置如下特殊字母welcome, database, account,  <br> user, password, oracle,computer, abcd':'不能設置如下特殊字母welcome, database, account,  <br> user, password, oracle,computer, abcd',
  '一个数据库实例中有且仅有一个数据备份策略，需要删除已创立的备份策略后执行':'一個數據庫實例中有且僅有一個數據備份策略，需要刪除已創立的備份策略後執行',
  '大小写字母、数字、特殊字符,特殊字符为!@#$%^&*()_+=':'大小寫字母、數字、特殊字符,特殊字符為!@#$%^&*()_+=',
  '数据库名由小写字母、数字、下划线组成，字母开头，字母或数字结尾':'數據庫名由小寫字母、數字、下劃線組成，字母開頭，字母或數字結尾',
  'off状态下，系统将自动分配默认密码':'off狀態下，系統將自動分配默認密碼',
  '属主用户密码不可以与用户名相同':'屬主用戶密碼不可以與用戶名相同',
  '应用用户密码不可以与用户名相同':'應用用戶密碼不可以與用戶名相同',
  '数据库名长度为2-60个字符！':'數據庫名長度為2-60個字符！',
  '数据库名长度为2-63个字符！':'數據庫名長度為2-63個字符！',
  '用户名长度需为16个字符以内':'用戶名長度需為16個字符以內',
  '用户名长度需2-19个字符':'用戶名長度需2-19個字符',
  '用户名长度需2-16个字符':'用戶名長度需2-16個字符',
  '小写字母、数字、下划线':'小寫字母、數字、下劃線',
  '关系型数据库 帮助文档':'關係型數據庫 幫助文檔',
  'Oracle 操作指南':'Oracle 操作指南',
  '实例无可恢复时间点！':'實例無可恢復時間點！',
  'MySQL 操作指南':'MySQL 操作指南',
  '排序规则 不能为空':'排序規則 不能為空',
  '字符分类 不能为空':'字符分類 不能為空',
  '请检查属主用户密码':'請檢查屬主用戶密碼',
  '请检查应用用户密码':'請檢查應用用戶密碼',
  '数据库创建 --':'數據庫創建 --',
  '请先选择字符集！':'請先選擇字符集！',
  '字符集 不能为空':'字符集 不能為空',
  '创建数据库成功！':'創建數據庫成功！',
  '账户创建 --':'賬戶創建 --',
  '请填写用户前缀':'請填寫用戶前綴',
  '8-30位字符':'8-30位字符',
  '12-30位字符':'12-30位字符',
  '用户名不能为空':'用戶名不能為空',
  '创建用户成功！':'創建用戶成功！',
  '创建备份失败':'創建備份失敗',
  '未授权数据库':'未授權數據庫',
  '已授权数据库':'已授權數據庫',
  '授权用户账号':'授權用戶賬號',
  '数据库端口:':'數據庫端口:',
  '数据库类型:':'數據庫類型:',
  '查看更多数据':'查看更多數據',
  '关系型数据库':'關係型數據庫',
  '数据库创建':'數據庫創建',
  '授权数据库':'授權數據庫',
  '数据库账号':'數據庫賬號',
  '未授权账户':'未授權賬戶',
  '已授权账户':'已授權賬戶',
  '排序规则':'排序規則',
  '数据库名':'數據庫名',
  '字符分类':'字符分類',
  '属主用户':'屬主用戶',
  '应用用户':'應用用戶',
  '用户权限':'用戶權限',
  '账户创建':'賬戶創建',
  '创建备份':'創建備份',
  '备份恢复':'備份恢復',
  '用户前缀':'用戶前綴',
  '设置密码':'設置密碼',
  '升级中':'升級中',
  '必填':'必填',
  '创建':'創建',
  '只读':'只讀',
  '实例ID 不能为空':'實例ID 不能為空',
  '请选择实例ID':'請選擇實例ID',
  '确定移除资源':'確定移除資源',
  '部署单元详情':'部署單元詳情',
  '实例ID:':'實例ID:',
  '添加成功！':'添加成功！',
  '添加云主机':'添加雲主機',
  '云主机列表':'雲主機列表',
  '云主机数量':'雲主機數量',
  '实例ID':'實例ID',
  '移除成功':'移除成功',
  '宿主机':'宿主機',
  '挂起':'掛起',
  '区域':'區域',
  '策略':'策略',
  '描述':'描述',
  '暂停':'暫停',
  '部署单元是指控制一组云主机分布在指定项目及可用区内不同计算节点上的策略，以此保证业务的高可用性和底层容灾能力。欢迎大家使用并反馈建议！':'部署單元是指控制一組雲主機分佈在指定項目及可用區內不同計算節點上的策略，以此保證業務的高可用性和底層容災能力。歡迎大家使用並反饋建議！',
  '请输入部署单元描述':'請輸入部署單元描述',
  '请输入部署单元名称':'請輸入部署單元名稱',
  '可用区 不能为空':'可用區 不能為空',
  '区域 不能为空':'區域 不能為空',
  '创建部署单元':'創建部署單元',
  '部署单元名称':'部署單元名稱',
  '修改成功！':'修改成功！',
  '新增成功！':'新增成功！',
  '可用区:':'可用區:',
  '区域:':'區域:',
  '请填a-z,0-9,-,@,*，或者单个@,*':'請填a-z,0-9,-,@,*，或者單個@,*',
  '请正确填写记录名，@或*只能单独存在':'請正確填寫記錄名，@或*只能單獨存在',
  '请正确填写记录名，a-z,0-9,-':'請正確填寫記錄名，a-z,0-9,-',
  '请填写解析网络区域 !':'請填寫解析網絡區域 !',
  '请填写记录名称 !':'請填寫記錄名稱 !',
  '请填写记录值 !':'請填寫記錄值 !',
  '请选择域名 !':'請選擇域名 !',
  '请填写ip地址':'請填寫ip地址',
  '解析网络环境':'解析網絡環境',
  '解析网络区域':'解析網絡區域',
  'DNS购买':'DNS購買',
  '请填写域名':'請填寫域名',
  '生存时间':'生存時間',
  '已选信息':'已選信息',
  '记录名称':'記錄名稱',
  '记录类型':'記錄類型',
  '记录值':'記錄值',
  '解析网络区域 不能为空':'解析網絡區域 不能為空',
  '记录类型 不能为空':'記錄類型 不能為空',
  '新增成功 !':'新增成功 !',
  '请输入记录值':'請輸入記錄值',
  'DNS详情':'DNS詳情',
  '添加记录':'添加記錄',
  '新增记录':'新增記錄',
  '解析设置':'解析設置',
  '多域云解析DNS 操作指南':'多域雲解析DNS 操作指南',
  '请勿重复锁定！':'請勿重覆鎖定！',
  '确定解锁该':'確定解鎖該',
  '点击可解锁':'點擊可解鎖',
  '锁定成功！':'鎖定成功！',
  '解锁成功！':'解鎖成功！',
  '确定锁定该':'確定鎖定該',
  '记录列表':'記錄列表',
  '增加记录':'增加記錄',
  '锁定者':'鎖定者',
  '锁定':'鎖定',
  '解锁':'解鎖',
  '数据盘(GB)':'數據盤(GB)',
  '云数据库购买':'雲數據庫購買',
  '修改成功 !':'修改成功 !',
  '用户名由小写字母，数字、下划线组成、字母开头， 字母或数字结尾，最长64个字符！':'用戶名由小寫字母，數字、下劃線組成、字母開頭， 字母或數字結尾，最長64個字符！',
  '数据库名由小写字母、数字、下划线、中划线组成，字母开头，字母或数字结尾':'數據庫名由小寫字母、數字、下劃線、中劃線組成，字母開頭，字母或數字結尾',
  '由小写字母，数字、下划线组成，最长16个字符':'由小寫字母，數字、下劃線組成，最長16個字符',
  '小写字母、数字、下划线、中划线':'小寫字母、數字、下劃線、中劃線',
  '用户名长度必须大于等于 2！':'用戶名長度必須大於等於 2！',
  '用户名长度最长64个字符！':'用戶名長度最長64個字符！',
  '大小写字母、数字、特殊字符':'大小寫字母、數字、特殊字符',
  '文档型数据库 操作指南':'文檔型數據庫 操作指南',
  '账户创建 -- 新增':'賬戶創建 -- 新增',
  '请先选择目标库！':'請先選擇目標庫！',
  '目标库不能为空':'目標庫不能為空',
  '修改权限 --':'修改權限 --',
  '请填写用户名！':'請填寫用戶名！',
  '其他库权限':'其他庫權限',
  '当前库权限':'當前庫權限',
  '请先选择第':'請先選擇第',
  '目标库:':'目標庫:',
  '用户名:':'用戶名:',
  '用户管理':'用戶管理',
  '权限类型':'權限類型',
  '条数据库':'條數據庫',
  '用户名':'用戶名',
  '条角色':'條角色',
  '新建':'新建',
  '角色':'角色',
  '用户':'用戶',
  '账号需要具备INSERT, CREATE, DROP, SUPER, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限':'賬號需要具備INSERT, CREATE, DROP, SUPER, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER權限',
  '账号需要具备所有迁移对象的SELECT, RELOAD, SHOW VIEW, EVENT, TRIGGER，及MySQL系统库的SELECT权限':'賬號需要具備所有遷移對象的SELECT, RELOAD, SHOW VIEW, EVENT, TRIGGER，及MySQL系統庫的SELECT權限',
  '2.全量数据迁移时，迁移的表需与源端表结构一致，且目标端表数据为空，不能存在外键约束。':'2.全量數據遷移時，遷移的表需與源端表結構一致，且目標端表數據為空，不能存在外鍵約束。',
  '1.全量数据迁移过程中，如果源库有数据更新，这部分更新数据不保证被迁移到目标实例；':'1.全量數據遷移過程中，如果源庫有數據更新，這部分更新數據不保證被遷移到目標實例；',
  '检查目标端表结构是否适用于源端 （Oracle表列名必须大写）':'檢查目標端表結構是否適用於源端 （Oracle表列名必須大寫）',
  '2.全量数据迁移时：源端与目标端用户要有DML权限。':'2.全量數據遷移時：源端與目標端用戶要有DML權限。',
  '检查目的库是否存在跟待迁移对象同名的结构对象':'檢查目的庫是否存在跟待遷移對象同名的結構對象',
  '提示：建议采用大写字母，小写字母默认转成大写字母。':'提示：建議採用大寫字母，小寫字母默認轉成大寫字母。',
  '检查目标端数据库的账号权限是否满足迁移要求':'檢查目標端數據庫的賬號權限是否滿足遷移要求',
  '已选择的目标端信息有误，连接数据库失败！':'已選擇的目標端信息有誤，連接數據庫失敗！',
  '检查数据迁移服务器是否能连通目的数据库':'檢查數據遷移服務器是否能連通目的數據庫',
  '检查数据迁移服务器是否能连通源数据库':'檢查數據遷移服務器是否能連通源數據庫',
  '结构迁移时：源端用户要有DML权限':'結構遷移時：源端用戶要有DML權限',
  '目标库不存在相同表名，请重新编辑!':'目標庫不存在相同表名，請重新編輯!',
  '目标库存在相同表名，请重新编辑!':'目標庫存在相同表名，請重新編輯!',
  '检查源库是否存在待迁移的结构对象': '檢查源庫是否存在待遷移的結構對象',
  '目标数据湖连通性检查': '目標數據湖連通性檢查',
  '检查目标数据库湖系统连通性':'檢查目標數據庫湖系統連通性',
  '检查目标端是否信任存储函数创建者':'檢查目標端是否信任存儲函數創建者',
  '源库实例与目标库实例不能相同！':'源庫實例與目標庫實例不能相同！',
  '目标端库名已存在，请重新编辑！':'目標端庫名已存在，請重新編輯！',
  '预检查成功，不能返回上一步！':'預檢查成功，不能返回上一步！',
  '目标端库对象数据存在性检查':'目標端庫對象數據存在性檢查',
  '预检查失败，不能启动迁移！':'預檢查失敗，不能啟動遷移！',
  '检查目标端库中表是否为空':'檢查目標端庫中表是否為空',
  '源库目标库表结构适用检查':'源庫目標庫表結構適用檢查',
  '任务名长度为2-64位！':'任務名長度為2-64位！',
  '请完整填写迁移对象信息！':'請完整填寫遷移對象信息！',
  '目标端信任存储函数检查':'目標端信任存儲函數檢查',
  '目标库测试连接不通过!':'目標庫測試連接不通過!',
  '迁移类型至少选择一个！':'遷移類型至少選擇一個！',
  '新增目标端表空间成功！':'新增目標端表空間成功！',
  '目标端对象存在性检查':'目標端對象存在性檢查',
  '源库测试连接不通过!':'源庫測試連接不通過!',
  '新增目标端用户成功！':'新增目標端用戶成功！',
  '目标端表空间已存在！':'目標端表空間已存在！',
  '不能存在同库同表名!':'不能存在同庫同表名!',
  '任务名重复，请修改':'任務名重覆，請修改',
  '请先选择迁移类型！':'請先選擇遷移類型！',
  '请先选择迁移对象！':'請先選擇遷移對象！',
  '新增目标端表成功！':'新增目標端表成功！',
  '目标端用户已存在！':'目標端用戶已存在！',
  '源库对象存在性检查':'源庫對象存在性檢查',
  '请输入数据库账号':'請輸入數據庫賬號',
  '请输入数据库密码':'請輸入數據庫密碼',
  '目的库连接性检查':'目的庫連接性檢查',
  '目标端库权限检查':'目標端庫權限檢查',
  'ECS自建数据库':'ECS自建數據庫',
  '请先填写任务名！':'請先填寫任務名！',
  '目标端表已存在！':'目標端表已存在！',
  '请输入任务名称':'請輸入任務名稱',
  '目标端表空间：':'目標端表空間：',
  '源库连接性检查':'源庫連接性檢查',
  '立即购买并启动':'立即購買並啟動',
  '迁移类型及列表':'遷移類型及列表',
  '请先测试连接!':'請先測試連接!',
  '请先选择租户!':'請先選擇租戶!',
  '库账号与密码!':'庫賬號與密碼!',
  '库实例列表!':'庫實例列表!',
  '非RAC实例':'非RAC實例',
  '目标端用户：':'目標端用戶：',
  '源库及目标库':'源庫及目標庫',
  'RDS数据库':'RDS數據庫',
  '全量数据迁移':'全量數據遷移',
  '库实例类型!':'庫實例類型!',
  '启动成功 !':'啟動成功 !',
  '库应用环境!':'庫應用環境!',
  '库IP地址!':'庫IP地址!',
  '目标端表空间':'目標端表空間',
  '目标库实例':'目標庫實例',
  '温馨提示：':'溫馨提示：',
  '数据库密码':'數據庫密碼',
  '目标库信息':'目標庫信息',
  '源端用户：':'源端用戶：',
  '任务名称:':'任務名稱:',
  'RAC实例':'RAC實例',
  '目标库IP':'目標庫IP',
  '新增数据表':'新增數據表',
  '新增数据库':'新增數據庫',
  '库的项目!':'庫的項目!',
  '目标端用户':'目標端用戶',
  '任务名称':'任務名稱',
  '源库信息':'源庫信息',
  '实例类型':'實例類型',
  '实例列表':'實例列表',
  '实例地区':'實例地區',
  '迁移级别':'遷移級別',
  '迁移类型':'遷移類型',
  '目标端：':'目標端：',
  '检测内容':'檢測內容',
  '检测结果':'檢測結果',
  '测试连接':'測試連接',
  '源库实例':'源庫實例',
  '源库IP':'源庫IP',
  '连接成功':'連接成功',
  '连接失败':'連接失敗',
  '诊断内容':'診斷內容',
  '诊断结果':'診斷結果',
  '数据迁移':'數據遷移',
  '结构迁移':'結構遷移',
  '用户级别':'用戶級別',
  '目标端表':'目標端表',
  '请先选择':'請先選擇',
  '请先填写':'請先填寫',
  '库端口!':'庫端口!',
  '检测项':'檢測項',
  '预检查':'預檢查',
  '表级别':'表級別',
  '目标端':'目標端',
  '源端：':'源端：',
  '目标':'目標',
  '源':'源',
  '数据迁移详情':'數據遷移詳情',
  '目标端迁移账号':'目標端遷移賬號',
  '目标端项目名称':'目標端項目名稱',
  '增量数据迁移':'增量數據遷移',
  '源端项目名称':'源端項目名稱',
  '源端迁移账号':'源端遷移賬號',
  '目标端库端口':'目標端庫端口',
  '目标端库类型':'目標端庫類型',
  '目标数据表':'目標數據表',
  '源端库类型':'源端庫類型',
  '目标端IP':'目標端IP',
  '源端库端口':'源端庫端口',
  '目标数据库':'目標數據庫',
  '迁移对象':'遷移對象',
  '源数据库':'源數據庫',
  '源数据表':'源數據表',
  '迁移完成':'遷移完成',
  '迁移失败':'遷移失敗',
  '任务ID':'任務ID',
  '用户ID':'用戶ID',
  '源端IP':'源端IP',
  '租户名称':'租戶名稱',
  '迁移中':'遷移中',
  '未迁移':'未遷移',
  '库级别':'庫級別',
  '数据迁移DTS 操作指南':'數據遷移DTS 操作指南',
  '迁移中状态禁止删除!':'遷移中狀態禁止刪除!',
  '目标端数据库类型':'目標端數據庫類型',
  '源端数据库类型':'源端數據庫類型',
  '目标端可用区':'目標端可用區',
  '目标端项目':'目標端項目',
  '迁移任务名':'遷移任務名',
  '源端可用区':'源端可用區',
  '源端项目':'源端項目',
  '迁移任务':'遷移任務',
  '任务名':'任務名',
  '数据库名由小写字母、数字、中划线、下划线组成，字母开头，字母或数字结尾':'數據庫名由小寫字母、數字、中劃線、下劃線組成，字母開頭，字母或數字結尾',
  '表名由小写字母、数字、中划线、下划线组成，字母开头，字母或数字结尾':'表名由小寫字母、數字、中劃線、下劃線組成，字母開頭，字母或數字結尾',
  '数据库binlog需设为ROW模式，默认从当前位点开始同步数据':'數據庫binlog需設為ROW模式，默認從當前位點開始同步數據',
  '检查目的库是否存在跟待同步对象同名的结构对象':'檢查目的庫是否存在跟待同步對象同名的結構對象',
  '检查目的数据库的账号权限是否满足同步要求':'檢查目的數據庫的賬號權限是否滿足同步要求',
  '检查数据传输服务器是否能连通目的数据库':'檢查數據傳輸服務器是否能連通目的數據庫',
  '检查源数据库的binlog模式是否合法':'檢查源數據庫的binlog模式是否合法',
  '检查源数据库的账号权限是否满足同步要求':'檢查源數據庫的賬號權限是否滿足同步要求',
  '检查数据传输服务器是否能连通源数据库':'檢查數據傳輸服務器是否能連通源數據庫',
  '检查源数据库是否开启binlog':'檢查源數據庫是否開啟binlog',
  '源库server_id检查': '源庫server_id檢查',
  '检查源表与目标表结构是否一致':'檢查源表與目標表結構是否一致',
  '预检查失败，不能启动同步！':'預檢查失敗，不能啟動同步！',
  '源库binlog模式检查':'源庫binlog模式檢查',
  '源和目标表是否有主键检查':'源和目標表是否有主鍵檢查',
  '检查源和目标表是否有主键':'檢查源和目標表是否有主鍵',
  '任务名长度为2-32位！':'任務名長度為2-32位！',
  '请完整填写同步对象信息！':'請完整填寫同步對象信息！',
  '源库binlog开启检查':'源庫binlog開啟檢查',
  '数据库名不能重复新增':'數據庫名不能重覆新增',
  '新增目标端表名成功！':'新增目標端表名成功！',
  '源与目标表结构检查':'源與目標表結構檢查',
  '目标端表名已存在！':'目標端表名已存在！',
  '同步表必须有主键':'同步表必須有主鍵',
  '目的库权限检查':'目的庫權限檢查',
  '全量数据初始化':'全量數據初始化',
  '任务名已存在！':'任務名已存在！',
  '源库权限检查':'源庫權限檢查',
  '选择同步对象':'選擇同步對象',
  '实例可用区':'實例可用區',
  '同步架构：':'同步架構：',
  '温馨提示:':'溫馨提示:',
  '结构初始化':'結構初始化',
  '配置链路':'配置鏈路',
  '单向同步':'單向同步',
  '初始化：':'初始化：',
  '立即启动':'立即啟動',
  '目标表':'目標表',
  '序号':'序號',
  'large规格的线上运行性能依赖于网络环境、源实例和目标实例的性能。':'large規格的線上運行性能依賴於網絡環境、源實例和目標實例的性能。',
  '源实例可用区:':'源實例可用區:',
  '目标可用区:':'目標可用區:',
  '目标数据库类型':'目標數據庫類型',
  '源数据库类型':'源數據庫類型',
  '目标实例:':'目標實例:',
  '同步拓扑:':'同步拓撲:',
  '链路规格:':'鏈路規格:',
  '购买数量:':'購買數量:',
  '目标实例':'目標實例',
  '同步拓扑':'同步拓撲',
  '链路规格':'鏈路規格',
  '购买数量':'購買數量',
  '源实例:':'源實例:',
  '创建任务':'創建任務',
  '源实例':'源實例',
  '无限制':'無限制',
  '数据传输详情':'數據傳輸詳情',
  '增量数据同步':'增量數據同步',
  '初始化失败':'初始化失敗',
  '连接信息':'連接信息',
  '同步对象':'同步對象',
  '初始化中':'初始化中',
  '双向同步':'雙向同步',
  '同步类型':'同步類型',
  '同步账号':'同步賬號',
  '同步中':'同步中',
  '未配置':'未配置',
  '类别':'類別',
  '源端':'源端',
  '异常':'異常',
  '数据传输DTS 操作指南':'數據傳輸DTS 操作指南',
  '同步中状态禁止删除!':'同步中狀態禁止刪除!',
  '停止成功 !':'停止成功 !',
  '传输任务名':'傳輸任務名',
  '购买链路':'購買鏈路',
  '同步任务':'同步任務',
  '最小磁盘(GB)':'最小磁盤(GB)',
  '最小内存(MB)':'最小內存(MB)',
  '大小(GB)':'大小(GB)',
  '云主机详情':'雲主機詳情',
  '磁盘列表':'磁盤列表',
  '磁盘类型':'磁盤類型',
  '硬盘类型':'硬盤類型',
  '快照列表':'快照列表',
  '系统版本':'系統版本',
  '已挂载':'已掛載',
  '磁盘名':'磁盤名',
  '设备名':'設備名',
  '快照名':'快照名',
  '格式':'格式',
  '空闲':'空閑',
  '云主机':'雲主機',
  '云主机容量':'雲主機容量',
  '物理机容量':'物理機容量',
  '备份策略ID':'備份策略ID',
  '备份计划ID':'備份計劃ID',
  '备份计划名称':'備份計劃名稱',
  '主机实例名称':'主機實例名稱',
  '备份策略名称':'備份策略名稱',
  '备份部分成功':'備份部分成功',
  '备份主机名':'備份主機名',
  '备份进行中':'備份進行中',
  '策略类型':'策略類型',
  '暂停备份':'暫停備份',
  '备份成功':'備份成功',
  '策略名称':'策略名稱',
  '备份失败':'備份失敗',
  '数据量':'數據量',
  '恢复':'恢復',
  '周期':'周期',
  '单次':'單次',
  '文件系统和挂载点请同时配置，只配置其中一项无效!':'文件系統和掛載點請同時配置，只配置其中一項無效!',
  '目前仅支持输入10个以内数量的IP!':'目前僅支持輸入10個以內數量的IP!',
  '/路径名称，如：/rh/data':'/路徑名稱，如：/rh/data',
  '所选子网可用ip数不足 !':'所選子網可用ip數不足 !',
  '请选择有效的云主机类型 !':'請選擇有效的雲主機類型 !',
  'IOPS读/写总(次s)':'IOPS讀/寫總(次s)',
  '必填，请输入部署单元名称':'必填，請輸入部署單元名稱',
  '请选择有效的系统版本 !':'請選擇有效的系統版本 !',
  '带宽读/写总(KBs)':'帶寬讀/寫總(KBs)',
  '挂载路径填写不规范!':'掛載路徑填寫不規範!',
  '请选择云硬盘类型 !':'請選擇雲硬盤類型 !',
  '部署单元创建成功！':'部署單元創建成功！',
  '带宽(Mbps)':'帶寬(Mbps)',
  '无可用主机机型':'無可用主機機型',
  '公网IP类型':'公網IP類型',
  '需要公网IP':'需要公網IP',
  '已被使用了！':'已被使用了！',
  'GPU数量':'GPU數量',
  '专属宿主机':'專屬宿主機',
  'MB内存、':'MB內存、',
  '个IP和第':'個IP和第',
  '个IP相同':'個IP相同',
  '云主机购买':'雲主機購買',
  '请先修改!':'請先修改!',
  '云主机类型':'雲主機類型',
  '镜像提供方':'鏡像提供方',
  '云硬盘类型':'雲硬盤類型',
  '共享镜像':'共享鏡像',
  '固定宽带':'固定寬帶',
  '文件系统':'文件系統',
  '挂载路径':'掛載路徑',
  '按流量':'按流量',
  '架构':'架構',
  '平台':'平臺',
  '第':'第',
  '建议8位以上，包含大小写字母、数字、下划线':'建議8位以上，包含大小寫字母、數字、下劃線',
  '最小磁盘和最小内存只能填整数!':'最小磁盤和最小內存只能填整數!',
  '没有可以解除的可用区了！':'沒有可以解除的可用區了！',
  '没有可以同步的可用区了！':'沒有可以同步的可用區了！',
  '必填,2-32字符':'必填,2-32字符',
  '审核失败ailed':'審核失敗ailed',
  '请先填写最小磁盘!':'請先填寫最小磁盤!',
  '请先填写最小内存!':'請先填寫最小內存!',
  '请先选择操作系统!':'請先選擇操作系統!',
  '请先选择文件格式!':'請先選擇文件格式!',
  '请先选择可用区!':'請先選擇可用區!',
  '文件上传成功!':'文件上傳成功!',
  '解除镜像成功！':'解除鏡像成功！',
  '同步镜像成功！':'同步鏡像成功！',
  '安全审核状态:':'安全審核狀態:',
  '请先上传文件!':'請先上傳文件!',
  '没有可选可用区':'沒有可選可用區',
  '安全审批状态':'安全審批狀態',
  '请选择可用区':'請選擇可用區',
  '支持密码注入': '支持密碼註入',
  '请提前在镜像中安装cloud-init软件':'請提前在鏡像中安裝cloud-init軟件',
  '同步至可用区':'同步至可用區',
  '大小(MB)':'大小(MB)',
  '审核结果说明':'審核結果說明',
  'root密码':'root密碼',
  '可用区配置':'可用區配置',
  '操作系统:':'操作系統:',
  '文件格式:':'文件格式:',
  '解除可用区':'解除可用區',
  '单位:MB':'單位:MB',
  '审核成功':'審核成功',
  '审核失败':'審核失敗',
  '上传成功':'上傳成功',
  '上传失败':'上傳失敗',
  '新增镜像':'新增鏡像',
  '镜像配置':'鏡像配置',
  '最小内存':'最小內存',
  '最小磁盘':'最小磁盤',
  '单位:G':'單位:G',
  '待审核':'待審核',
  '文件:':'文件:',
  '上传中':'上傳中',
  '排序值':'排序值',
  '公开':'公開',
  '数字':'數字',
  '先添加操作数据':'先添加操作數據',
  '公网IP':'公網IP',
  '操作用户':'操作用戶',
  '操作IP':'操作IP',
  '操作类型':'操作類型',
  '操作日志':'操作日誌',
  '挂载磁盘':'掛載磁盤',
  '操作时间':'操作時間',
  '设备':'設備',
  '必填,2-60字符':'必填,2-60字符',
  '必填,http地址':'必填,http地址',
  '排序值只能填整数!':'排序值只能填整數!',
  '请选择可用区!':'請選擇可用區!',
  '操作系统类型':'操作系統類型',
  '文件URL':'文件URL',
  '必填,数字':'必填,數字',
  '发行版本':'發行版本',
  '勾选挂载的云硬盘后，删除云主机同时将删除云硬盘，请确认数据已备份':'勾選掛載的雲硬盤後，刪除雲主機同時將刪除雲硬盤，請確認數據已備份',
  '此云硬盘中存在快照记录，请删除快照记录后删除云硬盘':'此雲硬盤中存在快照記錄，請刪除快照記錄後刪除雲硬盤',
  '操作指令已发出，请关注状态变化！':'操作指令已發出，請關註狀態變化！',
  '描述字段长度为2-60个字符！':'描述字段長度為2-60個字符！',
  '请卸载云硬盘后再操作重建主机':'請卸載雲硬盤後再操作重建主機',
  '主机该状态下无法打开控制台！':'主機該狀態下無法打開控制台！',
  '购买硬盘请求已发送成功 !':'購買硬盤請求已發送成功 !',
  '磁盘挂载命令已发出 !':'磁盤掛載命令已發出 !',
  '云主机没有挂载磁盘 !':'雲主機沒有掛載磁盤 !',
  '云主机ECS 操作指南':'雲主機ECS 操作指南',
  '该云主机已经解锁 !':'該雲主機已經解鎖 !',
  '该云主机系统已经挂载':'該雲主機系統已經掛載',
  '当前状态不允许解绑！':'當前狀態不允許解綁！',
  '该云主机已经锁定 !':'該雲主機已經鎖定 !',
  '重建命令已发送成功！':'重建命令已發送成功！',
  '没有可绑定的eip':'沒有可綁定的eip',
  '磁盘类型 不能为空':'磁盤類型 不能為空',
  '迁移命令发送成功！':'遷移命令發送成功！',
  '重建后将无法启动':'重建後將無法啟動',
  '磁盘列表获取为空':'磁盤列表獲取為空',
  '确定锁定该云主机':'確定鎖定該雲主機',
  'ECS 帮助文档':'ECS 幫助文檔',
  '堡垒机 操作指南':'堡壘機 操作指南',
  '请选择专有宿主机':'請選擇專有宿主機',
  '请先选择机器 !':'請先選擇機器 !',
  '该云主机已经锁定,不允许销毁 !':'該雲主機已經鎖定,不允許銷毀 !',
  '确定解锁该云主机':'確定解鎖該雲主機',
  '磁盘卸载成功 !':'磁盤卸載成功 !',
  '请先选择eip！':'請先選擇eip！',
  '暂不支持快照服务':'暫不支持快照服務',
  '路径名称，如：':'路徑名稱，如：',
  '编辑修改成功！':'編輯修改成功！',
  '请选择配置 !':'請選擇配置 !',
  '配置修改成功！':'配置修改成功！',
  '重建云主机失败':'重建雲主機失敗',
  '绑定申请成功！':'綁定申請成功！',
  '解绑申请成功！':'解綁申請成功！',
  '可绑定EIP':'可綁定EIP',
  '无法绑定 !':'無法綁定 !',
  '修改公网带宽':'修改公網帶寬',
  '修改配置确认':'修改配置確認',
  '共享计算节点':'共享計算節點',
  '弹性网卡列表':'彈性網卡列表',
  '快速购买硬盘':'快速購買硬盤',
  '确定解绑该':'確定解綁該',
  '宿主机迁移':'宿主機遷移',
  '个云数据盘':'個雲數據盤',
  '所在可用区':'所在可用區',
  '硬重启主机':'硬重啟主機',
  '目标宿主机':'目標宿主機',
  '删除成功！':'刪除成功！',
  '检查源数据库是否设置server_id大于1': '檢查源數據庫是否設置server_id大於1',
  '数据删除成功 !':'數據刪除成功 !',
  '磁盘类型:':'磁盤類型:',
  '当前宿主机':'當前宿主機',
  '绑定eip':'綁定eip',
  '云主机迁移':'雲主機遷移',
  '请选择配置':'請選擇配置',
  '解绑eip':'解綁eip',
  'EIP绑定':'EIP綁定',
  '确定进行':'確定進行',
  '购买磁盘':'購買磁盤',
  '当前配置':'當前配置',
  '卸载磁盘':'卸載磁盤',
  '创建快照':'創建快照',
  '重建确认':'重建確認',
  '迁移备注':'遷移備註',
  '磁盘挂载':'磁盤掛載',
  '硬重启':'硬重啟',
  '(固-':'(固-',
  '重建':'重建',
  '名字':'名字',
  '全选':'全選',
  '数据统计来源不同：基础监控的统计数据来源于虚拟化层，操作系统监控的统计数据来源于虚拟机内部。':'數據統計來源不同：基礎監控的統計數據來源於虛擬化層，操作系統監控的統計數據來源於虛擬機內部。',
  '操作系统统计频率是10秒，所以如果监控数据波动比较大时，数据被削峰填谷导致数据不一致。':'操作系統統計頻率是10秒，所以如果監控數據波動比較大時，數據被削峰填谷導致數據不一致。',
  '统计频率不同:监控图表中提供的数据均为统计周期内的平均值，基础监控统计频率是1分钟，':'統計頻率不同:監控圖表中提供的數據均為統計周期內的平均值，基礎監控統計頻率是1分鐘，',
  '您在查看基础监控和操作系统监控数据时，可能会存在数据不一致的情况，主要有以下原因：':'您在查看基礎監控和操作系統監控數據時，可能會存在數據不一致的情況，主要有以下原因：',
  '所以会出现操作系统监控的数据和基础监控数据不一致的情况':'所以會出現操作系統監控的數據和基礎監控數據不一致的情況',
  '（即插件采集的数据和虚拟化层采集的数据不同）。':'（即插件採集的數據和虛擬化層採集的數據不同）。',
  '网卡入口包速率':'網卡入口包速率',
  '网卡出口包速率':'網卡出口包速率',
  '网卡出口流量':'網卡出口流量',
  '网卡入口流量':'網卡入口流量',
  '卷IO利用率':'捲IO利用率',
  '操作系统监控':'操作系統監控',
  '卷写入速率':'捲寫入速率',
  '卷读写延时':'捲讀寫延時',
  '云主机信息':'雲主機信息',
  '卷读取速率':'捲讀取速率',
  '基础监控':'基礎監控',
  'windows操作系统的云主机安装备份软件，安装流程参照':'windows操作系統的雲主機安裝備份軟件，安裝流程參照',
  'windows操作系统的云主机安装备份软件，':'windows操作系統的雲主機安裝備份軟件，',
  '需要恢复目录或者多个文件，请输入如':'需要恢複目錄或者多個文件，請輸入如',
  '确定覆盖后将把同名文件进行覆盖，':'確定覆蓋後將把同名文件進行覆蓋，',
  '工作，必须以C-Z任一字符加:':'工作，必須以C-Z任一字符加:',
  '多个文件路径支持以换行符分隔':'多個文件路徑支持以換行符分隔',
  '需要恢复单个文件，请输入如':'需要恢復單個文件，請輸入如',
  '每一行一个路径，例如：':'每一行一個路徑，例如：',
  '请先配置恢复路径!':'請先配置恢復路徑!',
  '请先配置恢复记录!':'請先配置恢復記錄!',
  'ECS备份帮助文档':'ECS備份幫助文檔',
  '请先配置恢复名称!':'請先配置恢複名稱!',
  '请先选择恢复主机!':'請先選擇恢復主機!',
  '已选恢复备份记录':'已選恢復備份記錄',
  '请输入文件列表!':'請輸入文件列表!',
  '备份-文件列表':'備份-文件列表',
  '创建ECS恢复':'創建ECS恢復',
  '请输入路径：如':'請輸入路徑：如',
  '请输入文件路径':'請輸入文件路徑',
  '无可选备份记录':'無可選備份記錄',
  '恢复至其他主机':'恢復至其他主機',
  '覆盖同名文件':'覆蓋同名文件',
  '包含下列文件':'包含下列文件',
  '请谨慎操作。':'請謹慎操作。',
  '包含所有文件':'包含所有文件',
  '输入文件列表':'輸入文件列表',
  '恢复至源主机':'恢復至源主機',
  '格式1：D:':'格式1：D:',
  '配置恢复原则':'配置恢複原則',
  '源主机名称':'源主機名稱',
  '点击下载。':'點擊下載。',
  '恢复规则':'恢復規則',
  '备份时间':'備份時間',
  '恢复路径':'恢復路徑',
  '云主机名':'雲主機名',
  '操作系统':'操作系統',
  '格式2：':'格式2：',
  '目标主机':'目標主機',
  '确认恢复':'確認恢復',
  '目标路径':'目標路徑',
  '恢复名称':'恢複名稱',
  '原目录':'原目錄',
  '查看':'查看',
  '开头':'開頭',
  '恢复所选备份数据':'恢復所選備份數據',
  '源主机可用区':'源主機可用區',
  '目标主机IP':'目標主機IP',
  '源主机IP':'源主機IP',
  '恢复目录':'恢複目錄',
  '恢复主机':'恢復主機',
  '恢复失败':'恢復失敗',
  '部分成功':'部分成功',
  '源主机':'源主機',
  '恢复中':'恢復中',
  '云主机快照详情':'雲主機快照詳情',
  '源主机名':'源主機名',
  '排序':'排序',
  '云主机快照列表':'雲主機快照列表',
  'windows操作系统的云主机安装备份软件':'windows操作系統的雲主機安裝備份軟件',
  '请选择需要备份的云主机实例':'請選擇需要備份的雲主機實例',
  '请先输入正确格式文件路径':'請先輸入正確格式文件路徑',
  '创建ECS策略备份':'創建ECS策略備份',
  'C-Z任一字符加:':'C-Z任一字符加:',
  '备份周期具体天数':'備份周期具體天數',
  '请先配置保留时间':'請先配置保留時間',
  '添加增量备份计划':'添加增量備份計劃',
  '无符合条件云主机':'無符合條件雲主機',
  '请先输入文件列表':'請先輸入文件列表',
  '选择备份的文件':'選擇備份的文件',
  '备份保留时间':'備份保留時間',
  '配置备份策略':'配置備份策略',
  '包括所有文件':'包括所有文件',
  '云主机实例':'雲主機實例',
  '文件路径':'文件路徑',
  '文件列表':'文件列表',
  '备份名称':'備份名稱',
  '按量计费':'按量計費',
  '添加主机':'添加主機',
  '确认备份':'確認備份',
  '请先配置':'請先配置',
  '备份文件':'備份文件',
  '计费方式':'計費方式',
  '点击下载':'點擊下載',
  '加入右侧':'加入右側',
  '加入左侧':'加入左側',
  '源文件':'源文件',
  '工作':'工作',
  '点击确定后，备份任务立即执行':'點擊確定後，備份任務立即執行',
  '只有备份成功才可恢复！':'只有備份成功才可恢復！',
  '确定立即执行备份任务吗':'確定立即執行備份任務嗎',
  '立即备份请求发送成功！':'立即備份請求發送成功！',
  '确定启用备份策略吗':'確定啟用備份策略嗎',
  '确定禁用备份策略吗':'確定禁用備份策略嗎',
  '备份策略创建失败':'備份策略創建失敗',
  '当前条件暂无数据':'當前條件暫無數據',
  '备份策略创建成功':'備份策略創建成功',
  '备份软件安装失败':'備份軟件安裝失敗',
  '备份数据成功率':'備份數據成功率',
  '备份策略创建中':'備份策略創建中',
  '请选择时间区间':'請選擇時間區間',
  '备份软件安装中':'備份軟件安裝中',
  '目标主机可用区':'目標主機可用區',
  '创建策略失败':'創建策略失敗',
  '备份策略处于':'備份策略處於',
  '策略创建失败':'策略創建失敗',
  '备份开始时间':'備份開始時間',
  '编辑备份计划':'編輯備份計劃',
  '创建备份计划':'創建備份計劃',
  '查看备份历史':'查看備份歷史',
  '备份策略详情':'備份策略詳情',
  '主机IP地址':'主機IP地址',
  '主机操作系统':'主機操作系統',
  '备份文件:':'備份文件:',
  '软件安装中':'軟件安裝中',
  '禁用成功！':'禁用成功！',
  '备份计划数':'備份計劃數',
  '备份数据量':'備份數據量',
  '选择日期:':'選擇日期:',
  '策略创建中':'策略創建中',
  '启用成功！':'啟用成功！',
  '目标主机名':'目標主機名',
  '备份计划':'備份計劃',
  '安装失败':'安裝失敗',
  '立即备份':'立即備份',
  '成功记录':'成功記錄',
  '创建失败':'創建失敗',
  '创建成功':'創建成功',
  '保留周期':'保留周期',
  '主机名称':'主機名稱',
  '策略ID':'策略ID',
  '失败数':'失敗數',
  '成功数':'成功數',
  '状态，':'狀態，',
  '价格':'價格',
  '总量':'總量',
  '每周':'每周',
  '允许':'允許',
  '四':'四',
  '六':'六',
  '不':'不',
  '五':'五',
  '三':'三',
  '二':'二',
  '一':'一',
  '个':'個',
  '号':'號',
  '多个文件路径支持以逗号/换行符分隔':'多個文件路徑支持以逗號/換行符分隔',
  '请先配置文件路径':'請先配置文件路徑',
  'ECS实例IP':'ECS實例IP',
  '软件安装失败':'軟件安裝失敗',
  '修改备份策略':'修改備份策略',
  '增加备份计划':'增加備份計劃',
  '云主机ID':'雲主機ID',
  '是否启用':'是否啟用',
  '计划数':'計劃數',
  '名称不能以http://或https://开头 !:':'名稱不能以http://或https://開頭 !:',
  '描述不能以http://或https://开头 !':'描述不能以http://或https://開頭 !',
  '该操作涉及价格，请先配置NAT网关！':'該操作涉及價格，請先配置NAT網關！',
  '该操作涉及价格，请先配置合适线路！':'該操作涉及價格，請先配置合適線路！',
  '请先填写不少于两个字符的名称!':'請先填寫不少於兩個字符的名稱!',
  '当前选项下暂无路线，请修改配置':'當前選項下暫無路線，請修改配置',
  '非必填，2-60个字符':'非必填，2-60個字符',
  '必填，2-60个字符':'必填，2-60個字符',
  '创建NAT':'創建NAT',
  'EIP购买':'EIP購買',
  '线路':'線路',
  'EIP详情':'EIP詳情',
  '付费类型':'付費類型',
  '锁定原因':'鎖定原因',
  '绑定主机':'綁定主機',
  '已分配':'已分配',
  '绑定中':'綁定中',
  '解绑中':'解綁中',
  '可用':'可用',
  '已分配状态不允许删除！':'已分配狀態不允許刪除！',
  '没有同网段可绑定的主机':'沒有同網段可綁定的主機',
  '已分配状态不允许绑定！':'已分配狀態不允許綁定！',
  '当前状态不允许绑定！':'當前狀態不允許綁定！',
  '没有可解绑的云主机！':'沒有可解綁的雲主機！',
  '当前状态不允许删除！':'當前狀態不允許刪除！',
  'EIP 操作指南':'EIP 操作指南',
  '请先选择IP！':'請先選擇IP！',
  '可绑定云主机':'可綁定雲主機',
  '所属运营商':'所屬運營商',
  '绑定':'綁定',
  '解绑':'解綁',
  'IP地址或者cidr，多个IP支持以逗号/空格/换行符分隔':'IP地址或者cidr，多個IP支持以逗號/空格/換行符分隔',
  '】的后缀,后缀由大小写英文字母、数字、中划线、下划线组成':'】的後綴,後綴由大小寫英文字母、數字、中劃線、下劃線組成',
  '】的前缀,前缀由大小写英文字母、数字、中划线、下划线组成':'】的前綴,前綴由大小寫英文字母、數字、中劃線、下劃線組成',
  '多文件总容量最大为20M，请重新上传！':'多文件總容量最大為20M，請重新上傳！',
  ',目标端口数值要满足1~65535 !':',目標端口數值要滿足1~65535 !',
  '该组配置正在进行编辑，不允许删除!':'該組配置正在進行編輯，不允許刪除!',
  '文件大于10M，请重新上传！':'文件大於10M，請重新上傳！',
  '前缀必填，字符长度1-60':'前綴必填，字符長度1-60',
  '后缀选填，字符长度0-40':'後綴選填，字符長度0-40',
  '单文件最大容量为10M，':'單文件最大容量為10M，',
  '前缀根据项目自动匹配':'前綴根據項目自動匹配',
  '请正确填写【目标系统':'請正確填寫【目標系統',
  '请先选择【目标系统':'請先選擇【目標系統',
  '重新提交请求已发送':'重新提交請求已發送',
  '请正确填写【源系统':'請正確填寫【源系統',
  '请正确填写目标端口':'請正確填寫目標端口',
  '请先填写申请理由':'請先填寫申請理由',
  '字符长度0-40':'字符長度0-40',
  '是否为临时策略':'是否為臨時策略',
  '请检查书写规范':'請檢查書寫規範',
  '确认请求已发送':'確認請求已發送',
  '新增防火墙策略':'新增防火牆策略',
  '请正确填写【':'請正確填寫【',
  '】的起止时间':'】的起止時間',
  '】的目标端口':'】的目標端口',
  '安全规则试算':'安全規則試算',
  '已申请提交!':'已申請提交!',
  '正在编辑中':'正在編輯中',
  '添加源系统':'添加源系統',
  '删除源系统':'刪除源系統',
  '的目标端口':'的目標端口',
  '单文件过大':'單文件過大',
  '请先填写【':'請先填寫【',
  '上传文件':'上傳文件',
  '试算结果':'試算結果',
  '后缀选填':'後綴選填',
  '目标系统':'目標系統',
  '目标IP':'目標IP',
  '目标端口':'目標端口',
  '试算条件':'試算條件',
  '立即提交':'立即提交',
  '】的协议':'】的協議',
  '协议类型':'協議類型',
  '重新提交':'重新提交',
  '尚无数据':'尚無數據',
  '起至时间':'起至時間',
  '起止时间':'起止時間',
  '选择时间':'選擇時間',
  '】的前缀':'】的前綴',
  '申请理由':'申請理由',
  '源系统':'源系統',
  '源IP':'源IP',
  '】的【':'】的【',
  '系统':'系統',
  '试算':'試算',
  '】的':'】的',
  '的':'的',
  '请先选择要下载的文件':'請先選擇要下載的文件',
  '防火墙策略详情':'防火牆策略詳情',
  '审核不通过':'審核不通過',
  '下载附件':'下載附件',
  '签批时间':'簽批時間',
  '申请失败':'申請失敗',
  '审批流程':'審批流程',
  '审批结果':'審批結果',
  '审批人':'審批人',
  '下发中':'下發中',
  '同意':'同意',
  '驳回':'駁回',
  '步骤':'步驟',
  '意见':'意見',
  '请正确填写目标端口,目标端口数值要满足1~65535 !':'請正確填寫目標端口,目標端口數值要滿足1~65535 !',
  '防火墙FW 操作指南':'防火牆FW 操作指南',
  '防火墙策略':'防火牆策略',
  '审批单号':'審批單號',
  '修改时间':'修改時間',
  '验证':'驗證',
  '当不选择任何权限时，则会取消以上所选用户对应所选云主机的堡垒机权限':'當不選擇任何權限時，則會取消以上所選用戶對應所選雲主機的堡壘機權限',
  '云主机 不能为空':'雲主機 不能為空',
  '设置权限成功！':'設置權限成功！',
  '请先选择用户！':'請先選擇用戶！',
  '批量授权成功！':'批量授權成功！',
  '用户 不能为空':'用戶 不能為空',
  'NUC用户':'NUC用戶',
  '云主机:':'雲主機:',
  '设置权限':'設置權限',
  '用户类型':'用戶類型',
  '暂无昵称':'暫無昵稱',
  '文件上传':'文件上傳',
  '批量授权':'批量授權',
  '文件下载':'文件下載',
  '本地用户':'本地用戶',
  '用户:':'用戶:',
  '状态:':'狀態:',
  '权限:':'權限:',
  '已授权':'已授權',
  '未授权':'未授權',
  '昵称':'昵稱',
  '您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！':'您的瀏覽器不支持websocket協議,建議使用新版谷歌、火狐等瀏覽器，請勿使用IE10以下瀏覽器，360瀏覽器請使用極速模式，不要使用兼容模式！',
  '如果确定修改，当前的页面将被重新加载, 仍要进行修改吗':'如果確定修改，當前的頁面將被重新加載, 仍要進行修改嗎',
  '为保持数据一致性，页面将进行刷新操作！':'為保持數據一致性，頁面將進行刷新操作！',
  '没有可选租户项目':'沒有可選租戶項目',
  '请输入搜索内容':'請輸入搜索內容',
  '管理控制台':'管理控制台',
  '无匹配数据':'無匹配數據',
  '租户列表':'租戶列表',
  '访问权限':'訪問權限',
  '查看更多':'查看更多',
  '兼容问题':'兼容問題',
  '项目列表':'項目列表',
  '最近项目':'最近項目',
  '消息通知':'消息通知',
  '工单':'工單',
  '预览':'預覽',
  '警告':'警告',
  '需上传基本资料：包括主办单位证件、主办单位负责人证件和网站负责人证件。':'需上傳基本資料：包括主辦單位證件、主辦單位負責人證件和網站負責人證件。',
  '要求由三个或三个以上汉字组成，与主办单位名称有关联性':'要求由三個或三個以上漢字組成，與主辦單位名稱有關聯性',
  '请填写正确格式的应急联系人电话!':'請填寫正確格式的應急聯繫人電話!',
  '请填写正确格式的电子邮件地址!':'請填寫正確格式的電子郵件地址!',
  '请填写主办单位或主办人名称!':'請填寫主辦單位或主辦人名稱!',
  '请填写正确格式的联系方式1!':'請填寫正確格式的聯繫方式1!',
  '请填写正确格式的联系方式2!':'請填寫正確格式的聯繫方式2!',
  '请填写正确格式的网站名称!':'請填寫正確格式的網站名稱!',
  '请选择主办单位所属区域!':'請選擇主辦單位所屬區域!',
  '请填写主办单位证件号码!':'請填寫主辦單位證件號碼!',
  '请选择主办单位证件类型!':'請選擇主辦單位證件類型!',
  '请填写主办单位通讯地址!':'請填寫主辦單位通訊地址!',
  '请填写主办单位证件住所!':'請填寫主辦單位證件住所!',
  '请填写网站首页URL!':'請填寫網站首頁URL!',
  '请填写应急联系人电话!':'請填寫應急聯繫人電話!',
  '请填写负责人证件类型!':'請填寫負責人證件類型!',
  '请填写负责人证件号码!':'請填寫負責人證件號碼!',
  '请填写电子邮件地址!':'請填寫電子郵件地址!',
  '主办单位或主办人名称':'主辦單位或主辦人名稱',
  '请选择主办单位性质!':'請選擇主辦單位性質!',
  '请填写负责人姓名!':'請填寫負責人姓名!',
  '请填写已验证域名!':'請填寫已驗證域名!',
  '请填写联系方式1!':'請填寫聯繫方式1!',
  '主办单位证件号码':'主辦單位證件號碼',
  '主办单位所属区域':'主辦單位所屬區域',
  '主办单位证件住所':'主辦單位證件住所',
  '主办单位通讯地址':'主辦單位通訊地址',
  '个人备案无需填写':'個人備案無需填寫',
  '请填写网站名称!':'請填寫網站名稱!',
  '主办单位证件类型':'主辦單位證件類型',
  '请填写验证码!':'請填寫驗證碼!',
  '看不清，换一张':'看不清，換一張',
  '已上传资料下载':'已上傳資料下載',
  '网站首页URL':'網站首頁URL',
  '应急联系人电话':'應急聯繫人電話',
  '负责人证件号码':'負責人證件號碼',
  '负责人证件类型':'負責人證件類型',
  '主办单位性质':'主辦單位性質',
  '填写主体信息':'填寫主體信息',
  '填写网站信息':'填寫網站信息',
  '工商执业执照':'工商執業執照',
  '组织机构代码':'組織機構代碼',
  '请填写域名!':'請填寫域名!',
  '电子邮件地址':'電子郵件地址',
  '请上传资料!':'請上傳資料!',
  '请选择IP!':'請選擇IP!',
  '联系方式2':'聯繫方式2',
  '已验证域名':'已驗證域名',
  '负责人姓名':'負責人姓名',
  '联系方式1':'聯繫方式1',
  '联系方式':'聯繫方式',
  '资料确认':'資料確認',
  '网站编号':'網站編號',
  '提交备案':'提交備案',
  '网站名称':'網站名稱',
  '产品验证':'產品驗證',
  '选择IP':'選擇IP',
  '信息确认':'信息確認',
  '社会团体':'社會團體',
  '事业单位':'事業單位',
  '产品类型':'產品類型',
  '资料上传':'資料上傳',
  '开始备案':'開始備案',
  '详细地址':'詳細地址',
  '主体信息':'主體信息',
  '网站信息':'網站信息',
  '验证码':'驗證碼',
  '其他市':'其他市',
  '区/县':'區/縣',
  '企业': '企業',
  '县':'縣',
  '区':'區',
  '市':'市',
  '主办单位或主办人全称：':'主辦單位或主辦人全稱：',
  '主办单位所属区域：':'主辦單位所屬區域：',
  '主办单位证件类型：':'主辦單位證件類型：',
  '主办单位证件号码：':'主辦單位證件號碼：',
  '主办单位证件住所：':'主辦單位證件住所：',
  '主办单位通讯地址：':'主辦單位通訊地址：',
  '负责人证件号码：':'負責人證件號碼：',
  '负责人电子邮箱：':'負責人電子郵箱：',
  '负责人证件类型：':'負責人證件類型：',
  '主办单位性质：':'主辦單位性質：',
  '应急联系电话：':'應急聯繫電話：',
  'ISP备案信息':'ISP備案信息',
  '电子邮件地址：':'電子郵件地址：',
  '联系方式2：':'聯繫方式2：',
  '负责人姓名：':'負責人姓名：',
  '联系方式1：':'聯繫方式1：',
  '网站URL：':'網站URL：',
  '网站名称：':'網站名稱：',
  '网站域名：':'網站域名：',
  '证件类型：':'證件類型：',
  '证件号码：':'證件號碼：',
  '网站编号：':'網站編號：',
  '备案号：':'備案號：',
  '备案':'備案',
  '网站：':'網站：',
  '编辑备案网站信息成功！':'編輯備案網站信息成功！',
  '我的ICP备案信息：':'我的ICP備案信息：',
  '请填写主体备案号！':'請填寫主體備案號！',
  '请填写网站备案号！':'請填寫網站備案號！',
  'ICP主体备案状态':'ICP主體備案狀態',
  '请先选择备案进度！':'請先選擇備案進度！',
  '编辑主体信息成功！':'編輯主體信息成功！',
  '请先选择备案状态！':'請先選擇備案狀態！',
  '首次提交备案时间':'首次提交備案時間',
  'ICP主体备案号':'ICP主體備案號',
  '正在备案的订单':'正在備案的訂單',
  '成功备案的网站':'成功備案的網站',
  '主办单位名称':'主辦單位名稱',
  '继续接入备案':'繼續接入備案',
  '当前备案进度':'當前備案進度',
  '资料提交管局':'資料提交管局',
  '网站备案号:':'網站備案號:',
  '网站备案号':'網站備案號',
  '主体备案号':'主體備案號',
  '备案进度':'備案進度',
  '管局审核':'管局審核',
  '备案信息':'備案信息',
  '主体备案':'主體備案',
  '首次备案':'首次備案',
  '备案状态':'備案狀態',
  '备案完成':'備案完成',
  '备案网站':'備案網站',
  '订单号':'訂單號',
  '负责人':'負責人',
  '初审中':'初審中',
  '您的NAS卷未进行同步操作，若需要容灾后续可对新购NAS卷进行同步配置。':'您的NAS捲未進行同步操作，若需要容災後續可對新購NAS捲進行同步配置。',
  'cifs(Window专用)':'cifs(Window專用)',
  'nfs(Linux专用)':'nfs(Linux專用)',
  '请填写NAS名称 !':'請填寫NAS名稱 !',
  '请填写目标卷名称!':'請填寫目標捲名稱!',
  '启用NAS同步：':'啟用NAS同步：',
  '请选择协议 !':'請選擇協議 !',
  '目标NAS存储':'目標NAS存儲',
  '配置同步关系':'配置同步關係',
  '源NAS存储':'源NAS存儲',
  '目标卷名称':'目標捲名稱',
  '条件:':'條件:',
  '请输入名称':'請輸入名稱',
  '请选择指标':'請選擇指標',
  'NAS配置':'NAS配置',
  '可用区：':'可用區：',
  '同步频率':'同步頻率',
  '设置大小':'設置大小',
  '15分钟':'15分鐘',
  '30分钟':'30分鐘',
  '区域：':'區域：',
  '大小':'大小',
  '建议用户新建空NAS卷，如果NAS卷是被使用中，可能会造成还原失败':'建議用戶新建空NAS捲，如果NAS捲是被使用中，可能會造成還原失敗',
  '删除策略会一同删除备份记录，此操作无法恢复！':'刪除策略會一同刪除備份記錄，此操作無法恢復！',
  '没有可还原的NAS卷，请购买一个新卷':'沒有可還原的NAS捲，請購買一個新捲',
  '当前状态下无法禁启用备份策略！':'當前狀態下無法禁啟用備份策略！',
  '当前状态下无法编辑备份策略！':'當前狀態下無法編輯備份策略！',
  '该删除操作仅删除同步关系！':'該刪除操作僅刪除同步關係！',
  '当前状态下无法执行备份！':'當前狀態下無法執行備份！',
  '还原数据指令发送成功 !':'還原數據指令發送成功 !',
  '立即执行请求已发出！':'立即執行請求已發出！',
  '地址已复制至剪切板！':'地址已複製至剪切板！',
  '编辑备份保存成功!':'編輯備份保存成功!',
  '备份时间 不能为空':'備份時間 不能為空',
  '全备日期 不能为空':'全備日期 不能為空',
  '卸载指令已经发出!':'卸載指令已經發出!',
  '挂载指令已经发出!':'掛載指令已經發出!',
  '挂载点格式错误!':'掛載點格式錯誤!',
  '目标NAS卷:':'目標NAS捲:',
  '任务完成时间:':'任務完成時間:',
  '暂无还原数据!':'暫無還原數據!',
  '备份策略列表':'備份策略列表',
  '备份策略编辑':'備份策略編輯',
  '最新同步时间':'最新同步時間',
  '授权主机列表':'授權主機列表',
  '容量（GB）': '容量（GB）',
  '主机 IP':'主機 IP',
  'NAS详情':'NAS詳情',
  '系统策略名':'系統策略名',
  '暂停成功！':'暫停成功！',
  '激活成功！':'激活成功！',
  '创建时间:':'創建時間:',
  '备份时间:':'備份時間:',
  '全备日期:':'全備日期:',
  '全备时间':'全備時間',
  '还原结果':'還原結果',
  '同步编辑':'同步編輯',
  'NAS卷':'NAS捲',
  '立即执行':'立即執行',
  '全备日期':'全備日期',
  '扩容失败':'擴容失敗',
  '同步关系':'同步關係',
  '访问路径':'訪問路徑',
  '删除同步':'刪除同步',
  '目标卷':'目標捲',
  '同步卷':'同步捲',
  '使用中':'使用中',
  '策略名':'策略名',
  '不可用':'不可用',
  '扩容中':'擴容中',
  '周第':'周第',
  '挂载':'掛載',
  '对齐':'對齊',
  '卸载':'卸載',
  '路径':'路徑',
  '小时':'小時',
  '分钟':'分鐘',
  '激活':'激活',
  '月第':'月第',
  '模式':'模式',
  '容量':'容量',
  '还原':'還原',
  '半年':'半年',
  '源卷':'源捲',
  '启':'啟',
  '天':'天',
  '每':'每',
  '当保留天数为1个月时，备份周期为一周时间，选择1-7代表星期一至星期日的一天做全量备份':'當保留天數為1個月時，備份周期為一周時間，選擇1-7代表星期一至星期日的一天做全量備份',
  '当保留天数大于1个月时，备份周期为一个月时间，选择一天代表每月的当天做全量备份':'當保留天數大於1個月時，備份周期為一個月時間，選擇一天代表每月的當天做全量備份',
  '温馨提示：NAS源卷扩容的同时，同步的NAS卷会自动扩容。':'溫馨提示：NAS源捲擴容的同時，同步的NAS捲會自動擴容。',
  '如月份天数少于所选日期，平台将自动判断为最后一天':'如月份天數少於所選日期，平臺將自動判斷為最後一天',
  '如无特殊说明，周期中的其他天为增量备份':'如無特殊說明，周期中的其他天為增量備份',
  '文件存储NAS 操作指南':'文件存儲NAS 操作指南',
  '协议为空，无法授权主机！':'協議為空，無法授權主機！',
  '暂不支持备份还原服务':'暫不支持備份還原服務',
  '没有可绑定的主机！':'沒有可綁定的主機！',
  '请先完成所有选择！':'請先完成所有選擇！',
  '保留天数 不能为空':'保留天數 不能為空',
  '扩容数据未改变 !':'擴容數據未改變 !',
  '没有可解绑主机！':'沒有可解綁主機！',
  '解除授权成功！':'解除授權成功！',
  '大小(GB)：':'大小(GB)：',
  '新增授权成功！':'新增授權成功！',
  '立即备份成功！':'立即備份成功！',
  '计划备份成功！':'計劃備份成功！',
  '扩容成功 !':'擴容成功 !',
  'NAS卷用途':'NAS捲用途',
  '已授权主机':'已授權主機',
  '保留天数:':'保留天數:',
  'NAS同步':'NAS同步',
  '选择云主机':'選擇雲主機',
  '计划备份':'計劃備份',
  '所属区域':'所屬區域',
  '扩容--':'擴容--',
  '授权主机':'授權主機',
  '保留天数':'保留天數',
  '解除授权':'解除授權',
  '挂载点':'掛載點',
  '卷名称':'捲名稱',
  '读写':'讀寫',
  '权限':'權限',
  '扩容':'擴容',
  '请选择或新建目标NAS卷！':'請選擇或新建目標NAS捲！',
  '请填写目标NAS卷名称！':'請填寫目標NAS捲名稱！',
  '源NAS名称:':'源NAS名稱:',
  '目标NAS卷':'目標NAS捲',
  '购买成功！':'購買成功！',
  '同步配置':'同步配置',
  '租户：':'租戶：',
  '项目：':'項目：',
  '当日22:00前申请的SNAT和DNAT，当日22:00开始下发；22:00之后申请的则需等到次日22:00开始下发！':'當日22:00前申請的SNAT和DNAT，當日22:00開始下發；22:00之後申請的則需等到次日22:00開始下發！',
  'SNAT（云主机IP）':'SNAT（雲主機IP）',
  'DNAT（内网IP）':'DNAT（內網IP）',
  'NAT网关 操作指南':'NAT網關 操作指南',
  '硬终端和软终端数量只能填大于等于0整数，请先修改第':'硬終端和軟終端數量只能填大於等於0整數，請先修改第',
  '时长仅允许输入大于0整数或者1位小数，请先修改第':'時長僅允許輸入大於0整數或者1位小數，請先修改第',
  '请输入大于0整数或者1位小数，单位：小时':'請輸入大於0整數或者1位小數，單位：小時',
  '请输入大于等于0整数，单位：个':'請輸入大於等於0整數，單位：個',
  '请输入2016-02-03':'請輸入2016-02-03',
  '请先完成所有添加的配置':'請先完成所有添加的配置',
  '请先完成已添加的配置':'請先完成已添加的配置',
  '请输入60个以内字符':'請輸入60個以內字符',
  '请先配置产品类型':'請先配置產品類型',
  '请先配置产品类型/租户/项目!':'請先配置產品類型/租戶/項目!',
  '办公服务配置中心':'辦公服務配置中心',
  '请输入使用时长':'請輸入使用時長',
  '请输入一级部门':'請輸入一級部門',
  '请输入使用者':'請輸入使用者',
  '请输入订单号':'請輸入訂單號',
  '各项配置如下':'各項配置如下',
  '实际结束时间':'實際結束時間',
  '获取服务类型':'獲取服務類型',
  '您一共购买了':'您一共購買了',
  '实际开始时间':'實際開始時間',
  '请输入昵称':'請輸入昵稱',
  '软终端数量':'軟終端數量',
  '请输入部门':'請輸入部門',
  '硬终端数量':'硬終端數量',
  '请查看配置':'請查看配置',
  '请输入公司':'請輸入公司',
  '请先完成第':'請先完成第',
  '配置服务':'配置服務',
  '删除配置':'刪除配置',
  '购买详情':'購買詳情',
  '会议名称':'會議名稱',
  '再买一个':'再買一個',
  '使用时长':'使用時長',
  '组的配置':'組的配置',
  '一级部门':'一級部門',
  '使用者':'使用者',
  '份服务':'份服務',
  '项目!':'項目!',
  '时长':'時長',
  '公司':'公司',
  '部门':'部門',
  '办公服务管理':'辦公服務管理',
  '云视讯服务':'雲視訊服務',
  '会议发起人':'會議發起人',
  '受益人公司':'受益人公司',
  '预约方数':'預約方數',
  '申请时间':'申請時間',
  '可用性运维服务-优先级':'可用性運維服務-優先級',
  '数据处理服务-类型':'數據處理服務-類型',
  '运营服务配置中心':'運營服務配置中心',
  '非关键应用':'非關鍵應用',
  '关键应用':'關鍵應用',
  '普通应用':'普通應用',
  '可用性运维服务':'可用性運維服務',
  '运营服务管理':'運營服務管理',
  '请先正确填写手机号码！':'請先正確填寫手機號碼！',
  '请先填写您的手机号码！':'請先填寫您的手機號碼！',
  '请填写正确的邮箱地址！':'請填寫正確的郵箱地址！',
  '请先填写反馈内容！':'請先填寫反饋內容！',
  '请先填写您的邮箱！':'請先填寫您的郵箱！',
  '请先填写您的姓名！':'請先填寫您的姓名！',
  '请输入您的手机号码':'請輸入您的手機號碼',
  '请输入您的邮箱地址':'請輸入您的郵箱地址',
  '请先填写验证码！':'請先填寫驗證碼！',
  '提交反馈成功！':'提交反饋成功！',
  '请输入您的姓名':'請輸入您的姓名',
  '请填写反馈内容':'請填寫反饋內容',
  '是否处理完成:':'是否處理完成:',
  '图片或附件信息':'圖片或附件信息',
  '提交评价成功！':'提交評價成功！',
  '请输入验证码':'請輸入驗證碼',
  '选择反馈时间':'選擇反饋時間',
  '反馈内容:':'反饋內容:',
  '您的手机':'您的手機',
  '建议内容':'建議內容',
  '提交建议':'提交建議',
  '反馈详情':'反饋詳情',
  '反馈内容':'反饋內容',
  '反馈类型':'反饋類型',
  '反馈状态':'反饋狀態',
  '查看回复':'查看回覆',
  '您的姓名':'您的姓名',
  '产品建议':'產品建議',
  '您的邮箱':'您的郵箱',
  '反馈投诉':'反饋投訴',
  '反馈时间':'反饋時間',
  '上传图片':'上傳圖片',
  '已提交':'已提交',
  '已回复':'已回覆',
  '已关闭':'已關閉',
  '姓名':'姓名',
  '确认':'確認',
  '评价':'評價',
  '手机':'手機',
  '目标恢复路径':'目標恢復路徑',
  '是否重写目录':'是否重寫目錄',
  '是否为FTP':'是否為FTP',
  '容量(GB)':'容量(GB)',
  '交换区大小':'交換區大小',
  'GPU计算':'GPU計算',
  '无优惠活动':'無優惠活動',
  '目标库ID':'目標庫ID',
  'EIP端口':'EIP端口',
  '互联网IP':'互聯網IP',
  '目标系统名':'目標系統名',
  '恢复时间点':'恢復時間點',
  '云硬盘ID':'雲硬盤ID',
  '订单进度':'訂單進度',
  '订单详情':'訂單詳情',
  '订单概要':'訂單概要',
  '付费方式':'付費方式',
  '购买时间':'購買時間',
  '优惠活动':'優惠活動',
  '购买类型':'購買類型',
  'GPU卡':'GPU卡',
  '快照大小':'快照大小',
  '磁盘大小':'磁盤大小',
  '硬盘大小':'硬盤大小',
  '子网ID':'子網ID',
  '镜像名称':'鏡像名稱',
  '镜像格式':'鏡像格式',
  '周期备份':'周期備份',
  '单次备份':'單次備份',
  '固定带宽':'固定帶寬',
  '系统名称':'系統名稱',
  '10分钟':'10分鐘',
  '24小时':'24小時',
  '12个月':'12個月',
  '源桶ID':'源桶ID',
  '同步桶名':'同步桶名',
  '备份桶名':'備份桶名',
  '源库ID':'源庫ID',
  '计划类型':'計劃類型',
  '内网IP':'內網IP',
  '目标库名':'目標庫名',
  '发起人':'發起人',
  '折扣价':'折扣價',
  '30天':'30天',
  '进行中':'進行中',
  '完成':'完成',
  '原价':'原價',
  '新购':'新購',
  '升级':'升級',
  '降级':'降級',
  '单位':'單位',
  '记录':'記錄',
  '天数':'天數',
  '插槽':'插槽',
  '3天':'3天',
  '每天':'每天',
  '频率':'頻率',
  '时间':'時間',
  '规格':'規格',
  '选择开始时间':'選擇開始時間',
  '选择结束时间':'選擇結束時間',
  'OSS 自动将用户的数据以冗余的方式存储在同一区域（Region）的 1个可用区（Zone）中。提供机房级容灾能力。':'OSS 自動將用戶的數據以冗餘的方式存儲在同一區域（Region）的 1個可用區（Zone）中。提供機房級容災能力。',
  '区域可用区容量包不足，存储桶冗余容灾能力关闭。需要提供容灾能力，请':'區域可用區容量包不足，存儲桶冗餘容災能力關閉。需要提供容災能力，請',
  '对象存储购买请求已发送成功 !':'對象存儲購買請求已發送成功 !',
  '您所需区域下没有对象存储容量包':'您所需區域下沒有對象存儲容量包',
  '在您进行对象存储桶购买前先':'在您進行對象存儲桶購買前先',
  'OSS对象存储新增':'OSS對象存儲新增',
  '对象容量存储包':'對象容量存儲包',
  '同城容灾存储':'同城容災存儲',
  '存储类型':'存儲類型',
  '集群':'集群',
  '提交':'提交',
  '一个 Bucket 可以支持多个 Referer 参数，最多10个参数。设置时使用回车作为换行符分隔。':'一個 Bucket 可以支持多個 Referer 參數，最多10個參數。設置時使用回車作為換行符分隔。',
  '提示信息：如果存储桶非空(已存在数据)，删除会失败，强制删除则可以强行删除存储桶及其数据':'提示信息：如果存儲桶非空(已存在數據)，刪除會失敗，強制刪除則可以強行刪除存儲桶及其數據',
  '允许空referer':'允許空referer',
  '最多10个参数!':'最多10個參數!',
  '对象存储桶管理':'對象存儲桶管理',
  '对象存储存储桶':'對象存儲存儲桶',
  '配置成功 !':'配置成功 !',
  '强制删除：':'強制刪除：',
  '存储桶名称':'存儲桶名稱',
  '对象容量包':'對象容量包',
  'OSS密钥':'OSS密鑰',
  '配置防盗链':'配置防盜鏈',
  '通用型':'通用型',
  '归档型':'歸檔型',
  '性能型':'性能型',
  '白名单':'白名單',
  '黑名单':'黑名單',
  '桶名称':'桶名稱',
  '备份':'備份',
  '拒绝':'拒絕',
  '同步':'同步',
  'SecretKey仅在首次申请时提供':'SecretKey僅在首次申請時提供',
  '集群 不能为空':'集群 不能為空',
  '请妥善保存使用':'請妥善保存使用',
  'n可用区：':'n可用區：',
  'n集群：':'n集群：',
  'n项目:':'n項目:',
  '租户:':'租戶:',
  '集群:':'集群:',
  'OSS Packages请求已发送成功 !':'OSS Packages請求已發送成功 !',
  '名称须2-60个字符 !':'名稱須2-60個字符 !',
  '请选择有效的集群信息 !':'請選擇有效的集群信息 !',
  'OSS存储容量包购买':'OSS存儲容量包購買',
  '请填写名称信息 !':'請填寫名稱信息 !',
  '对象存储容量包':'對象存儲容量包',
  '存储桶信息':'存儲桶信息',
  'OSS自动将用户的数据以冗余的方式存储在同一区域(Region)的 1个可用区(Zone)中。提供机房级容灾能力。':'OSS自動將用戶的數據以冗餘的方式存儲在同一區域(Region)的 1個可用區(Zone)中。提供機房級容災能力。',
  'OSS 存储桶创建请求已发送成功 !':'OSS 存儲桶創建請求已發送成功 !',
  '请先清除该容量包下的所有存储桶！':'請先清除該容量包下的所有存儲桶！',
  '必填,最长32字符':'必填,最長32字符',
  '对象存储容量包扩容':'對象存儲容量包擴容',
  '剩余容量(GB)':'剩餘容量(GB)',
  '扩容(GB):':'擴容(GB):',
  '总容量(GB)':'總容量(GB)',
  '同城容灾存储:':'同城容災存儲:',
  '存储类型:':'存儲類型:',
  '新建存储桶':'新建存儲桶',
  '存储桶数':'存儲桶數',
  '建桶':'建桶',
  '授权模板详情':'授權模板詳情',
  '排除项目:':'排除項目:',
  '策略组:':'策略組:',
  '授权模板':'授權模板',
  '用户列表':'用戶列表',
  '新增用户':'新增用戶',
  '策略列表':'策略列表',
  '新增策略':'新增策略',
  '新增租户':'新增租戶',
  '新增项目':'新增項目',
  '修改授权':'修改授權',
  '项目:':'項目:',
  '用户移除成功!':'用戶移除成功!',
  '策略新增成功！':'策略新增成功！',
  '策略移除成功！':'策略移除成功！',
  '用户关联成功':'用戶關聯成功',
  '用户不能为空':'用戶不能為空',
  '项目不能为空':'項目不能為空',
  '租户不能为空':'租戶不能為空',
  '输入搜索条件':'輸入搜索條件',
  '关联用户:':'關聯用戶:',
  '排除租户:':'排除租戶:',
  '关联策略项':'關聯策略項',
  '策略管理':'策略管理',
  '添加策略':'添加策略',
  '分组类型':'分組類型',
  '取消策略':'取消策略',
  '策略项':'策略項',
  '范围':'範圍',
  '资源':'資源',
  'ID':'ID',
  '策略名称长度须2-60个字符':'策略名稱長度須2-60個字符',
  '策略修改成功！':'策略修改成功！',
  '名称不能为空':'名稱不能為空',
  '账单总览生成预计需要1-5min,请耐心等待':'賬單生成預計需要1-5min,請耐心等待',
  '-日度账单明细':'-日度賬單明細',
  '-月度账单明细':'-月度賬單明細',
  '下载账单明细':'下載賬單明細',
  '账单生成中':'賬單生成中',
  '账单周期':'賬單周期',
  '订单ID':'訂單ID',
  '产品ID':'產品ID',
  '账单月份':'賬單月份',
  '包年包月':'包年包月',
  '账单明细':'賬單明細',
  '账单日期':'賬單日期',
  '点击':'點擊',
  '选择':'選擇',
  '月份':'月份',
  '下载':'下載',
  '请':'請',
  '年':'年',
  '账单总览生成预计需要20-60s,请耐心等待':'賬單總覽生成預計需要20-60s,請耐心等待',
  '下载账单概览':'下載賬單概覽',
  '折扣价(元)':'折扣價(元)',
  '月账单汇总':'月賬單彙總',
  '按产品汇总':'按產品彙總',
  '按区域汇总':'按區域彙總',
  '按扣费周期':'按扣費周期',
  '代金券支付':'代金券支付',
  '原价(元)':'原價(元)',
  '可用区名称':'可用區名稱',
  '-账单总览':'-賬單總覽',
  '赠送金支付':'贈送金支付',
  '账单概览':'賬單概覽',
  '统计周期':'統計周期',
  '日统计':'日統計',
  '周统计':'周統計',
  '月统计':'月統計',
  '近30日统计':'近30日統計',
  '现金支付':'現金支付',
  '产品名称':'產品名稱',
  '访问来源':'訪問來源',
  '共':'共',
  '磁盘配额修改成功 !':'磁盤配額修改成功 !',
  '2-60字符':'2-60字符',
  '中文名':'中文名',
  '配额':'配額',
  '云主机快照大小(MB)：':'雲主機快照大小(MB)：',
  '单磁盘上限(GB)：':'單磁盤上限(GB)：',
  '项目配额修改成功 !':'項目配額修改成功 !',
  '磁盘大小(GB)：':'磁盤大小(GB)：',
  '硬盘大小(GB)：':'硬盤大小(GB)：',
  '可修改最大配额：':'可修改最大配額：',
  '云主机快照数量：':'雲主機快照數量：',
  '内存(GB)：':'內存(GB)：',
  '当前配额：':'當前配額：',
  '修改配额：':'修改配額：',
  '实例数量：':'實例數量：',
  '磁盘数量：':'磁盤數量：',
  '项目信息':'項目信息',
  '配额信息':'配額信息',
  '修改配额':'修改配額',
  '线程数：':'線程數：',
  '已使用：':'已使用：',
  '确认修改':'確認修改',
  '项目配额':'項目配額',
  '项目备注':'項目備註',
  '天数仅允许输入大于0整数或者1位小数，请先修改第':'天數僅允許輸入大於0整數或者1位小數，請先修改第',
  '请输入大于0整数或者1位小数':'請輸入大於0整數或者1位小數',
  '安全服务配置中心':'安全服務配置中心',
  '安全服务管理':'安全服務管理',
  '网络安全':'網絡安全',
  '请填写一级服务目录！':'請填寫一級服務目錄！',
  '请填写二级服务目录第':'請填寫二級服務目錄第',
  '新增服务目录成功！':'新增服務目錄成功！',
  '添加二级服务项目':'添加二級服務項目',
  '新增一级服务目录':'新增一級服務目錄',
  '一级服务目录':'一級服務目錄',
  '二级服务目录':'二級服務目錄',
  '条信息！':'條信息！',
  '请输入':'請輸入',
  '确 定':'確 定',
  '取 消':'取 消',
  '二级目录下无三级目录后才可以删除!':'二級目錄下無三級目錄後才可以刪除!',
  '编辑二级服务目录成功！':'編輯二級服務目錄成功！',
  '二级服务目录删除成功!':'二級服務目錄刪除成功!',
  '新增二级服务目录成功！':'新增二級服務目錄成功！',
  '二级服务目录名称':'二級服務目錄名稱',
  '新增二级服务':'新增二級服務',
  '研发服务':'研發服務',
  '二级服务':'二級服務',
  '返回':'返回',
  '删除服务目录已提交OA审批！':'刪除服務目錄已提交OA審批！',
  '是否在年初公允定价范围内':'是否在年初公允定價範圍內',
  '待审批状态不允许编辑！':'待審批狀態不允許編輯！',
  '待审批状态不允许删除！':'待審批狀態不允許刪除！',
  '目录Owner':'目錄Owner',
  '推荐使用环境':'推薦使用環境',
  '服务拆分类型':'服務拆分類型',
  '服务介绍:':'服務介紹:',
  '目录负责人':'目錄負責人',
  '服务级别':'服務級別',
  '服务时间':'服務時間',
  '响应时间':'響應時間',
  '解决时间':'解決時間',
  '服务定价':'服務定價',
  '收费方式':'收費方式',
  '收费对象':'收費對象',
  '计算方法':'計算方法',
  '备注说明':'備註說明',
  '服务详情':'服務詳情',
  '新增服务':'新增服務',
  '修改服务':'修改服務',
  '删除服务':'刪除服務',
  '有效年份':'有效年份',
  '目录类型':'目錄類型',
  '单价':'單價',
  '含税':'含稅',
  '税率':'稅率',
  '温馨提示：提交服务目录变更操作，系统将自动发起OA审批。':'溫馨提示：提交服務目錄變更操作，系統將自動發起OA審批。',
  '服务目录生成预计需要20-60s,请耐心等待！':'服務目錄生成預計需要20-60s,請耐心等待！',
  '请点击选择年份下载服务目录':'請點擊選擇年份下載服務目錄',
  '点击选择年份搜索':'點擊選擇年份搜索',
  '二级级服务目录':'二級級服務目錄',
  '日期不能为空！':'日期不能為空！',
  '服务目录生成中':'服務目錄生成中',
  '单价(含税)':'單價(含稅)',
  '三级服务目录':'三級服務目錄',
  '新增三级服务':'新增三級服務',
  '-服务目录':'-服務目錄',
  '审批状态':'審批狀態',
  '审批通过':'審批通過',
  '审批驳回':'審批駁回',
  '发起失败':'發起失敗',
  '日期:':'日期:',
  '待审批':'待審批',
  '一级服务目录名称':'一級服務目錄名稱',
  '二级服务目录数':'二級服務目錄數',
  '新增一级服务':'新增一級服務',
  '工作时间：5*7（上午9:00-12:00，下午13:30-17:30）':'工作時間：5*7（上午9:00-12:00，下午13:30-17:30）',
  '备注：服务时间指人员服务时间，若为7*24小时，则需有人值班':'備註：服務時間指人員服務時間，若為7*24小時，則需有人值班',
  '7*24小时（周一至周日 00:00 - 24:00）':'7*24小時（周一至周日 00:00 - 24:00）',
  '点击【确定】后，系统将自动发起OA审批':'點擊【確定】後，系統將自動發起OA審批',
  '请上传上会材料及会议纪要等相关材料':'請上傳上會材料及會議紀要等相關材料',
  '推荐使用环境长度限1000！':'推薦使用環境長度限1000！',
  '三级服务目录限50个汉字！':'三級服務目錄限50個漢字！',
  '服务介绍长度限1000！':'服務介紹長度限1000！',
  '服务时间长度限1000！':'服務時間長度限1000！',
  '响应时间长度限1000！':'響應時間長度限1000！',
  '解决时间长度限1000！':'解決時間長度限1000！',
  '收费方式长度限1000！':'收費方式長度限1000！',
  '计算方法长度限1000！':'計算方法長度限1000！',
  '备注说明长度限1000！':'備註說明長度限1000！',
  '服务目录已提交OA审批！':'服務目錄已提交OA審批！',
  '请填写目录Owner！':'請填寫目錄Owner！',
  '请先填写目录负责人第':'請先填寫目錄負責人第',
  '请选择一级服务目录！':'請選擇一級服務目錄！',
  '请选择二级服务目录！':'請選擇二級服務目錄！',
  '请选择服务拆分类型！':'請選擇服務拆分類型！',
  '单价长度限1000！':'單價長度限1000！',
  '单位长度限1000！':'單位長度限1000！',
  '请填写三级服务目录！':'請填寫三級服務目錄！',
  '非工作时间：不适用':'非工作時間：不適用',
  '请选择有效年份！':'請選擇有效年份！',
  '请选择目录类型！':'請選擇目錄類型！',
  '请选择有效年份':'請選擇有效年份',
  '请输入所属中心':'請輸入所屬中心',
  '请先上传附件！':'請先上傳附件！',
  '编辑三级服务':'編輯三級服務',
  '请填写单价！':'請填寫單價！',
  '请填写单位！':'請填寫單位！',
  '服务介绍':'服務介紹',
  '上传附件':'上傳附件',
  '采购分摊':'採購分攤',
  '受益人':'受益人',
  '按人力':'按人力',
  '按量':'按量',
  '条！':'條！',
  '消息发布时间':'消息發佈時間',
  '标题内容':'標題內容',
  '消息类型':'消息類型',
  '消息时间':'消息時間',
  '预览-':'預覽-',
  '链接为临时预览公告链接，非正式链接。该链接3日有效!':'鏈接為臨時預覽公告鏈接，非正式鏈接。該鏈接3日有效!',
  '消息详情':'消息詳情',
  '消息订阅修改成功！':'消息訂閱修改成功！',
  '批量已读成功！':'批量已讀成功！',
  '全部已读成功！':'全部已讀成功！',
  '批量已读':'批量已讀',
  '全部已读':'全部已讀',
  'IP协议版本':'IP協議版本',
  '已用IP数':'已用IP數',
  '总IP数':'總IP數',
  '子网详情':'子網詳情',
  '子网id':'子網id',
  '网关':'網關',
  '请输入标签键进行查询，多个标签键以英文逗号隔开':'請輸入標簽鍵進行查詢，多個標簽鍵以英文逗號隔開',
  '标签键':'標簽鍵',
  '标签值':'標簽值',
  '更改人':'更改人',
  '账单生成预计需要1-5min,请耐心等待':'賬單生成預計需要1-5min,請耐心等待',
  '按项目汇总':'按項目彙總',
  '请选择VPC、子网信息 !':'請選擇VPC、子網信息 !',
  '请先选择可用区！':'請先選擇可用區！',
  '请先选择子网！':'請先選擇子網！',
  'VIP购买':'VIP購買',
  'VIP详情':'VIP詳情',
  '所属子网':'所屬子網',
  '端口id':'端口id',
  'subnet_id为NULL,暂不能进行绑定':'subnet_id為NULL,暫不能進行綁定',
  '没有同网段可绑定的主机！':'沒有同網段可綁定的主機！',
  '没有已绑定的主机！':'沒有已綁定的主機！',
  'VIP 操作指南':'VIP 操作指南',
  '请选择实例IP':'請選擇實例IP',
  '子网CIDR':'子網CIDR',
  '绑定成功！':'綁定成功！',
  '解绑成功！':'解綁成功！',
  '确定释放该':'確定釋放該',
  'VIP解绑':'VIP解綁',
  '释放成功！':'釋放成功！',
  'VIP绑定':'VIP綁定',
  '子网网关':'子網網關',
  '申请':'申請',
  '防火墙节点需至少连接一个目标节点！':'防火牆節點需至少連接一個目標節點！',
  '创建资源栈请求已发送，请稍后查看！':'創建資源棧請求已發送，請稍後查看！',
  '编辑模板资源参数配置将会重置！':'編輯模板資源參數配置將會重置！',
  '相同的连个节点只能连一条线！':'相同的連個節點只能連一條線！',
  '防火墙节点需连接一个源节点！':'防火牆節點需連接一個源節點！',
  '防火墙节点只能连入一个源！':'防火牆節點只能連入一個源！',
  '连线节点至少连接两个节点':'連線節點至少連接兩個節點',
  '请先绘制画布！':'請先繪製畫布！',
  '模板创建成功！':'模板創建成功！',
  '模板编辑成功！':'模板編輯成功！',
  '是否编辑模板！':'是否編輯模板！',
  '编辑资源参数':'編輯資源參數',
  '创建资源栈':'創建資源棧',
  '清空资源':'清空資源',
  '创建模板':'創建模板',
  '创建一个新云硬盘时，您可以选择一个已有的云硬盘或快照进行数据的复制，':'創建一個新雲硬盤時，您可以選擇一個已有的雲硬盤或快照進行數據的複製，',
  '如果希望创建一个全新的云硬盘则无需选择此项':'如果希望創建一個全新的雲硬盤則無需選擇此項',
  '云硬盘购买请求已发送成功 !':'雲硬盤購買請求已發送成功 !',
  '请填写全部参数 !':'請填寫全部參數 !',
  '请填写名称 !':'請填寫名稱 !',
  '云硬盘购买':'雲硬盤購買',
  '复制源类型':'複製源類型',
  '列表':'列表',
  '云硬盘快照列表':'雲硬盤快照列表',
  '云硬盘快照ID':'雲硬盤快照ID',
  '复制源类型ID':'複製源類型ID',
  '挂载主机IP':'掛載主機IP',
  '云硬盘详情':'雲硬盤詳情',
  '挂载主机名':'掛載主機名',
  '是否启动盘':'是否啟動盤',
  '操作记录':'操作記錄',
  '操作序列':'操作序列',
  '挂载主机':'掛載主機',
  '操作结果':'操作結果',
  '磁盘id':'磁盤id',
  '操作人':'操作人',
  '磁盘已被挂载，不能重复挂载！':'磁盤已被掛載，不能重覆掛載！',
  '云硬盘CBS 操作指南':'雲硬盤CBS 操作指南',
  '挂载命令已发出 !':'掛載命令已發出 !',
  '云主机列表获取为空':'雲主機列表獲取為空',
  '请先选择云主机 !':'請先選擇雲主機 !',
  '名称不能为空 !':'名稱不能為空 !',
  '大小(GB):':'大小(GB):',
  '快照链id':'快照鏈id',
  '挂载路径:':'掛載路徑:',
  '文件系统:':'文件系統:',
  '挂载云主机':'掛載雲主機',
  '云硬盘名称':'雲硬盤名稱',
  '快照详情':'快照詳情',
  '快照ID':'快照ID',
  '使用快照创建云硬盘将已有的云硬盘或快照进行数据的复制，与原磁盘保持相同的可用区和云硬盘类型。':'使用快照創建雲硬盤將已有的雲硬盤或快照進行數據的複製，與原磁盤保持相同的可用區和雲硬盤類型。',
  '，在此之后的数据将会被清除，请确认数据已进行备份或处理。':'，在此之後的數據將會被清除，請確認數據已進行備份或處理。',
  '云磁盘类型 不能为空':'雲磁盤類型 不能為空',
  '请选择云硬盘类型！':'請選擇雲硬盤類型！',
  '磁盘大小(GB)':'磁盤大小(GB)',
  '硬盘大小(GB)':'硬盤大小(GB)',
  '的数据将回滚到':'的數據將回滾到',
  '请选择云硬盘!':'請選擇雲硬盤!',
  '云硬盘类型:':'雲硬盤類型:',
  '云硬盘描述：':'雲硬盤描述：',
  '购买云硬盘':'購買雲硬盤',
  '云硬盘创建':'雲硬盤創建',
  '关联磁盘：':'關聯磁盤：',
  '云硬盘描述':'雲硬盤描述',
  '快照名称':'快照名稱',
  '磁盘名称':'磁盤名稱',
  '源盘名称':'源盤名稱',
  '快照：':'快照：',
  '回滚':'回滾',
  '温馨提示：请在云硬盘处理处于【未挂载】状态进行回滚操作。':'溫馨提示：請在雲硬盤處理處於【為挂載】狀態進行回滾操作。',
  '快照链详情':'快照鏈詳情',
  '快照链ID':'快照鏈ID',
  '永久保留':'永久保留',
  '删除错误':'刪除錯誤',
  '快照类型':'快照類型',
  '快照数量':'快照數量',
  '回滚中':'回滾中',
  '系统盘':'系統盤',
  '未挂载':'未掛載',
  '磁盘容量(GB)':'磁盤容量(GB)',
  '硬盘容量(GB)':'硬盤容量(GB)',
  '快照容量(GB)':'快照容量(GB)',
  'VPC子网列表':'VPC子網列表',
  'VPC详情':'VPC詳情',
  '专有网络VPC 操作指南':'專有網絡VPC 操作指南',
  '子网列表':'子網列表',
  '工单标题长度小于32位！':'工單標題長度小於32位！',
  '选择问题所属产品与服务':'選擇問題所屬產品與服務',
  '联系人长度小于8位！':'聯繫人長度小於8位！',
  '请填写正确手机格式！':'請填寫正確手機格式！',
  '请填写正确邮箱格式！':'請填寫正確郵箱格式！',
  '期待您的反馈及评价':'期待您的反饋及評價',
  '请填写手机号码！':'請填寫手機號碼！',
  '请输入工单流水号':'請輸入工單流水號',
  '请填写问题描述！':'請填寫問題描述！',
  '请选择联系时间！':'請選擇聯繫時間！',
  '请填写解决信息！':'請填寫解決信息！',
  '请填写工单标题！':'請填寫工單標題！',
  '提交工单成功！':'提交工單成功！',
  '相关产品与服务':'相關產品與服務',
  '请填写联系人！':'請填寫聯繫人！',
  '默认为北京时间':'默認為北京時間',
  '请输入工单编号':'請輸入工單編號',
  '请选择问题类型':'請選擇問題類型',
  '问题是否解决:':'問題是否解決:',
  '请选择评分！':'請選擇評分！',
  '云产品和服务':'雲產品和服務',
  '超过最大容量':'超過最大容量',
  '选择问题类型':'選擇問題類型',
  '填写工单信息':'填寫工單信息',
  '用户联系方式':'用戶聯繫方式',
  '请选择紧急！':'請選擇緊急！',
  '反馈完成！':'反饋完成！',
  '评论成功！':'評論成功！',
  '产品和服务':'產品和服務',
  '整体评价:':'整體評價:',
  '反馈建议:':'反饋建議:',
  '请填写: ':'請填寫: ',
  '工单编号':'工單編號',
  '工单状态':'工單狀態',
  '问题描述':'問題描述',
  '创建工单':'創建工單',
  '任何时间':'任何時間',
  '是否紧急':'是否緊急',
  '业务功能':'業務功能',
  '联系时间':'聯繫時間',
  '反馈评价':'反饋評價',
  '手机号码':'手機號碼',
  '提交时间':'提交時間',
  '留言信息':'留言信息',
  '提交用户':'提交用戶',
  '工单标题':'工單標題',
  '工单详情':'工單詳情',
  '处理中':'處理中',
  '提交人':'提交人',
  '近两天':'近兩天',
  '近一天':'近壹天',
  '留言:':'留言:',
  '联系人':'聯繫人',
  '未解决':'未解決',
  '已解决':'已解決',
  '待确认':'待確認',
  '评论':'評論',
  '提单':'提單',
  '每日':'每日',
  '从不':'從不',
  '策略管理详情':'策略管理詳情',
  '策略组管理详情':'策略組管理詳情',
  '授权用户列表':'授權用戶列表',
  '策略组名称':'策略組名稱',
  '策略组ID':'策略組ID',
  '资源IP，仅支持精确搜索':'資源IP，僅支持精確搜索',
  '资源ID':'資源ID',
  '资源类型':'資源類型',
  '日志管理':'日誌管理',
  '请提供证件的原件照片或者扫描件（正副本均可），文字/盖章清晰可辩认格式要求jpg、jpeg、png，不超过2MB':'請提供證件的原件照片或者掃描件（正副本均可），文字/蓋章清晰可辯認格式要求jpg、jpeg、png，不超過2MB',
  '您可以通过客服热线0755-88236666或邮箱cloud@cmft.com申请更新您的手机号。':'您可以通過客服熱線0755-88236666或郵箱cloud@cmft.com申請更新您的手機號。',
  '只能包含特殊字符：!@#$%^&*()_+-=;':'只能包含特殊字符：!@#$%^&*()_+-=;',
  '认证材料审核预计3-5个工作日，请您耐心等待':'認證材料審核預計3-5個工作日，請您耐心等待',
  '为了完整体验平台产品，请先完成企业实名认证':'為了完整體驗平臺產品，請先完成企業實名認證',
  '您未通过认证审核，请修改资料后重新提交':'您未通過認證審核，請修改資料後重新提交',
  '大小写字母、数字、特殊字符包含四种;':'大小寫字母、數字、特殊字符包含四種;',
  '手机号更新一般1-2个工作日内生效。':'手機號更新一般1-2個工作日內生效。',
  '恭喜您已完成招商云企业实名认证':'恭喜您已完成招商雲企業實名認證',
  '营业执照注册号位：1-18位!':'營業執照註冊號位：1-18位!',
  '密码长度须8-21个字符 !':'密碼長度須8-21個字符 !',
  '请务必与营业执照的注册号一致':'請務必與營業執照的註冊號一致',
  '该手机号码无效，请重新输入':'該手機號碼無效，請重新輸入',
  '未验证,点击去验证手机号码':'未驗證,點擊去驗證手機號碼',
  '本人操作，请完成以下验证':'本人操作，請完成以下驗證',
  '若您的主账号手机号不可用':'若您的主賬號手機號不可用',
  '请输入正确的邮箱地址!':'請輸入正確的郵箱地址!',
  '请输入正确的身份证号!':'請輸入正確的身份證號!',
  '请输入正确的手机号码!':'請輸入正確的手機號碼!',
  '手机不可用，点击解决。':'手機不可用，點擊解決。',
  '企业名称与营业执照一致':'企業名稱與營業執照一致',
  '如需修改，请填写新密码':'如需修改，請填寫新密碼',
  '增加企业认证信息 >':'增加企業認證信息 >',
  '注册营业执照扫描件：':'註冊營業執照掃描件：',
  '请先获取短信验证码！':'請先獲取短信驗證碼！',
  '该图片超过了2MB!':'該圖片超過了2MB!',
  '请输入正确的邮箱地址':'請輸入正確的郵箱地址',
  '修改手机号码成功!':'修改手機號碼成功!',
  '招商云隐私政策声明':'招商雲隱私政策聲明',
  '管理员身份证号码:':'管理員身份證號碼:',
  '请先输入图片验证码':'請先輸入圖片驗證碼',
  '请先完成所有配置!':'請先完成所有配置!',
  '管理员身份证姓名:':'管理員身份證姓名:',
  '邮箱格式不正确 !':'郵箱格式不正確 !',
  '请先输入短信验证码':'請先輸入短信驗證碼',
  '两次输入密码不一致':'兩次輸入密碼不一致',
  '请勾选同意协议内容':'請勾選同意協議內容',
  '增加企业认证信息':'增加企業認證信息',
  '营业执照注册号：':'營業執照註冊號：',
  '管理员手机号码:':'管理員手機號碼:',
  '填写管理员邮箱:':'填寫管理員郵箱:',
  '请输入正确的手机':'請輸入正確的手機',
  '管理员身份证号码':'管理員身份證號碼',
  '中国香港+852':'中國香港+852',
  '营业执照扫描件：':'營業執照掃描件：',
  '8-32位字符;':'8-32位字符;',
  '12-32位字符;':'12-32位字符;',
  '注册营业执照号：':'註冊營業執照號：',
  '完成企业实名认证':'完成企業實名認證',
  '请输入短信验证码':'請輸入短信驗證碼',
  '请输入图片验证码':'請輸入圖片驗證碼',
  '查看企业认证信息':'查看企業認證信息',
  '使用已有账号登录':'使用已有賬號登錄',
  '输入有效手机号码':'輸入有效手機號碼',
  '图片格式不正确！':'圖片格式不正確！',
  '输入图片验证码':'輸入圖片驗證碼',
  '请输入行业范畴':'請輸入行業範疇',
  '同意协议并注册':'同意協議並註冊',
  '企业管理员信息':'企業管理員信息',
  '企业通讯地址:':'企業通訊地址:',
  '企业通讯地址：':'企業通訊地址：',
  '获取短信验证码':'獲取短信驗證碼',
  '输入短信验证码':'輸入短信驗證碼',
  '中国大陆+86':'中國大陸+86',
  '企业认证信息:':'企業認證信息:',
  '欢迎注册招商云':'歡迎註冊招商雲',
  '为确认是账户':'為確認是賬戶',
  '新手机号码:':'新手機號碼:',
  '旧手机号码:':'舊手機號碼:',
  '重新提交材料':'重新提交材料',
  '图片验证码:':'圖片驗證碼:',
  '身份证号码：':'身份證號碼：',
  '短信验证码:':'短信驗證碼:',
  '身份证姓名：':'身份證姓名：',
  '填写企业信息':'填寫企業信息',
  '确认企业信息':'確認企業信息',
  '企业认证信息':'企業認證信息',
  '用户信息编辑':'用戶信息編輯',
  '修改手机号码':'修改手機號碼',
  '绑定手机号码':'綁定手機號碼',
  '手机号码：':'手機號碼：',
  '行业信息：':'行業信息：',
  '管理员邮箱':'管理員郵箱',
  '确认密码:':'確認密碼:',
  '企业名称:':'企業名稱:',
  '所在行业:':'所在行業:',
  '请输入账号':'請輸入賬號',
  '请选择企业':'請選擇企業',
  '请输入手机':'請輸入手機',
  '绑定新手机':'綁定新手機',
  '请输入邮箱':'請輸入郵箱',
  '绑定成功!':'綁定成功!',
  '手机号码:':'手機號碼:',
  '企业名称：':'企業名稱：',
  '重新上传':'重新上傳',
  '提交审核':'提交審核',
  '注册成功':'註冊成功',
  '提交成功':'提交成功',
  '验证身份':'驗證身份',
  '立即绑定':'立即綁定',
  '我已阅读':'我已閱讀',
  '密码:':'密碼:',
  '手机:':'手機:',
  '邮箱:':'郵箱:',
  '账号:':'賬號:',
  '未认证':'未認證',
  '市/区':'市/區',
  '换一张':'換一張',
  '邮箱：':'郵箱：',
  '不通过':'不通過',
  '审核':'審核',
  '首页':'首頁',
  '通过':'通過',
  '聚合类型':'聚合類型',
  '时间区间':'時間區間',
  'P95值':'P95值',
  '刷新中':'刷新中',
  '时间段':'時間段',
  '最小值':'最小值',
  '最大值':'最大值',
  '平均值':'平均值',
  '原始值':'原始值',
  '不能设置如下特殊字母welcome':'不能設置如下特殊字母welcome',
  '数据库（数据库名：权限）':'數據庫（數據庫名：權限）',
  '账户管理 -- 新增':'賬戶管理 -- 新增',
  '用户权限重置成功！':'用戶權限重置成功！',
  '请先创建数据库':'請先創建數據庫',
  '权限修改成功！':'權限修改成功！',
  '数据库名：权限':'數據庫名：權限',
  '授权数据库:':'授權數據庫:',
  '特殊字符为!':'特殊字符為!',
  '数据库账号:':'數據庫賬號:',
  '暂无数据库':'暫無數據庫',
  '属主用户:':'屬主用戶:',
  '应用用户:':'應用用戶:',
  '所属目标库':'所屬目標庫',
  '数据库列表':'數據庫列表',
  '用户账号:':'用戶賬號:',
  '部署用户':'部署用戶',
  '修改权限':'修改權限',
  '目标库':'目標庫',
  '恢复时间点请选择在可恢复时间范围内！':'恢復時間點請選擇在可恢復時間範圍內！',
  '购买恢复数据库实例':'購買恢複數據庫實例',
  '请选择恢复时间点！':'請選擇恢復時間點！',
  '创建恢复任务成功！':'創建恢復任務成功！',
  '恢复源数据库实例':'恢復源數據庫實例',
  '恢复原数据库实例':'恢複原數據庫實例',
  '磁盘大小(G)':'磁盤大小(G)',
  '可恢复时间范围':'可恢復時間範圍',
  '恢复的时间点':'恢復的時間點',
  '配置恢复对象':'配置恢復對象',
  '请选择子网！':'請選擇子網！',
  '恢复可用区':'恢復可用區',
  '数据库系列':'數據庫系列',
  '恢复信息':'恢復信息',
  '数据实例':'數據實例',
  '恢复区域':'恢復區域',
  '还原备份':'還原備份',
  '恢复计划':'恢復計劃',
  '请在数据库实例恢删除前进行数据备份操作':'請在數據庫實例恢刪除前進行數據備份操作',
  '恢复时间点 不能为空':'恢復時間點 不能為空',
  'RDS关系型数据库':'RDS關係型數據庫',
  '重试请求已发送！':'重試請求已發送！',
  '无可恢复时间点！':'無可恢復時間點！',
  '恢复时间范围:':'恢復時間範圍:',
  '恢复时间点:':'恢復時間點:',
  '恢复数据大小':'恢複數據大小',
  '恢复结束时间':'恢復結束時間',
  '实例创建失败':'實例創建失敗',
  '重试数据恢复':'重試數據恢復',
  '恢复计划名称':'恢復計劃名稱',
  '实例创建中':'實例創建中',
  '还原数据库':'還原數據庫',
  '恢复实例':'恢復實例',
  '还原状态':'還原狀態',
  '恢复完成':'恢復完成',
  '删除实例':'刪除實例',
  '恢复管理':'恢復管理',
  '重试':'重試',
  '确定删除当前备份策略吗':'確定刪除當前備份策略嗎',
  '备份策略立即执行一次':'備份策略立即執行一次',
  '数据备份删除成功!':'數據備份刪除成功!',
  '日志备份删除成功!':'日誌備份刪除成功!',
  '备份策略将不在执行':'備份策略將不在執行',
  '立即执行备份策略':'立即執行備份策略',
  '状态，【不】允许':'狀態，【不】允許',
  '删除备份记录：':'刪除備份記錄：',
  '策略下发失败':'策略下發失敗',
  '点击确定后，':'點擊確定後，',
  '启用备份策略':'啟用備份策略',
  '新增备份计划':'新增備份計劃',
  '备份策略操作':'備份策略操作',
  '策略下发中':'策略下發中',
  '禁启用操作':'禁啟用操作',
  '备份策略,删除成功!':'備份策略,刪除成功!',
  '数据备份':'數據備份',
  '日志备份':'日誌備份',
  '数据类型':'數據類型',
  '下发失败':'下發失敗',
  '备份任务':'備份任務',
  '删除策略':'刪除策略',
  '禁用中':'禁用中',
  '确认要':'確認要',
  '成功!':'成功!',
  '全备':'全備',
  '增备':'增備',
  '数据':'數據',
  '启用日志备份后，支持恢复到有效备份数据的任意时间':'啟用日誌備份後，支持恢復到有效備份數據的任意時間',
  '备份策略中已存在一个日志备份，保留周期的时间是：':'備份策略中已存在一個日誌備份，保留周期的時間是：',
  '您创建的单次备份，备份时系统提供默认的备份时间':'您創建的單次備份，備份時系統提供默認的備份時間',
  '每周一，二，三，四，五，六，日':'每周一，二，三，四，五，六，日',
  '确认要延长日志备份的保留周期？':'確認要延長日誌備份的保留周期？',
  '修改后为您自定义的备份时间':'修改後為您自定義的備份時間',
  '请先配置单次备份时间':'請先配置單次備份時間',
  '增加备份计划成功!':'增加備份計劃成功!',
  '修改备份计划成功!':'修改備份計劃成功!',
  '请先配置全备时间':'請先配置全備時間',
  '创建备份成功!':'創建備份成功!',
  '启用日志备份':'啟用日誌備份',
  '选择备份信息':'選擇備份信息',
  '修改备份计划':'修改備份計劃',
  '单次备份时间':'單次備份時間',
  '策略是否启动':'策略是否啟動',
  '全备周期':'全備周期',
  '策略说明':'策略說明',
  '计划说明':'計劃說明',
  '备份频率':'備份頻率',
  '备份确认':'備份確認',
  '每天全备':'每天全備',
  '请先输入':'請先輸入',
  '计划':'計劃',
  '账户（账户名：权限）':'賬戶（賬戶名：權限）',
  '数据库管理--新增':'數據庫管理--新增',
  '授权用户账号:':'授權用戶賬號:',
  '账户名：权限':'賬戶名：權限',
  '数据库名:':'數據庫名:',
  '排序规则:':'排序規則:',
  '字符分类:':'字符分類:',
  '暂无账户':'暫無賬戶',
  '字符集:':'字符集:',
  '账户列表':'賬戶列表',
  '账户名':'賬戶名',
  '账户':'賬戶',
  '数据库节点ID':'數據庫節點ID',
  '归档磁盘容量':'歸檔磁盤容量',
  '计算节点ID':'計算節點ID',
  '插入数据': '插入數據',
  '更新数据': '更新數據',
  '创建函数': '創建函數',
  '删除函数': '刪除函數',
  '创建存储过程': '創建存儲過程',
  '编辑存储过程': '編輯存儲過程',
  '删除存储过程': '刪除存儲過程',
  '删除触发器': '刪除觸發器',
  '创建序列': '創建序列',
  '数据磁盘容量':'數據磁盤容量',
  '当前磁盘容量最大值为':'當前磁盤容量最大值為',
  '当前磁盘容量总和为':'當前磁盤容量總和為',
  '当前磁盘容量总和超过':'當前磁盤容量總和超過',
  '请重新分配！':'請重新分配！',
  '数据库节点':'數據庫節點',
  '存储容量':'存儲容量',
  '请输入可修改参数范围内的数字！':'請輸入可修改參數範圍內的數字！',
  '请输入可修改参数范围内的值！':'請輸入可修改參數範圍內的值！',
  '你确认要修改这些参数吗':'你確認要修改這些參數嗎',
  '您没有修改任何参数！':'您沒有修改任何參數！',
  '变更前的参数值':'變更前的參數值',
  '变更后的参数值':'變更後的參數值',
  '参数提交成功！':'參數提交成功！',
  '可修改参数值':'可修改參數值',
  '可修改参数':'可修改參數',
  '参数默认值':'參數默認值',
  '运行参数值':'運行參數值',
  '提交修改':'提交修改',
  '是否重启':'是否重啟',
  '修改历史':'修改歷史',
  '是否生效':'是否生效',
  '变更时间':'變更時間',
  '重启生效':'重啟生效',
  '参数名':'參數名',
  '放大':'放大',
  '选择时间区间:':'選擇時間區間:',
  '十分钟':'十分鐘',
  '半小时':'半小時',
  '一小时':'一小時',
  '一天':'一天',
  '三天':'三天',
  '不支持any，可以多个port，用逗号隔开，个数与internal_port一致，且端口号一一对应；端口号不能重复使用；1-65534':'不支持any，可以多個port，用逗號隔開，個數與internal_port一致，且端口號一一對應；端口號不能重覆使用；1-65534',
  '不支持any，可以多个port，用逗号隔开，个数与eip_port一致，1-65534':'不支持any，可以多個port，用逗號隔開，個數與eip_port一致，1-65534',
  'any：所有公网ip；支持单ip或多个ip和CIDR，多ip用逗号隔开':'any：所有公網ip；支持單ip或多個ip和CIDR，多ip用逗號隔開',
  '名称须是以数字或字母开头并由字母、数字和下划线组成的32位字符':'名稱須是以數字或字母開頭並由字母、數字和下劃線組成的32位字符',
  '原配置内网IP已不存在，请重新配置!':'原配置內網IP已不存在，請重新配置!',
  '请输入目标系统名，最长32位':'請輸入目標系統名，最長32位',
  '没有可配置的内网IP':'沒有可配置的內網IP',
  '请填写正确格式名称!':'請填寫正確格式名稱!',
  '没有可配置的EIP':'沒有可配置的EIP',
  '请先完成必填配置!':'請先完成必填配置!',
  '正在编辑序号：':'正在編輯序號：',
  '创建DNAT':'創建DNAT',
  '内网端口':'內網端口',
  '请输入名称搜索':'請輸入名稱搜索',
  'NAT网关详情':'NAT網關詳情',
  '支持any，多端口号(逗号隔开,可有port段)，如:(1,3-10,12)，但与dest_ip不可同时为any；1-65534':'支持any，多端口號(逗號隔開,可有port段)，如:(1,3-10,12)，但與dest_ip不可同時為any；1-65534',
  '公网ip，支持any，多ip和CIDR(逗号隔开)，校验除私有ip外的其他公网ip':'公網ip，支持any，多ip和CIDR(逗號隔開)，校驗除私有ip外的其他公網ip',
  '目标系统名须是以数字或字母开头并由字母、数字和下划线组成的32位字符':'目標系統名須是以數字或字母開頭並由字母、數字和下劃線組成的32位字符',
  '请填写正确格式目标系统名!':'請填寫正確格式目標系統名!',
  '没有可配置的云主机':'沒有可配置的雲主機',
  '创建SNAT':'創建SNAT',
  '备份桶名称':'備份桶名稱',
  '备份大小':'備份大小',
  '备份日志':'備份日誌',
  '任务中断':'任務中斷',
  '桶ID':'桶ID',
  '点击确定后，备份任务立即':'點擊確定後，備份任務立即',
  '中断执行正在进行备份任务':'中斷執行正在進行備份任務',
  '全量备份任务等待处理中':'全量備份任務等待處理中',
  '增量备份任务等待处理':'增量備份任務等待處理',
  '全量备份任务等待处理':'全量備份任務等待處理',
  '是否删除同步数据：':'是否刪除同步數據：',
  '立即执行备份任务':'立即執行備份任務',
  '备份桶已被删除':'備份桶已被刪除',
  '增量备份完成':'增量備份完成',
  '增量备份错误':'增量備份錯誤',
  '全量备份错误':'全量備份錯誤',
  '全量备份完成':'全量備份完成',
  '源桶已被删除':'源桶已被刪除',
  '启用成功!':'啟用成功!',
  '禁用成功!':'禁用成功!',
  '备份存储桶':'備份存儲桶',
  '增量备份中':'增量備份中',
  '全量备份中':'全量備份中',
  '添加备份':'添加備份',
  '禁用任务':'禁用任務',
  '启用任务':'啟用任務',
  '中断备份':'中斷備份',
  '源存储桶':'源存儲桶',
  '中断':'中斷',
  '执行':'執行',
  '您所需区域下没有对象存储容量包,请先':'您所需區域下沒有對象存儲容量包,請先',
  '请先完成备份时间的配置':'請先完成備份時間的配置',
  '请先完成备份频率的配置':'請先完成備份頻率的配置',
  '策略说明应不少于5个字':'策略說明應不少於5個字',
  '请输入至少5个字':'請輸入至少5個字',
  '请先完成备份桶名':'請先完成備份桶名',
  '备份名称的配置':'備份名稱的配置',
  '请输入备份桶名':'請輸入備份桶名',
  '请输入备份名称':'請輸入備份名稱',
  '备份源桶':'備份源桶',
  '备份区域':'備份區域',
  '备份信息':'備份信息',
  '温馨提示：存储桶文件列表展示前50个文件，若需查看更多文件请输入文件前缀名进行搜索。':'溫馨提示：存儲桶文件列表展示前50個文件，若需查看更多文件請輸入文件前綴名進行搜索。',
  '文件已删除，若有需要请重新上传。':'文件已刪除，若有需要請重新上傳。',
  '没有权限进行该操作！':'沒有權限進行該操作！',
  '将文件拖到此处，或者':'將文件拖到此處，或者',
  '请输入文件名前缀匹配':'請輸入文件名前綴匹配',
  '请先选择访问权限！':'請先選擇訪問權限！',
  '访问权限修改成功！':'訪問權限修改成功！',
  '文件大小(KB)':'文件大小(KB)',
  '预签名url':'預簽名url',
  '修改访问权限':'修改訪問權限',
  '点击可删除':'點擊可刪除',
  '暂无文件~':'暫無文件~',
  '文件列表：':'文件列表：',
  '修改ACL':'修改ACL',
  '文件ACL':'文件ACL',
  '上传文件：':'上傳文件：',
  '复制链接':'複製鏈接',
  '点击上传':'點擊上傳',
  '文件名称':'文件名稱',
  '文件大小':'文件大小',
  '文件名':'文件名',
  '版本号':'版本號',
  '执行任务总数/天':'執行任務總數/天',
  '执行任务总数':'執行任務總數',
  '对象存储桶':'對象存儲桶',
  '执行成功数':'執行成功數',
  '写请求数：':'寫請求數：',
  '同步策略：':'同步策略：',
  '备份策略：':'備份策略：',
  '执行失败数':'執行失敗數',
  '对象总数：':'對象總數：',
  '容量包数量':'容量包數量',
  '存储总量':'存儲總量',
  '剩余总量':'剩餘總量',
  '总计':'總計',
  '读':'讀',
  '点击确定后，同步任务立即':'點擊確定後，同步任務立即',
  '中断执行正在进行同步任务':'中斷執行正在進行同步任務',
  '立即执行同步任务':'立即執行同步任務',
  '使用容量(kb)':'使用容量(kb)',
  '存储桶类型':'存儲桶類型',
  '防盗链配置':'防盜鏈配置',
  '调用次数':'調用次數',
  '对象数量':'對象數量',
  '中断同步':'中斷同步',
  '立即同步':'立即同步',
  '同步周期':'同步周期',
  '同步名称':'同步名稱',
  '对象存储':'對象存儲',
  '增加同步':'增加同步',
  '增加备份':'增加備份',
  '是否删除':'是否刪除',
  '数据：':'數據：',
  '请先完成同步时间的配置':'請先完成同步時間的配置',
  '请先完成同步频率的配置':'請先完成同步頻率的配置',
  '请先完成同步桶名':'請先完成同步桶名',
  '同步名称的配置':'同步名稱的配置',
  '请输入同步桶名':'請輸入同步桶名',
  '请输入同步名称':'請輸入同步名稱',
  '同步时间':'同步時間',
  '同步源桶':'同步源桶',
  '同步区域':'同步區域',
  '同步信息':'同步信息',
  '同步策略详情':'同步策略詳情',
  '同步策略ID':'同步策略ID',
  '同步桶名称':'同步桶名稱',
  '同步日志':'同步日誌',
  '同步策略名称':'同步策略名稱',
  '同步存储桶':'同步存儲桶',
  '添加同步':'添加同步',
  '可连接节点':'可連接節點',
  '资源属性':'資源屬性',
  '资源详情':'資源詳情',
  '资源名称':'資源名稱',
  '属性名':'屬性名',
  '选项值':'選項值',
  '目标计算节点为必选':'目標計算節點為必選',
  '编辑资源成功！':'編輯資源成功！',
  '请输入资源名称':'請輸入資源名稱',
  '选项值为必填':'選項值為必填',
  '资源code':'資源code',
  '资源图片:':'資源圖片:',
  '请先填好第':'請先填好第',
  '选项值:':'選項值:',
  '可连节点':'可連節點',
  '添加属性':'添加屬性',
  '属性名称':'屬性名稱',
  '属性描述':'屬性描述',
  '是否必填':'是否必填',
  '属性类型':'屬性類型',
  '编辑资源':'編輯資源',
  '资源描述':'資源描述',
  '资源连接':'資源連接',
  '下拉框':'下拉框',
  '上传':'上傳',
  '文本':'文本',
  '项！':'項！',
  '目标节点资源ID':'目標節點資源ID',
  '源节点资源ID':'源節點資源ID',
  '目标节点ID':'目標節點ID',
  '目标节点类型':'目標節點類型',
  '云主机ECS':'雲主機ECS',
  '源节点ID':'源節點ID',
  '源节点类型':'源節點類型',
  '资源栈名称':'資源棧名稱',
  '资源栈ID':'資源棧ID',
  '资源栈预览':'資源棧預覽',
  '资源列表':'資源列表',
  '节点ID':'節點ID',
  '资源状态':'資源狀態',
  '关系列表':'關係列表',
  '关联结果':'關聯結果',
  '关联类型':'關聯類型',
  '模板ID':'模板ID',
  '是否完成':'是否完成',
  '重试次数':'重試次數',
  '资源栈':'資源棧',
  '防火墙':'防火牆',
  '创建资源栈请求已发送，请耐心等待！':'創建資源棧請求已發送，請耐心等待！',
  '重试请求已发送，请耐心等待！':'重試請求已發送，請耐心等待！',
  '请输入资源栈名称':'請輸入資源棧名稱',
  '模板名称:':'模板名稱:',
  '请选择模板':'請選擇模板',
  '创建栈':'創建棧',
  '模板':'模板',
  '模板内容':'模板內容',
  '模板预览':'模板預覽',
  '模板详情':'模板詳情',
  '模板名称':'模板名稱',
  '请输入模板ID':'請輸入模板ID',
  '模板复制成功！':'模板複製成功！',
  '请输入模板名称':'請輸入模板名稱',
  '源模板ID':'源模板ID',
  '新建模板':'新建模板',
  '关闭参数配置将会清空已配置的数据！':'關閉參數配置將會清空已配置的數據！',
  '是否关闭参数配置！':'是否關閉參數配置！',
  '确认资源栈':'確認資源棧',
  '保存模板':'保存模板',
  '配置实例':'配置實例',
  '参数':'參數',
  '请先填选':'請先填選',
  'Flavor规格:':'Flavor規格:',
  '镜像提供方:':'鏡像提供方:',
  '云主机类型:':'雲主機類型:',
  '系统版本:':'系統版本:',
  '实例名称:':'實例名稱:',
  '应用环境:':'應用環境:',
  '记录名称:':'記錄名稱:',
  '生存时间:':'生存時間:',
  '目标系统:':'目標系統:',
  '申请理由:':'申請理由:',
  '实例描述:':'實例描述:',
  '数据库:':'數據庫:',
  '数据盘:':'數據盤:',
  '解析网络':'解析網絡',
  '源系统:':'源系統:',
  '生效时间':'生效時間',
  '大小:':'大小:',
  '机型:':'機型:',
  '子网:':'子網:',
  '名称:':'名稱:',
  '描述:':'描述:',
  '协议:':'協議:',
  '备注:':'備註:',
  '类型:':'類型:',
  '内容:':'內容:',
  '请填写记录名 !':'請填寫記錄名 !',
  '请先选择系统版本！':'請先選擇系統版本！',
  '请先选择vpc！':'請先選擇vpc！',
  '可填多个，逗号隔开,长度:1~255':'可填多個，逗號隔開,長度:1~255',
  '后缀选填,字符长度0-40':'後綴選填,字符長度0-40',
  '请先填写申请理由！':'請先填寫申請理由！',
  '请选择原系统前缀！':'請選擇原系統前綴！',
  '请先选择项目！':'請先選擇項目！',
  '是否立即生效':'是否立即生效',
  '】的生效时间':'】的生效時間',
  '目标节点':'目標節點',
  '请先选择协议！':'請先選擇協議！',
  '请填写名称！':'請填寫名稱！',
  '请填写名称':'請填寫名稱',
  '数据库名由小写字母、数字组成，字母开头，字母或数字结尾':'數據庫名由小寫字母、數字組成，字母開頭，字母或數字結尾',
  '数据库名长度为2-128个字符！':'數據庫名長度為2-128個字符！',
  '数据库名长度为2-8个字符！':'數據庫名長度為2-8個字符！',
  '注意: 1.结构迁移时：源端用户要有DML权限,目标端用户要有DDL、DML权限。\n':'註意: 1.結構遷移時：源端用戶要有DML權限,目標端用戶要有DDL、DML權限。\n',
  'C-Z任一字符加:\\开头，eg:D:\\Nextcloud\\工作':'C-Z任壹字符加:\\開頭，eg:D:\\Nextcloud\\工作',
  '工作，必须以C-Z任一字符加:\\开头\n格式2：':'工作，必須以C-Z任壹字符加:\\開頭\n格式2：',
  '多个文件路径支持以换行符分隔\n例如：\n格式1：':'多個文件路徑支持以換行符分隔\n例如：\n格式1：',
  '多个文件路径支持以逗号/换行符分隔\n例如：\n格式1：aa.txt\n格式2：\\aaa':'多個文件路徑支持以逗號/換行符分隔\n例如：\n格式1：aa.txt\n格式2：\\aaa',
  '请输入文件路径\n每一行一个路径，例如：':'請輸入文件路徑\n每壹行壹個路徑，例如：',
  '中文简体': '中文簡體',
  '中文繁体': '中文繁體',
  '英文': '英語',
  '1 v 1 入云方案咨询': '1 v 1 入雲方案諮詢',
  '7x24 小时专家客服': '7x24 小時專家客服',
  '最高级别安全合规': '最高級別安全合規',
  '专业架构师指引': '專業架構師指引',
  '相关法律文件': '相關法律文件',
  '产品白皮书': '產品白皮書',
  '权益与要求': '權益與要求',
  '支持与服务': '支持與服務',
  '申请加入': '申請加入',
  '优秀伙伴': '優秀夥伴',
  '招商云是集团数字化战略的核心赋能平台，是数字化转型建设的技术底座，对促进产业共享、提升收益，汇聚数据、挖掘价值，打造云化生态和产业转型升级具有不可替代的作用。是赋能二级公司客户服务、生产经营、内部管理、生态打造和助力招商局产业转型的先导工程。招商云以“云生态、云赋能、云数据、云产业”为四大目标，构建云上生态圈，打造IaaS，PaaS，SaaS三位一体的云服务。': '招商雲是集團數字化戰略的核心賦能平臺，是數字化轉型建設的技術底座，對促進產業共享、提升收益，匯聚數據、挖掘價值，打造雲化生態和產業轉型升級具有不可替代的作用。是賦能二級公司客戶服務、生產經營、內部管理、生態打造和助力招商局產業轉型的先導工程。招商雲以“雲生態、雲賦能、雲數據、雲產業”爲四大目標，構建雲上生態圈，打造IaaS，PaaS，SaaS三位一體的雲服務。',
  '您未拥有此权限，获取权限请联系管理员！': '您未擁有此權限，獲取權限請聯繫管理員！',
  '请使用招商随行扫码登录': '請使用招商隨行掃碼登錄',
  '请选择账号类型': '請選擇賬號類型',
  '请选择账户类型': '請選擇賬戶類型',
  '请输入用户名': '請輸入用戶名',
  '二维码已失效': '二維碼已失效',
  '刷新二维码': '刷新二維碼',
  '互联网用户': '互聯網用戶',
  '扫码登录': '掃碼登錄',
  '解冻账号': '解凍賬號',
  '已登入!': '已登入!',
  '账号登录': '賬號登錄',
  '登 录': '登 錄',
  '点这里': '點這裏',
  '获 取': '獲 取',
  '个IP相同,请先修改!': '個IP相同,請先修改!',
  '数据删除成功!': '數據刪除成功!',
  '版本发布服务': '版本發布服務',
  '数据处理服务': '數據處理服務',
  '云磁盘': '雲磁盤',
  '云磁盘快照': '雲磁盤快照',
  '虚拟IP': '虛擬IP',
  'OSS对象存储': 'OSS對象存儲',
  'VPC子网': 'VPC子網',
  'OSS桶同步': 'OSS桶同步',
  'ecs文件备份': 'ecs文件備份',
  '固定公网IP': '固定公網IP',
  '弹性网卡': '彈性網卡',
  '桌面服务': '桌面服務',
  '云打印服务': '雲打印服務',
  'OSS桶备份': 'OSS桶備份',
  '邮件服务': '郵件服務',
  '云桌面服务': '雲桌面服務',
  '数据库同步': '數據庫同步',
  '物理裸机': '物理裸機',
  '桌面安全': '桌面安全',
  '应用安全': '應用安全',
  'SSL证书服务': 'SSL證書服務',
  '主机安全服务': '主機安全服務',
  '数据库审计服务': '數據庫審計服務',
  '态势感知服务': '態勢感知服務',
  '网盘服务': '網盤服務',
  'GPU物理机服务': 'GPU物理機服務',
  '文件备份': '文件備份',
  '互联网带宽': '互聯網帶寬', 
  '专线带宽': '專線帶寬',
  'OSS存储包': 'OSS存儲包',
  '弹性公网IP': '彈性公網IP',
  '数据库还原': '數據庫還原',
  'ecs文件恢复': 'ecs文件恢復',
  'NAS备份': 'NAS備份',
  '云主机|云磁盘': '雲主機|雲磁盤',
  'NAS|NAS同步':'NAS|NAS同步',
  '云主机|EIP':'雲主機|EIP',
  '文件存储': '文件存儲',
  '请选择字符集 !':'請選擇字符集 !',
  '请选择块大小 !':'請選擇塊大小 !',
  '请选择关联证书!': '請選擇關聯證書',
  '启/禁用状态修改成功!': '啓/禁用狀態修改成功!',
  '协议监听编辑成功!': '協議監聽編輯成功!',
  '健康检查修改成功!': '健康檢查修改成功!',
  '预检查失败': '預檢查失敗',
  '挂载云磁盘': '掛載雲磁盤',
  '挂载NAS': '掛載NAS',
  'DNS绑定': 'DNS綁定',
  '新增后端服务器成功!': '新增後端服務器成功!',
  '问题描述:': '問題描述:',
  '请先选择搜索维度！':'請先選擇搜索維度！',
  '同步级别：': '同步級別：',
  '源端数据库：': '源端數據庫：',
  '目标端数据库：': '目標端數據庫：',
  '新增目标端库名成功！': '新增目標端庫名成功！',
  '项目负责人':'項目負責人',
  '销毁中': '銷毀中',
  '删除前请确认数据是否备份，如需备份请联系存储组备份，以免造成损失': '删除前請確認數據是否備份，如需備份請聯系存儲組備份，以免造成損失',
  '删除前请确认数据是否备份，以免造成损失，': '删除前請確認數據是否備份，以免造成損失，',
  '备份后请及时禁用备份策略': '備份後請及時禁用備份策略',
  '去備份': '去備份',
  '到期时间': '到期時間',
  '立即销毁': '立即銷毀',
  '数据库回收站': '數據庫回收站',
  '软删除': '軟刪除',
  '数据库详情': '數據庫詳情',
  '可填多个端口或端口段，多个端口用英文逗号/空格/换行符分隔；\n多个连续端口可用中横线隔开，示例：8080-10000；\n总长度不超过100个字符':'可填多個端口或端口段，多個端口用英文逗號/空格/換行符分隔；\n多個連續端口可用中橫線隔開，示例：8080-10000；\n總長度不超過100個字符',
  '充值总额:': '充值總額:',
  '开始日期': '開始日期',
  '结束日期': '結束日期',
  '过滤': '過濾',
  '编辑额度(元)：': '編輯額度(元)：',
  '项目可用余额(元)': '項目可用餘額(元)',
  '额度启用': '額度啓用',
  '发票信息管理':'發票信息管理',
  '项目额度管理': '項目額度管理',
  '编辑额度': '編輯額度',
  '成功！': '成功！',
  '本月当前费用': '本月當前費用',
  '预测本月费用': '預測本月費用',
  '目录类别': '目錄類別',
  '适用范围': '適用範圍',
  '集团': '集團',
  '内部结算': '內部結算',
  '实业板块': '實業板塊',
  '外部市场': '外部市場',
  '请选择目录类别！': '請選擇目錄類別！',
  '最新备份记录': '最新備份記錄',
  '完成时间': '完成時間',
  '请等待备份任务完成或停止备份任务后再删除。': '請等待備份任務完成或停止備份任務後再刪除。',
  '数据还未备份，建议先备份以免造成损失，': '數據還未備份，建議先備份以免造成損失，',
  '可在': '可在',
  '查看该数据库完整的备份记录，并根据实际情况进行数据备份': '查看該資料庫完整的備份記錄，並根據實際情況進行資料備份',
  '温馨提示：您若需要卸载或删除块存储SAN，请在招商云': '溫馨提示：您若需要卸載或刪除塊存儲SAN，請在招商雲',
  '块存储SAN 帮助文档':'塊存儲SAN 幫助文檔',
  '需要网络连接后再进行购买操作。可申请工单处理完成后进行购买操作。您可重新选择其它云裸机进行挂载。': '需要網絡連接後再進行購買操作。可申請工單處理完成後進行購買操作。您可重新選擇其它雲裸機進行掛載。',
  '块存储SAN与云裸机光纤网络连接': '塊存儲SAN與雲裸機光纖網絡連接',
  '您的云裸机的HBA网络未连接': '您的雲裸機的HBA網絡未連接',
  '当前条件没有存储类型！': '當前條件沒有存儲類型！',
  '设置SAN存储信息': '設置SAN存儲信息',
  '没有可挂载的云裸机': '沒有可掛載的雲裸機',
  'SAN存储-编辑': 'SAN存儲-編輯',
  '添加SAN存储': '添加SAN存儲',
  'SAN存储购买': 'SAN存儲購買',
  '请选择云裸机!': '請選擇雲裸機!',
  '云裸机不能为空': '雲裸機不能為空',
  'SAN存储详情': 'SAN存儲詳情',
  '块存储SAN': '塊存儲SAN',
  '挂载裸机IP': '掛載裸機IP',
  '磁盘名称：': '磁盤名稱：',
  '磁盘用途：': '磁盤用途：',
  '挂载云裸机': '掛載雲裸機',
  '挂载裸机名': '掛載裸機名',
  '磁盘用途': '磁盤用途',
  '磁盘数量': '磁盤數量',
  '云裸机：': '雲裸機：',
  '挂载成功': '掛載成功',
  '超高端': '超高端',
  '日志盘': '日誌盤',
  '心跳盘': '心跳盤',
  '提工单': '提工單',
  '挂载中': '掛載中',
  '卸载中': '卸載中',
  '普通': '普通',
  '中端': '中端',
  '高端': '高端',
  '挂载SAN存储':'掛載SAN存儲',
  '删除云裸机失败':'刪除雲裸機失敗',
  '删除云裸机前请取消挂载SAN存储盘':'刪除雲裸機前請取消掛載SAN存儲盤',
  '没有可挂载的SAN':'沒有可掛載的SAN',
  'SAN存储盘':'SAN存儲盤',
  'MySQL备份': 'MySQL備份',
  '确认要禁用': '確認要禁用',
  '点击确定后，备份策略将不在执行': '點擊確定後，備份策略將不在執行',
  '禁用备份策略成功!': '禁用備份策略成功!',
  '确认要启用': '確認要啟用',
  '点击确定后，启用备份策略': '點擊確定後，啟用備份策略',
  '启用备份策略成功!': '啟用備份策略成功!',
  '确定删除当前备份策略吗?': '確定删除當前備份策略嗎?',
  '源数据库ID': '源數據庫ID',
  '数据库IP地址': '數據庫IP地址',
  '源数据库实例': '源數據庫實例',
  '配置备份计划': '配寘備份計畫',
  '请输入策略名称': '請輸入策略名稱',
  '请输入计划名称': '請輸入計畫名稱',
  '租户额度未启用状态不能编辑!': '租戶額度未啓用狀態不能編輯!',
  '请正确填写额度!': '請正確填寫額度!',
  '额度最多两位小数!': '額度最多兩位小數!',
  '信用额度(元)': '信用額度(元)',
  '项目额度(元)': '項目額度(元)',
  '挂载时间':'掛載時間',
  '挂载SAN':'掛載SAN',
  '请输入域名或URL': '請輸入域名或URL',
  'URL刷新': 'URL刷新',
  'URL预热': 'URL預熱',
  '刷新预热': '刷新預熱',
  '操作内容': '操作內容',
  '所有类型': '所有類型',
  '刷新类型': '刷新類型',
  '预热区域': '預熱區域',
  '每日刷新上限2000，预热上限500，目录上限100。刷新任务生效时间大约为5分钟。': '每日刷新上限2000，預熱上限500，目錄上限100。刷新任務生效時間大約爲5分鐘。',
  '当您需要刷新或预热多条请求时，请按照一行一个URL进行输入，并以http://或https://开头。\t\n刷新或预热URL，示例：http://www.test.com/test.html。\t\n刷新目录需以 / 结束，示例：http://www.test.com/test/。': '當您需要刷新或預熱多條請求時，請按照一行一個URL進行輸入，並以http://或https://開頭。\t\n刷新或預熱URL，示例：http://www.test.com/test.html。\t\n刷新目錄需以 / 結束，示例：http://www.test.com/test/。',
  '请输入正确的URL，必须以http://或https://开头，不能重复。': '請輸入正確的URL，必須以http://或https://開頭，不能重複。',
  '请输入正确的URL，刷新目录需以"/"结束。': '請輸入正確的URL，刷新目錄需以"/"結束。',
  '文件刷新': '文件刷新',
  '目录刷新': '目錄刷新',
  '请选择操作类型 !': '請選擇操作類型 !',
  '请选择刷新类型 !': '請選擇刷新類型 !',
  '请选择预热区域 !': '請選擇預熱區域 !',
  '请先填写URL !': '請先填寫URL !',
  '预热刷新中': '預熱刷新中',
  '后端UUID':'後端UUID',
  '当前条件没有配置相应工单,请先配置！':'當前條件沒有配置相應工單,請先配置！',
  '剩余刷新量': '剩餘刷新量',
  '操作失败': '操作失敗',
  '备份策略处于【备份软件安装中】/【策略下发中】状态，【不】允许删除!': '備份策略處於【備份軟體安裝中】/【策略下發中】狀態，【不】允許删除!',
  '源数据库IP': '源數據庫IP',
  '建议选择购买当前云裸机已挂载使用的存储类型和磁盘类型': '建議選擇購買當前雲裸機已掛載使用的存儲類型和磁盤類型',
  '超高端存储：稳定性和安全性最好，适用于核心业务系统': '超高端存儲：穩定性和安全性最好，適用於核心業務系統',
  '高端存储：稳定性和安全性较好，适用于重要业务系统': '高端存儲：穩定性和安全性較好，適用於重要業務系統',
  '中端存储：稳定性和安全性一般，适用于一般业务系统': '中端存儲：穩定性和安全性壹般，適用於壹般業務系統',
  '普通存储：稳定性和安全性较差，适用于边缘业务系统': '普通存儲：穩定性和安全性較差，適用於邊緣業務系統',
  'NVME：新一代固态磁盘，性能最好、延时最低，适用于核心业务系统': 'NVME：新壹代固態磁盤，性能最好、延時最低，適用於核心業務系統',
  'SSD：固态磁盘，性能较好、延时较低，适用于重要业务系统': 'SSD：固態磁盤，性能較好、延時較低，適用於重要業務系統',
  'SAS：机械磁盘，性能一般、延时一般，适用于一般业务系统': 'SAS：機械磁盤，性能壹般、延時壹般，適用於壹般業務系統',
  'SATA：机械磁盘，性能较差、延时较高，适用于边缘业务系统和归档数据': 'SATA：機械磁盤，性能較差、延時較高，適用於邊緣業務系統和歸檔數據',
  '申请工单':'申請工單',
  '删除前请确保数据已备份，若未备份删除后数据无法找回':'刪除前請確保數據已備份，若未備份刪除後數據無法找回',
  '账号需要具备所迁移对象的 RELOAD, SELECT, SHOW VIEW, EVENT, TRIGGER及MySQL库的SELECT权限。': '賬號需要具備所遷移對象的 RELOAD, SELECT, SHOW VIEW, EVENT, TRIGGER及MySQL庫的SELECT權限。',
  '表级别迁移：账号需要具备 select_catalog_role, select any table 或 DBA权限。': '表級別遷移：賬號需要具備 select_catalog_role, select any table 或 DBA權限。',
  '用户级别迁移：账户需要具备 EXP_FULL_DATABASE 或 DBA权限。': '用戶級別遷移：賬戶需要具備 EXP_FULL_DATABASE 或 DBA權限。',
  '账号需要具备 INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限。': '賬號需要具備 INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER權限。',
  '表级别迁移：账号需要具备 select_catalog_role及目标对象的操作权限 或 DBA权限。': '表級別遷移：賬號需要具備 select_catalog_role及目標對象的操作權限 或 DBA權限。',
  '用户级别迁移：账户需要具备 IMP_FULL_DATABASE 或 DBA权限。': '用戶級別遷移：賬戶需要具備 IMP_FULL_DATABASE 或 DBA權限。',
  '账号需要具备所同步对象的 SELECT, SHOW VIEW, TRIGGER, RELOAD, REPLICATION SLAVE, REPLICATION CLIENT及MySQL库的SELECT权限。': '賬號需要具備所同步對象的 SELECT, SHOW VIEW, TRIGGER, RELOAD, REPLICATION SLAVE, REPLICATION CLIENT及MySQL庫的SELECT權限。',
  '账号需要具备 SELECT, INSERT, UPDATE, DELETE, INDEX, CREATE, DROP, ALTER, SUPER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, TRIGGER权限。': '賬號需要具備 SELECT, INSERT, UPDATE, DELETE, INDEX, CREATE, DROP, ALTER, SUPER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, TRIGGER權限。',
  '账户需要具备DBA权限。': '賬戶需要具備DBA權限。',
  '检查源数据库的账号权限是否满足迁移要求': '檢查源數據庫的賬號權限是否滿足遷移要求',
  '检查源库是否存在待同步的结构对象': '檢查源庫是否存在待同步的結構對象',
  '未检查': '未檢查',
  '启用DDL同步：': '啓用DDL同步：',
  '源数据共用：': '源數據共用：',
  '高级选项': '高級選項',
  '配件类型': '配件類型',
  '配件型号': '配件型號',
  '配件数量': '配件數量',
  '+添加物理配件': '+添加物理配件',
  '配件': '配件',
  '源数据库名称': '源數據庫名稱',
  '当前状态不支持创建备份策略！': '當前狀態不支持創建備份策略！',
  '配件数量不能大于插槽口数量!': '配件數量不能大於插槽口數量!',
  '配件类型和配件数量需要同时配置!': '配件類型和配件數量需要同時配置!',
  '配置项不能为空!': '配置項不能爲空!',
  '备份策略处于【启动中】/【备份软件安装中】/【策略下发中】状态，【不】允许删除!': '備份策略處於【啟動中】/【備份軟體安裝中】/【策略下發中】狀態，【不】允許删除!',
  '一次最多可授权10台主机！': '一次最多可授權10臺主機！',
  '目录计费类型': '目錄計費類型',
  '收费对象性质': '收費對象性質',
  '请选择目录计费类型！': '請選擇目錄計費類型！',
  '请选择收费对象性质！': '請選擇收費對象性質！',
  '目录类别:': '目錄類別:',
  '请选择目录类别': '請選擇目錄類別',
  '适用范围:': '適用範圍',
  '请选择适用范围': '請選擇適用範圍',
  '云环境': '雲環境',
  '当前选项下暂无区域，请修改配置': '當前選項下暫無區域，請修改配置',
  '集群类型': '集羣類型',
  '通用集群': '通用集羣',
  '高级设置': '高級設定',
  '请先选择集群类型！': '請先選擇集羣類型！',
  'IP类型': 'IP類型',
  '不支持any，可以多个port，用逗号隔开，1-65535': '不支持any，可以多個port，用逗號隔開，1-65535',
  '请先选择内网IP !': '請先選擇內網IP !',
  '请先填写内网端口 !': '請先填寫內網端口 !',
  '请先选择协议类型 !': '請先選擇協定類型 !',
  '不支持any，可以多个port，用逗号隔开，个数与internal_port一致，且端口号一一对应；端口号不能重复使用；1-65535': '不支持any，可以多個port，用逗號隔開，個數與internal_port一致，且端口號一一對應；端口號不能重覆使用；1-65535',
  '不支持any，可以多个port，用逗号隔开，个数与eip_port一致，1-65535': '不支持any，可以多個port，用逗號隔開，個數與eip_port一致，1-65535',
  '支持any，多端口号(逗号隔开,可有port段)，如:(1,3-10,12)，但与dest_ip不可同时为any；1-65535': '支持any，多端口號(逗號隔開,可有port段)，如:(1,3-10,12)，但與dest_ip不可同時為any；1-65535',
  '主机名:': '主機名:',
  '配置:': '配置:',
  '展示的是招商私有云的云数据库实例为运行状态的统计数据': '展示的是招商私有雲的雲數據庫實例為運行狀態的統計數據',
  '展示的是招商私有云的云主机资源概览': '展示的是招商私有雲的雲主機資源概覽',
  '展示的是招商私有云的云硬盘资源概览': '展示的是招商私有雲的雲硬盤資源概覽',
  '通用型云硬盘(个(GB))': '通用型雲硬盤(個(GB))',
  '云主机(台(vCPU))': '雲主機(臺(vCPU))',
  '招商私有云计算资源概览': '招商私有雲計算資源概覽',
  '云数据库类型分布情况': '雲數據庫類型分布情況',
  '数据库实例总数(个)': '數據庫實例總數(個)',
  '公有云计算资源概览': '公有雲計算資源概覽',
  '本月当前费用(元)': '本月當前費用(元)',
  '预测本月费用(元)': '預測本月費用(元)',
  '云主机总数(台)': '雲主機總數(臺)',
  '项目资源使用情况': '項目資源使用情況',
  '数据库实例(个)': '數據庫實例(個)',
  '云主机快照(个)': '雲主機快照(個)',
  '通用型系统存储': '通用型系統存儲',
  '云主机运行情况': '雲主機運行情況',
  '云硬盘运行情况': '雲硬盤運行情況',
  'NAS(个)': 'NAS(個)',
  '云资源概览': '雲資源概覽',
  '云硬盘总量': '雲硬盤總量',
  '产品类目：': '產品類目：',
  '项目名称：': '項目名稱：',
  '待查事项': '待查事項',
  '待办工单': '待辦工單',
  '待办审批': '待辦審批',
  '最新公告': '最新公告',
  '资源IP': '資源IP',
  '高性能型': '高性能型',
  '运行总数': '運行總數',
  '华为云': '華為雲',
  '天翼云': '天翼雲',
  '容量型': '容量型',
  '告警': '告警',
  '职能':'職能',
  '运维管理':'運維管理',
  '请先输入计划名称':'請先輸入計劃名稱',
  '您的MySQL数据库未进行备份操作':'您的MySQL數據庫未進行備份操作',
  '若有需要，请后续MySQL数据库进行备份操作':'若有需要，請後續MySQL數據庫進行備份操作',
  '备份设置':'備份設置',
  '启动数据库备份':'啟動數據庫備份',
  '修改数据库备份':'修改數據庫備份',
  '计算节点': '計算節點',
  'AD域': 'AD域',
  'openstack集群': 'openstack集群',
  'Flavor': 'Flavor',
  '地区': '地區',
  '动作': '動作',
  '短信功能': '短信功能',
  'DNS': 'DNS',
  '策略组': '策略組',
  'NAS': 'NAS',
  '策略子项': '策略子項',
  'Mysql数据库': 'Mysql數據庫',
  'Redis数据库': 'Redis數據庫',
  'Oracle数据库': 'Oracle數據庫',
  'Mongo数据库': 'Mongo數據庫',
  'PostgreSQL数据库': 'PostgreSQL數據庫',
  '数据库规格管理': '數據庫規格管理',
  '数据库版本管理': '數據庫版本管理',
  '数据库类型管理': '數據庫類型管理',
  '数据库托管项目配置': '數據庫托管項目配置',
  '云主机文件备份': '雲主機文件備份',
  'SAN存储': 'SAN存儲',
  '回收站': '回收站',
  '公有云': '公有雲',
  '密码找回': '密碼找回',
  '密码重置': '密碼重置',
  '输入新密码': '輸入新密碼',
  '确认新密码': '確認新密碼',
  '确 认': '確 認',
  '返回登录': '返回登錄',
  '仅支持互联网用户找回密码！': '僅支持互聯網用戶找回密碼！',
  '两次密码不一致 !': '兩次密碼不一致 !',
  '密码格式错误': '密碼格式錯誤',
  '密码重置成功！': '密碼重置成功！',
  '昵称:': '暱稱:',
  '验证码:': '驗證碼:',
  '新密码': '新密碼',
  '如更改，请填写新密码': '如更改，請填寫新密碼',
  '8-21位字符': '8-21位字符',
  '请填写昵称!': '請填寫暱稱!',
  '请填写验证码！': '請填寫驗證碼！',
  '已使用容量': '已使用容量',
  '不能包含中文字符': '不能包含中文字符',
  '不能包含中文字符;': '不能包含中文字符;',
  '请正确填写密码!': '請正確填寫密碼!',
  '请正确填写邮箱!': '請正確填寫郵箱!',
  '天翼云磁盘暂不支持编辑功能': '天翼雲磁盤暫不支持編輯功能',
  '忘记密码': '忘記密碼',
  '必须为有效邮箱': '必須爲有效郵箱',
  '必须包含大小写字母、数字、特殊字符': '必須包含大小寫字母、數字、特殊字符',
  'NAS卷名称': 'NAS卷名稱',
  'NAS可用区': 'NAS可用區',
  '备份NAS名称': '備份NAS名稱',
  'NAS协议': 'NAS協議',
  'NAS名称': 'NAS名稱',
  '保留数据': '保留數據',
  '源NAS卷名称': '源NAS卷名稱',
  '目标NAS名称': '目標NAS名稱',
  '目标NAS可用区': '目標NAS可用區',
  '目标NAS的ID': '目標NAS的ID',
  '恢复NAS卷': '恢復NAS卷',
  '请输入需要创建的恢复名称':'請輸入需要創建的恢復名稱',
  '目标nas卷名称': '目標NAS捲名稱',
  '请填写恢复名称': '請填寫恢復名稱',
  '请选择目标NAS卷': '請選擇目標NAS卷',
  '请填写策略名称': '請填寫策略名稱',
  '备份发起时间': '備份發起時間',
  '请先配置全量计划名称': '請先配置全量計劃名稱',
  '请先配置全量开始时间': '請先配置全量開始時間',
  '请先配置全量备份周期': '請先配置全量備份周期',
  '请先配置每周备份日期': '請先配置每周備份日期',
  '请先配置每月备份日期': '請先配置每月備份日期',
  '请先配置备份保留时间': '請先配置備份保留時間',
  '请先配置增量计划名称': '請先配置增量計劃名稱',
  '请先配置增量开始时间': '請先配置增量開始時間',
  '请先配置增量备份周期': '請先配置增量備份周期',
  '请先配置增量每周备份日期': '請先配置增量每周備份日期',
  '请先配置增量每月备份日期': '請先配置增量每月備份日期',
  '启用NAS备份': '啟用NAS備份',
  '您的NAS卷未进行备份操作，若需要容灾后续可对新购NAS卷进行备份配置。': '您的NAS捲未進行備份操作，若需要容災後續可對新購NAS捲進行備份配置',
  'NAS同步备份': 'NAS同步備份',
  '已启动': '已啟動',
  '未启动': '未啟動',
  '修改NAS备份': '修改NAS備份',
  '指定IP': '指定IP',
  '请输入需要指定的IP': '請輸入需要指定的IP',
  '请输入正确的IPv4地址!': '請輸入正確的IPv4地址!',
  '回收人': '回收人',
  '回收时间': '回收時間',
  '云主机回收':'雲主機回收',
  '系统和文件备份':'系統和文件備份',
  '招商云建议进行在云主机回收前进行系统和文件的备份。':'招商雲建議進行在雲主機回收前進行系統和文件的備份。',
  '文件备份:':'文件備份',
  '创建文件备份':'創建文件備份',
  '确认回收':'確認回收',
  '请输入验证码:':'請輸入驗證碼',
  '销毁':'銷毀',
  '回收':'回收',
  '云主机的相关磁盘同时进行恢复，恢复后将正常收取招商云费用。':'雲主機的相關磁盤同時進行恢復，恢復後將正常收取招商雲費用。',
  '云主机销毁':'雲主機銷毀',
  '销毁资源':'銷毀資源',
  'NAS授权':'NAS授權',
  '已授权的NAS列表':'已授權的NAS列表',
  '销毁云主机后NAS会自动卸载并取消授权':'銷毀雲主機後NAS會自動卸載並取消授權',
  '云网络产品':'雲網絡產品',
  '创建快照 & 下一步':'創建快照 & 下一步',
  '请输入快照名称':'請輸入快照名稱',
  '已挂载的云硬盘列表':'已掛載的雲硬盤列表',
  '回收云硬盘前请确认数据已备份':'回收雲硬盤前請確認數據已備份',
  '请先填写快照名称':'請先填寫快照名稱',
  '请先获取并填写短信验证码':'請先獲取並填寫短信驗證碼',
  '计算资源回收':'計算資源回收',
  '资源销毁':'資源銷毀',
  'IP释放':'IP釋放',
  '源端用户': '源端用戶',
  '源库ip': '源庫ip',
  '目标库ip': '目標庫ip',
  '源端租户': '源端租戶',
  '目标端租户': '目標端租戶',
  '源端租户名称': '源端租戶名稱',
  '目标端租户名称': '目標端租戶名稱',
  '跨租户迁移': '跨租戶遷移',
  '账号需要具备所迁移对象的SELECT权限':'賬號需要具備所遷移對象的SELECT權限',
  '表级别迁移：账号需要具备 select_catalog_role, select any table 或 DBA权限。': '表級別遷移：賬號需要具備 select_catalog_role, select any table 或 DBA權限。',
  '销毁成功':'銷毀成功',
  '3.oracle迁移不支持列名小写': '3.oracle遷移不支持列名小寫',
  '数据表名不能重复新增': '資料表名不能重複新增',
  '请输入中文名': '請輸入中文名',
  '请输入域账号': '請輸入域帳號',
  '开票名称1': '開票名稱1',
  '开票名称2': '開票名稱2',
  '开票名称': '開票名稱',
  '目录负责人域账号': '目錄負責人域帳號',
  '温馨提示：卸载云磁盘需先执行umount（Linux）或脱机（windows）操作，否则会导致磁盘再次挂载不可用。': '溫馨提示：卸載雲磁片需先執行umount（Linux）或離線（windows）操作，否則會導致磁片再次掛載不可用。',
  '请选择云环境': '請選擇雲環境',
  '资源纳管项目名称': '資源納管項目名稱',
  '从公有云同步至招商云的资源将暂存在此项目，后续可切换至该项目查看同步的资源，': '從公有雲同步至招商雲的資源將暫存在此項目，後續可切換至該項目查看同步的資源，',
  '并修改资源归属项目。': '並修改資源歸屬項目。',
  '项目名称长度最长61个字符': '項目名稱長度最長61個字符',
  '资源纳管项目中文名': '資源納管項目中文名',
  '项目中文名长度最长64个字符': '項目中文名長度最長64個字符',
  '资源纳管项目备注': '資源納管項目備註',
  '项目备注长度最长64个字符': '項目備註長度最長64個字符',
  '请填写Access Key ID！': '請填寫Access Key ID！',
  '请填写Access Key Secret！': '請填寫Access Key Secret！',
  '请填写资源纳管项目名称！': '請填寫資源納管項目名稱！',
  '云账号添加成功！': '雲帳號添加成功！',
  '云账号编辑成功！': '雲帳號編輯成功！',
  '同步操作开始！': '同步操作開始！',
  '校验成功！': '校驗成功！',
  'AccessKey管理': 'AccessKey管理',
  '同步概况': '同步概況',
  '同步开始时间': '同步開始時間',
  '同步结束时间': '同步結束時間',
  '同步人': '同步人',
  '同步成功': '同步成功',
  '同步失败': '同步失敗',
  '请注意！': '請注意！',
  '一次只能启用一个AccessKey，请在启用新的AccessKey前，禁用正在使用的AccessKey。': '一次只能啟用一個AccessKey，請在啟用新的AccessKey前，禁用正在使用的AccessKey。',
  '网卡多队列': '網卡多隊列',
  '目标网端口长度为1-80！': '目標網端口長度為1-80！',
  '端口为any时请勿写入其他端口号': '端口為any時請勿寫入其他端口號',
  '端口范围为1-65535！': '端口範圍為1-65535！',
  '端口号不可重复！': '端口號不可重複！',
  '目标端口和目标ip不可同时为any！': '目標端口和目標ip不可同時為any！',
  'EIP端口及内网端口长度为1-80！': 'EIP端口及內網端口長度為1-80！',
  '不支持any，支持多IP和CIDR（英文逗号隔开），IP长度为：1～2000': '不支持any，支持多IP和CIDR（英文逗號隔開），IP長度為：1～2000',
  '不支持any，支持多端口（英文逗号隔开）或端口段（用中横线连接），\n示例：（1，3-10，12）；端口长度为：1～1024；端口范围为1～65535': '不支持any，支持多端口（英文逗號隔開）或端口段（用中橫線連接），\n示例：（1，3-10，12）；端口長度為：1～1024；端口範圍為1～65535',
  'EIP端口与内网端口个数需一致！': 'EIP端口與內網端口個數需一致！',
  '备份策略处于【创建中】状态，【不】允许删除!': '備份策略處於【創建中】狀態，【不】允許刪除!',
  '空表单无法提交': '空表單無法提交',
  '资源监控': '資源監控',
  '引擎监控': '引擎監控',
  '温馨提示：在云主机回收前，建议先进行文件备份，以免造成损失': '溫馨提示：在雲主機回收前，建議先進行檔案備份，以免造成損失',
  '云账号': '雲帳號',
  '云账号管理': '雲帳號管理',
  '云账号名称': '雲帳號名稱',
  '添加云账号': '添加雲帳號',
  '启用NAS同步': '啟用NAS同步',
  '周备份': '周備份',
  '月备份': '月備份',
  '常规备份': '常規備份',
  '备份中': '備份中',
  '已复制至剪切板！': '已複製至剪切板！',
  '请先配置计划名称': '請先配置計劃名稱',
  '请先配置开始时间': '請先配置開始時間',
  '请先配置备份周期': '請先配置備份周期',
  '请先配置备份类型': '請先配置備份類型',
  '请先配置备份周期具体天数': '請先配置備份周期具體天數',
  '增量式备份': '增量式備份',
  '用户备份':'用戶備份',
  '用户存档': '用戶存檔',
  '累积增量式备份': '累積增量式備份',
  '事务日志备份': '事務日誌備份',
  '恢复成功': '恢復成功',
  '部分恢复成功': '部分恢復成功',
  '创建恢复任务': '創建恢復任務',
  '当前策略无备份记录可恢复': '當前策略無備份記錄可恢復',
  '确定禁用备份策略吗?': '確定禁用備份策略嗎?',
  '当前状态不能编辑':'當前狀態不能編輯',
  '确定立即执行备份任务吗?':'確定立即執行備份任務嗎?',
  '请输入恢复名称': '請輸入恢復名稱',
  '请选择需要恢复的备份记录': '請選擇需要恢復的備份記錄',
  '请选择目标nas卷名称': '請選擇目標nas卷名稱',
  'NAS 详情': 'NAS 詳情',
  '创建NAS策略备份': '創建NAS策略備份',
  '添加备份NAS': '添加備份NAS',
  '有效nas卷': '有效nas卷',
  '请先配置恢复记录名称': '請先配置恢復記錄名稱',
  '请先选择恢复的目标nas名称': '請先選擇恢復的目標nas名稱',
  '多云管理': '多雲管理',
  '温馨提示：Flavor规则配置修改会重启数据库实例,请评估业务影响范围,选择合适时间窗口变更,谨慎操作。': '溫馨提示：Flavor規則配寘修改會重啓資料庫實例，請評估業務影響範圍，選擇合適時間視窗變更，謹慎操作。',
  '正在查询价格': '正在査詢價格',
  '修改后：': '修改後：',
  '修改前：': '修改前：',
  '磁盘扩容': '磁片擴容',
  '当前磁盘容量已为最大值！': '當前磁片容量已為最大值！',
  '请先选择Flavor规格！': '請先選擇Flavor規格！',
  '修改配置成功！': '修改配寘成功！',
  '请至少扩容50GB！': '請至少擴容50GB！',
  '磁盘扩容成功！': '磁片擴容成功！',
  '申请理由最长1000字符': '申請理由最長1000字符',
  '备注最长1000字符': '备注最長1000字符',
  '插件管理': '挿件管理',
  '可用插件': '可用挿件',
  '插件名': '挿件名',
  '插件名称': '挿件名稱',
  '默认版本': '默認版本',
  '当前版本': '當前版本',
  '安装': '安裝',
  '该【': '該【',
  '】插件?': '】挿件?',
  '安装插件成功！': '安裝挿件成功！',
  '卸载插件成功！': '卸載挿件成功！',
  '同步详情': '同步詳情',
  'NAS还原': 'NAS還原',
  '当前用户已解锁 !': '當前用戶已解鎖 !',
  '当前用户已被锁定 !': '當前用戶已被鎖定 !',
  '云账号详情': '雲帳號詳情',
  '请勾选需要批量操作的资源':'請勾選需要批量操作的資源',
  '主机配置':'主機配置',
  '主机IP':'主機IP',
  '选择云环境':'選擇雲環境',
  '请选择需要同步的区域，将其添加到平台中进行资源同步':'請選擇需要同步的區域，將其添加到平臺中進行資源同步',
  '账号设置':'賬號設置',
  '公有云项目设置':'公有雲項目設置',
  '选择同步区域':'選擇同步區域',
  '请输入描述':'請輸入描述',
  '请输入云账号名称':'請輸入雲賬號名稱',
  '同步区域管理':'同步區域管理',
  '区域名称':'區域名稱',
  '待选择区域':'待選擇區域',
  '已选择区域':'已選擇區域',
  '确定要移除【':'確定要移除【',
  '自定义权限': '自定義權限',
  '自定义标签': '自定義標簽',
  '磁盘使用率低': '磁盤使用率低',
  '磁盘使用率高': '磁盤使用率高',
  '云数据库实例总数': '雲數據庫實例總數',
  '数据库磁盘类型分布': '數據庫磁盤類型分布',
  '数据库实例uuid': '數據庫實例uuid',
  '数据库磁盘剩余率分布': '數據庫磁盤剩余率分布',
  '数据库磁盘使用率分布': '數據庫磁盤使用率分布',
  '权限列表': '權限列表',
  '自定义权限不能为空！': '自定義權限不能為空！',
  '自定义用户': '自定義用戶',
  '权限更新成功！': '權限更新成功！',
  '默认表空间': '默認表空間',
  '临时表空间': '臨時表空間',
  'data盘总容量：':'data盤總容量：',
  '所有表空间已占容量：': '所有表空間已占容量：',
  '表空间类型：': '表空間類型：',
  '表空间大小：': '表空間大小：',
  '配额类型：': '配額類型：',
  '表空间名称': '表空間名稱',
  '表空间类型': '表空間類型',
  '已用容量(GB)': '已用容量(GB)',
  '用户配额': '用戶配額',
  '表空间': '表空間',
  '请填写表空间名称': '請填寫表空間名稱',
  '数据表空间': '數據表空間',
  '修改用户配额': '修改用戶配額',
  '不限配额': '不限配額',
  '取消配额': '取消配額',
  '表空间名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长30个字符': '表空間名由字母開頭，小寫字母，數字、下劃線組成， 字母或數字結尾，最長30個字符',
  '请选择表空间类型': '請選擇表空間類型',
  '表空间创建成功！': '表空間創建成功！',
  '扩容成功！': '擴容成功！',
  '请选择需要配置的用户名': '請選擇需要配置的用戶名',
  '请选择配额类型': '請選擇配額類型',
  '配额修改成功！': '配額修改成功！',
  '认证': '認證',
  '有': '有',
  '请先填写kafka集群!': '請先填寫kafka集羣!',
  '集群地址': '集羣地址',
  '账号需要具备SELECT, REPLICATION SLAVE, REPLICATION CLIENT权限。': '帳號需要具備SELECT，REPLICATION SLAVE，REPLICATION CLIENT權限。',
  '账号需要具备 SELECT,INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER权限。': '帳號需要具備 SELECT,INSERT, CREATE, SUPER, DROP, ALTER, EXECUTE, CREATE VIEW, CREATE ROUTINE, ALTER ROUTINE, EVENT, TRIGGER權限。',
  '包年包月<br/>包年包月是一种先付费后使用的计费方式，这种方式适用于提前预估设备需求量的场景。您可以通过包年包月的模式提前预留资源，享受更大的价格优惠，更大程度降低您的支出。': '包年包月<br/>包年包月是一種先付費後使用的計費方式，這種方式適用於提前預估設備需求量的場景。您可以通過包年包月的模式提前預留資源，享受更大的價格優惠，更大程度降低您的支出。',
  '按量计费<br/>按量付费是一种先使用后付费的计费方式。通过按量付费，您无需提前购买大量资源，可以按需开通和释放资源，减少资源浪费，大幅降低实例使用成本。': '按量計費<br/>按量付費是一種先使用後付費的計費方式。通過按量付費，您無需提前購買大量資源，可以按需開通和釋放資源，減少資源浪費，大幅降低實例使用成本。',
  '云环境是指能够从动态虚拟化的资源池中向您按需提供计算能力、存储能力或者虚拟机服务等的互联网或者大数据环境。<br/>为了让您更好地享受云服务请您选择招商云环境，如招商云没有您所需的资源，您可选择其它云环境。': '雲環境是指能夠從動態虛擬化的資源池中向您按需提供計算能力、存儲能力或者虛擬機服務等的互聯網或者大數據環境。<br/>爲了讓您更好地享受雲服務請您選擇招商雲環境，如招商雲沒有您所需的資源，您可選擇其它雲環境。',
  '区域指的是 ECS 实例所在的物理位置。<br/>招商云的服务器托管分布在多个位置，由不同的区域构成。每个区域都指一个独立的物理数据中心，不同区域的实例之间内网互不相通；您可以选择距离您客户最近的区域来降低网络时延、提高您客户的访问速度。': '區域指的是 ECS 實例所在的物理位置。<br/>招商雲的服務器託管分佈在多個位置，由不同的區域構成。每個區域都指一個獨立的物理數據中心，不同區域的實例之間內網互不相通；您可以選擇距離您客戶最近的區域來降低網絡時延、提高您客戶的訪問速度。',
  '可用区是指在同一区域内，电力和网络互相独立的物理区域。<br/>每个可用区都是独立的，同一可用区内的 ECS 实例网络延时更小。在同一区域内可用区与可用区之间内网互通，可用区之间能做到故障隔离。是否将云服务器 ECS 实例放在同一可用区内，主要取决于对容灾能力和网络延时的要求。如果您的应用需要较高的容灾能力，建议您将云服务器ECS实例部署在同一区域的不同可用区内。如果您的应用在实例之间需要较低的网络时延，则建议您将 ECS 实例创建在相同的可用区内。可用区是指在同一区域内，电力和网络互相独立的物理区域。': '可用區是指在同一區域內，電力和網絡互相獨立的物理區域。<br/>每個可用區都是獨立的，同一可用區內的 ECS 實例網絡延時更小。在同一區域內可用區與可用區之間內網互通，可用區之間能做到故障隔離。是否將雲服務器 ECS 實例放在同一可用區內，主要取決於對容災能力和網絡延時的要求。如果您的應用需要較高的容災能力，建議您將雲服務器ECS實例部署在同一區域的不同可用區內。如果您的應用在實例之間需要較低的網絡時延，則建議您將 ECS 實例創建在相同的可用區內。可用區是指在同一區域內，電力和網絡互相獨立的物理區域。',
  '公共镜像<br/>是由招商云官方或第三方合作商家提供的标准操作系统镜像，仅包括初始系统环境。请您根据实际情况自助配置应用环境或相关软件。': '公共鏡像<br/>是由招商雲官方或第三方合作商家提供的標準操作系統鏡像，僅包括初始系統環境。請您根據實際情況自助配置應用環境或相關軟件。',
  '自定义镜像<br/>基于实例创建的系统模板，包括初始系统环境、应用环境和相关软件配置。您可使用自定义镜像快速批量地创建云服务器，节省重复配置的时间。': '自定義鏡像<br/>基於實例創建的系統模板，包括初始系統環境、應用環境和相關軟件配置。您可使用自定義鏡像快速批量地創建雲服務器，節省重複配置的時間。',
  '快照<br/>招商云快照是一种便捷高效的数据容灾手段,您可用于数据备份、制作自定义镜像、应用容灾等。': '快照<br/>招商雲快照是一種便捷高效的數據容災手段,您可用於數據備份、製作自定義鏡像、應用容災等。',
  '数据盘主要用来存储用户数据，分为通用型、高性能型、容量型，您可以按照实际业务需求选择数据盘大小。': '數據盤主要用來存儲用戶數據，分爲通用型、高性能型、容量型，您可以按照實際業務需求選擇數據盤大小。',
  '入门型<br/>入门型云主机适用于个人博客、小网站等轻量应用业务。<br/>计算型<br/>适用于数据分析、数据编码解码、批量计算、Web前端、在线实时业务等对计算能力要求较高的业务场景。<br/>内存型<br/>适用于缓存服务、搜索集群、企业级数据库、高性能集群、大数据集群等对内存要求较大的应用场景，您可根据业务需求选择内存大小。<br/>通用型<br/>适用于各类型的网站，绝大多数应用，如企业网站、中小型数据库、缓存、中小型企业业务等性能比较均衡的业务场景。': '入門型<br/>入門型雲主機適用於個人博客、小網站等輕量應用業務。<br/>計算型<br/>適用於數據分析、數據編碼解碼、批量計算、Web前端、在線實時業務等對計算能力要求較高的業務場景。<br/>內存型<br/>適用於緩存服務、搜索集羣、企業級數據庫、高性能集羣、大數據集羣等對內存要求較大的應用場景，您可根據業務需求選擇內存大小。<br/>通用型<br/>適用於各類型的網站，絕大多數應用，如企業網站、中小型數據庫、緩存、中小型企業業務等性能比較均衡的業務場景。',
  'x86计算<br/>x86计算具有资源独享，稳定性较高的特点，适用于绝大部分用户的上云场景，一般用户在选择招商云服务器实例规格都会基于x86计算架构进行选择。<br/>GPU计算<br/>GPU计算比传统CPU效率更高，具有实时高速、低延迟，计算能力强大等特点，价格高于x86计算架构，适用于高性能计算、图形渲染、视频解码、深度学习、科学计算等应用场景。': 'x86計算<br/>x86計算具有資源獨享，穩定性較高的特點，適用於絕大部分用戶的上雲場景，一般用戶在選擇招商雲服務器實例規格都會基於x86計算架構進行選擇。<br/>GPU計算<br/>GPU計算比傳統CPU效率更高，具有實時高速、低延遲，計算能力強大等特點，價格高於x86計算架構，適用於高性能計算、圖形渲染、視頻解碼、深度學習、科學計算等應用場景。',
  '招商云私有网络（Virtual Private Cloud，VPC）是您在招商云上自定义的逻辑隔离网络空间，您可以完全掌握私有网络环境，包括选择IP地址范围、自定义网段划分、和路由策略等。您可以在自己定义的专有网络中使用云资源如云主机、云数据库、NAT网关和负载均衡等。': '招商雲私有網絡（Virtual Private Cloud，VPC）是您在招商雲上自定義的邏輯隔離網絡空間，您可以完全掌握私有網絡環境，包括選擇IP地址範圍、自定義網段劃分、和路由策略等。您可以在自己定義的專有網絡中使用雲資源如雲主機、雲數據庫、NAT網關和負載均衡等。',
  '部署单元是指控制一组云主机分布在指定项目及可用区内不同计算节点上的策略，以此保证业务的高可用性和底层容灾能力。': '部署單元是指控制一組雲主機分佈在指定項目及可用區內不同計算節點上的策略，以此保證業務的高可用性和底層容災能力。',
  '基础版：适用于开发、测试、预发布、容灾环境；<br>高可用版：适用于生产、容灾环境，暂不支持自助购买，请提交工单人工处理':'基礎版：適用於開發、測試、預發布、容災環境；<br>高可用版：適用於生產、容災環境，暫不支持自助購買，請提交工單人工處理',
  '基础版:适用于开发、测试、预发布、容灾环境；<br>高可用版:适用于生产、容灾环境':'基礎版:適用於開發、測試、預發布、容災環境；<br>高可用版:適用於生產、容災環境',
  '基础版:适用于开发、测试、预发布、容灾环境；<br>高可用版:适用于生产环境':'基礎版:適用於開發、測試、預發布、容災環境；<br>高可用版:適用於生產環境',
  '专有宿主机 (Dedicated Host Service, CDH) 是招商云提供的云专有宿主机服务，这是一种物理资源独享、配置灵活、安全且专有的宿主机服务，支持按需购买、按量付费、灵活配置超分比，可以极度压榨物理机的资源，切实降低您的单实例部署成本。使用云专有宿主机，您无需再与其他租户争抢资源，可在其上灵活创建、管理多种规格的独享型云主，且可获得更高的安全性，满足更严格的合规和监管要求。': '部署單元是指控制一組雲主機分佈在指定項目及可用區內不同計算節點上的策略，以此保證業務的高可用性和底層容災能力。專有宿主機 (Dedicated Host Service, CDH) 是招商雲提供的雲專有宿主機服務，這是一種物理資源獨享、配置靈活、安全且專有的宿主機服務，支持按需購買、按量付費、靈活配置超分比，可以極度壓榨物理機的資源，切實降低您的單實例部署成本。使用雲專有宿主機，您無需再與其他租戶爭搶資源，可在其上靈活創建、管理多種規格的獨享型雲主，且可獲得更高的安全性，滿足更嚴格的合規和監管要求。',
  '子网是每个VPC内的IP地址块，VPC中的所有云资源都必须部署在子网内。同一个VPC下,子网网段不可重复。子网创建成功后,网段无法修改。': '子網是每個VPC內的IP地址塊，VPC中的所有云資源都必須部署在子網內。同一個VPC下,子網網段不可重複。子網創建成功後,網段無法修改。',
  '请合理评估您所需的硬盘大小，避免资源浪费。': '請合理評估您所需的硬盤大小，避免資源浪費。',
  '发起通信的地址': '發起通信的地址',
  '接收通信的地址': '接收通信的地址',
  '访问目的地址的端口号': '訪問目的地址的端口號',
  '通信双方所使用的网络协议': '通信雙方所使用的網絡協議',
  '您在存储数据到表中的时候所用到的字符集,不同字符集编码格式不同。': '您在存儲數據到表中的時候所用到的字符集,不同字符集編碼格式不同。',
  '下载请求发送成功': '下載請求發送成功',
  '请耐心等待！': '請耐心等待！',
  '迁移结果报表': '遷移結果報表',
  '引擎类型': '引擎類型',
  '分片数': '分片數',
  '副本数': '副本數',
  '配额状态未修改': '配額狀態未修改',
  '当前配额为【不限配额】，请进行配额修改再提交': '當前配額為【不限配額】，請進行配額修改再提交',
  '当前配额为【取消配额】，请进行配额修改再提交': '當前配額為【取消配額】，請進行配額修改再提交',
  '当前表空间容量：': '當前表空間容量：',
  '用户已分配配额总量：': '用戶已分配配額總量：',
  '表空间容量：': '表空間容量：',
  '用户名由字母开头，小写字母，数字、下划线组成， 字母或数字结尾，最长30个字符': '用戶名由字母開頭，小寫字母，數字、下劃線組成， 字母或數字結尾，最長30個字符',
  'M内存': 'M內存',
  '仅允许批量编辑同账号下的公有云主机！': '僅允許批量編輯同帳號下的公有雲主機！',
  '当日申请的SNAT和DNAT，将在次日00:10开始下发': '當日申請的SNAT和DNAT，將在次日00:10開始下發',
  '权重': '權重',
  '请先配置服务器权重!': '請先配置服務器權重',
  '请填写【长度为1-60个英文或中文字符，必须以字母或汉字开头,可包含数字,点号(.),下划线(_)和短横线(-)】': '請填寫【長度爲1-60個英文或中文字符，必須以字母或漢字開頭,可包含數字,點號(.),下劃線(_)和短橫線(-)】',
  '深度归档型': '深度歸檔型',
  '自定义类型': '自定義類型',
  '权重可配置范围在0-100!': '權重可配置範圍在0-100!',
  '请选择子网信息 !': '請選擇子網信息 !',
  '仅允许批量编辑同账号下的公有云资源！': '僅允許批量編輯同帳號下的公有雲資源！',
  '公有云暂不支持此操作！': '公有雲暫不支持此操作！',
  '用户名长度最长30个字符！': '用戶名長度最長30個字符！',
  '当前状态为【创建中】, 不支持用户创建': '當前狀態為【創建中】, 不支持用戶創建',
  '请填写存储桶名称信息 !': '請填寫存儲桶名稱信息 !',
  '当前选项下暂无相关存储类型，请修改配置': '當前選項下暫無相關存儲類型，請修改配置',
  '请选择访问权限!': '請選擇訪問權限!',
  '请修改配置': '請修改配置',
  '当前选项下暂无相关存储类型!': '當前選項下暫無相關存儲類型!',
  '升级后：': '升級後：',
  '升级前：': '升級前：',
  '请至少扩容100G！': '請至少擴容100G！',
  '数据磁盘至少扩容70G！': '數據磁片至少擴容70G！',
  '归档磁盘至少扩容30G！': '歸檔磁片至少擴容30G！',
  '非测试环境防火墙策略，在完成审批流程后才会在当天18:00后开始真正下发。': '非測試環境防火牆策略，在完成審批流程後才會在當天18:00後開始真正下發。',
  '暂存': '暫存',
  '主出口IP':'主出口IP',
  '备出口IP':'備出口IP',
  '已选择云主机：': '已選擇雲主機：',
  '云盘名称': '雲盤名稱',
  '共享云盘': '共享雲盤',
  '添加授权主机': '添加授權主機',
  '选择授权的主机': '選擇授權的主機',
  '请先选择需要授权的主机！': '請先選擇需要授權的主機！',
  '请先选择需要筛选的类型': '請先選擇需要篩選的類型',
  '主机授权成功！': '主機授權成功！',
  '请输入要搜索的主机IP': '請輸入要搜索的主機IP',
  '请输入要搜索的主机名称': '請輸入要搜索的主機名稱',
  '解除授权主机': '解除授權主機',
  '选择要解除授权的主机': '選擇要解除授權的主機',
  '主机解除授权成功！': '主機解除授權成功！',
  '共享云盘详情': '共享雲盤詳情',
  '授权列表': '授權列表',
  '解除挂载': '解除掛載',
  '扩容记录': '擴容記錄',
  '原大小(GB)': '原大小(GB)',
  '扩容后大小(GB)': '擴容後大小(GB)',
  '确定挂载【': '確定掛載【',
  '】吗?': '】嗎?',
  '确定解除挂载【': '確定解除掛載【',
  '主机挂载成功!': '主機掛載成功!',
  '主机解除挂载成功!': '主機解除掛載成功!',
  '请输入共享云盘名称': '請輸入共享雲盤名稱',
  '温馨提示：挂载前请确认主机能识别共享云盘，否则可能会导致创建共享云盘失败，具体操作查看': '溫馨提示：掛載前請確認主機能識別共享雲盤，否則可能會導致創建共享雲盤失敗，具體操作查看',
  '帮助文档': '幫助文檔',
  '主机ECS': '主機ECS',
  '云硬盘CBS': '雲硬盤CBS',
  '云盘大小(GB)': '雲盤大小(GB)',
  '共享云盘购买': '共享雲盤購買',
  '请选则协议': '請選則協議',
  '请选则操作系统': '請選則操作系統',
  '容量平台': '容量平臺',
  '主机视图': '主機視圖',
  '项目视图': '項目視圖',
  '数据库视图': '數據庫視圖',
  '存储视图': '存儲視圖',
  '当前可用区暂不支持此功能！': '當前可用區暫不支持此功能！',
  '校验': '校驗',
  '取消授权': '取消授權',
  '共享云盘进行读写时禁止取消授权，取消授权前要取消挂载。': '共享雲盤進行讀寫時禁止取消授權，取消授權前要取消掛載。',
  '单选': '單選',
  'windows主机请查看ecsadmin密码。':'windows主機請查看ecsadmin密碼。',
  'linux主机请查看rhlog的密码。':'linux主機請查看rhlog的密碼。',
  'root不支持linux系统直接登录。':'root不支持linux系統直接登錄。',
  '请更换协议或监听端口': '請更換協議或監聽端口',
  'udp协议暂不支持对端口4789的监听': 'udp協議暫不支持對端口4789的監聽',
  '点击跳转指定文件夹': '點擊跳轉指定文件夾',
  '当前目录OSS': '當前目錄OSS',
  '创建文件夹': '創建文件夾',
  '文件夹名': '文件夾名',
  '请输入文件夹名称': '請輸入文件夾名稱',
  '文件上传成功': '文件上傳成功',
  '文件正在下载，请耐心等待': '文件正在下載，請耐心等待',
  '文件夹创建成功': '文件夾創建成功',
  '当前文件类型为': '當前文件類型為',
  '暂不支持下载': '暫不支持下載',
  '文件夹命名规范：': '文件夾命名規範：',
  '1、不能以"/","\"开头': '1、不能以"/","\"開頭',
  '2、不能以".."为目录名': '2、不能以".."為目錄名',
  '3、不允许出现连续的"//"字符': '3、不允許出現連續的"//"字符',
  '4、可使用"/"分割路径，创建多级目录': '4、可使用"/"分割路徑，創建多級目錄',
  '5、总长度控制在1~254个字符': '5、總長度控制在1~254個字符',
  '请输入符合规范的文件夹名称': '請輸入符合規範的文件夾名稱',
  'Server类型': 'Server類型',
  'Server配置': 'Server配寘',
  '高可用': '高可用',
  'FTP Server创建命令发送成功！': 'FTP Server創建命令發送成功！',
  '创建FTP Server': '創建FTP Server',
  'FTP 存储网关详情': 'FTP 存儲網關詳情',
  '关联OSS': '關聯OSS',
  'oss名称': 'oss名稱',
  '关联时间': '關聯時間',
  '解绑OSS': '解綁OSS',
  '添加账户': '添加帳戶',
  '账号名称': '帳號名稱',
  '删除文件操作': '刪除文件操作',
  'OSS桶': 'OSS桶',
  '6-8位字符': '6-8位字符',
  '大小写字母、数字、特殊字符,特殊字符为-_.*': '大小寫字母、數位、特殊字元,特殊字符為-_.*',
  'Server名称': 'Server名稱',
  'FTP Server端口': 'FTP Server端口',
  '请选择OSS桶！': '請選擇OSS桶！',
  '关联OSS成功！': '關聯OSS成功！',
  '解绑OSS成功！': '解綁OSS成功！',
  '添加账户成功！': '添加帳戶成功！',
  '密码查询成功！': '密碼查詢成功！',
  '删除账户成功！': '删除帳戶成功！',
  'Server 端口': 'Server 端口',
  '重启Server': '重啓Server',
  'FTP 存储网关': 'FTP 存儲網關',
  'FTP 存储网关服务关联OSS，需要绑定在同一可用区的存储桶。若需要购买请点击购买': 'FTP存儲網關服務關聯OSS，需要綁定在同一可用區的存儲桶。若需要購買請點擊購買',
  '请确认已解绑存储桶，删除后将解绑存储桶。': '請確認已解綁存儲桶，删除後將解綁存儲桶。',
  '请输入3~16个字符，支持数字、大小写字母、点、中横线、下划线': '請輸入3~16個字符，支持數位、大小寫字母、點、中橫線、底線',
  '编辑FTP Server成功！': '編輯FTP Server成功！',
  '确定重启该【': '確定重啓該【',
  '】服务?': '】服務？',
  '重启服务成功！': '重啓服務成功！',
  '确定停止该【': '確定停止該【',
  '停止服务成功！': '停止服務成功！',
  '启动服务成功！': '啟動服務成功！',
  '是否允许删除文件操作': '是否允許刪除檔操作',
  '删除账号后，用户将无法登录，重启FTP Server后生效': '删除帳號後，用戶將無法登錄，重啓FTP Server後生效',
  '重置密码在重启FTP Server后生效': '重置密碼在重啓FTP Server後生效',
  '关联OSS在重启FTP Server后生效': '關聯OSS在重啓FTP Server後生效',
  '添加账户在重启FTP Server后生效': '添加帳戶在重啓FTP Server後生效',
  '解绑OSS在重启FTP Server后生效': '解綁OSS在重啓FTP Server後生效',
  '修改配置在重启FTP Server后生效': '修改配置在重啓FTP Server後生效',
  '共享云盘购买成功 !': '共享雲盤購買成功 !',
  '已授权或挂载共享云盘列表': '已授權或掛載共享雲盤列表',
  '销毁云主机后共享云盘会自动卸载并取消授权': '銷毀雲主機後共享雲盤會自動卸載並取消授權',
  '共享云盘名称': '共享雲盤名稱',
  '源端主机名称':'源端主機名稱',
  '服务提供商':'服務提供者',
  '目的端主机IP':'目的端主機IP',
  '创建迁移任务':'創建遷移任務',
  '选择迁移配置':'選擇遷移配寘',
  '是否覆盖同名文件':'是否覆蓋同名檔案',
  '目的端云主机名称':'目的端雲主機名稱',
  '源端文件链接':'源端檔案連結',
  '源系统密码':'源系統密碼',
  '迁移目的端信息':'遷移目的端資訊',
  '制作源端主机镜像':'製作源端主機鏡像',
  '将迁移源端的云主机创建成镜像' :'將遷移源端的雲主機創建成鏡像',
  '查看制作镜像帮助文档':'查看製作鏡像幫助文檔',
  '创建源端OSS':'创建源端OSS',
  '购买源端OSS产品':'購買源端OSS產品',
  '上传文件至源端OSS':'上傳文件至源端OSS',
  '将镜像文件上传至源端OSS':'將鏡像文件上傳至源端OSS',
  '创建目的端OSS':'創建目的端OSS',
  '购买招商云的OSS产品':'購買招商雲的OSS產品',
  '请填写正确的阿里云源端文件链接!':'請填寫正確的阿裡雲源端檔案連結！',
  '请填写正确的腾讯云源端文件链接!':'請填寫正確的騰訊雲源端檔案連結！',
  '请填写正确的招商云源端文件链接!':'請填寫正確的招商雲源端檔案連結！',
  '请在使用堡垒机前操作纳管云主机！': '請在使用堡壘機前操作納管雲主機！',
  '修改owner成功！': '修改owner成功！',
  '修改owner': '修改owner',
  '账号列表': '帳號列表',
  '节点数': '節點數',
  '数据库会话连接数': '數據庫會話連接數',
  '数据库会话连接使用率(%)': '數據庫會話連接使用率(%)',
  '数据库最大会话连接数': '數據庫最大會話連接數',
  '最大iops': '最大iops',
  '规格名称': '規格名稱',
  '腾讯云暂不支持创建账户！': '騰訊雲暫不支持創建帳戶！',
  '存储引擎': '存儲引擎',
  '需全局唯一，不能与已有的任何桶名称重复':'需全域唯一，不能與已有的任何桶名稱重複',
  '数据库迁移DTS 操作指南': '數據庫遷移DTS 操作指南',
  '数据库迁移 DTS': '數據庫遷移 DTS',
  '源端数据库版本': '源端數據庫版本',
  '文件至数据库迁移详情': '文件至數據庫遷移詳情',
  '迁移进度': '遷移進度',
  '购买数据库实例': '購買數據庫實例',
  '调用CAE建用户': '調用CAE建用戶',
  '购买NAS,挂载NAS': '購買NAS,掛載NAS',
  '下载文件': '下載文件',
  '解压文件': '解壓文件',
  '执行导入命令': '執行導入命令',
  '源端实例类型': '源端實例類型',
  'NAS ID': 'NAS ID',
  '文件总大小': '文件總大小',
  '请输入任务名': '請輸入任務名',
  '数据库版本': '數據庫版本',
  '备份级别': '備份級別',
  '选购目标库': '選購目標庫',
  '当前数据库版本不支持，请选择其他版本': '當前數據庫版本不支持，請選擇其他版本',
  '选择对象存储': '選擇對象存儲',
  '存储桶可用容量': '存儲桶可用容量',
  '温馨提示：若需要': '溫馨提示：若需要',
  '购买新对象存储': '購買新對象存儲',
  '，请先暂存任务再购买': '，請先暫存任務再購買',
  '已上传文件列表：': '已上傳文件列表：',
  '当前文件不存在，请重新上传或删除': '當前文件不存在，請重新上傳或刪除',
  '请至少填写至选购目标库的项目，可将此条任务暂时保存': '請至少填寫至選購目標庫的項目，可將此條任務暫時保存',
  '可将此条任务暂时保存': '可將此條任務暫時保存',
  '文件迁移': '文件遷移',
  'IDC自建数据库': 'IDC自建數據庫',
  '实例级别': '實例級別',
  'SCHEMA级别': 'SCHEMA級別',
  '公有云暂不支持': '公有雲暫不支持',
  '请输入任务名！': '請輸入任務名！',
  '任务名由字母，数字、下划线与中划线组成、字母或数字开头，最长64个字符': '任務名由字母，數字、下劃線與中劃線組成、字母或數字開頭，最長64個字符',
  '请选择实例类型！': '請選擇實例類型！',
  '请选择数据库类型！': '請選擇數據庫類型！',
  '请选择数据库版本！': '請選擇數據庫版本！',
  '请选择备份类型！': '請選擇備份類型！',
  '请选择备份级别！': '請選擇備份級別！',
  '请选择字符集！': '請選擇字符集！',
  '请选择块大小！': '請選擇塊大小！',
  '实例名称规则': '實例名稱規則',
  '由字母开头，小写字母和数字组成，最长为128个字符': '由字母開頭，小寫字母和數字組成，最長為128個字符',
  '校验异常': '校驗異常',
  '任务名重复或数据库版本异常，请查看页面红色文字提示！': '任務名重復或數據庫版本異常，請查看頁面紅色文字提示！',
  '请先选择对象存储桶！': '請先選擇對象存儲桶！',
  '文件类型有误': '文件類型有誤',
  '请输入任务名，再暂存': '請輸入任務名，再暫存',
  '请选择实例类型，再暂存': '請選擇實例類型，再暫存',
  '请选择数据库类型，再暂存': '請選擇數據庫類型，再暫存',
  '请选择数据库版本，再暂存': '請選擇數據庫版本，再暫存',
  '请选择备份类型，再暂存': '請選擇備份類型，再暫存',
  '请选择备份级别，再暂存': '請選擇備份級別，再暫存',
  '请选择字符集，再暂存': '請選擇字符集，再暫存',
  '请选择块大小，再暂存': '請選擇塊大小，再暫存',
  '当前内容已暂存！': '當前內容已暫存！',
  '支持上传的文件类型:': '支持上傳的文件類型',
  '文件正在上传中，暂不能启动！': '文件正在上傳中，暫不能啟動！',
  '当前未上传文件！': '當前未上傳文件！',
  '请先上传文件再启动！': '請先上傳文件再啟動！',
  '目前仅支持单个zip文件,或多个zip分卷': '目前僅支持單個zip文件,或多個zip分卷',
  '文件总容量：': '文件總容量：',
  '数据库至数据库迁移': '數據庫至數據庫遷移',
  '文件至数据库迁移': '文件至數據庫遷移',
  '数据库迁移': '數據庫遷移',
  '文件已上传至存储桶，若需要重新选择存储桶，请先删除已上传文件再选择': '文件已上傳至存儲桶，若需要重新選擇存儲桶，請先刪除已上傳文件再選擇',
  '成本优化分析': '成本優化分析',
  '查看优化策略': '查看優化策略',
  '优化对象': '優化對象',
  '优化费用': '優化費用',
  '优化前月费用': '優化前月費用',
  '优化后月费用': '優化后月費用',
  '可节省费用': '可節省費用',
  '优化建议': '優化建議',
  '建议优化资源列表': '建議優化資源列表',
  '忽略优化资源列表': '忽略優化資源列表',
  '优化策略': '優化策略',
  '适用资源': '適用資源',
  '闲置资源预测': '閑置資源預測',
  'CPU使用率Max值小于5%，并且内存使用率Max值小于10%，建议降配或释放。': 'CPU使用率Max值小於5%，并且内存使用率Max值小於10%，建議降配或釋放。',
  '未绑定到ECS主机的块存储，建议释放。': '未綁定到ECS主機的塊存儲，建議釋放。',
  '未绑定到ECS云主机的弹性IP，建议释放。': '未綁定到ECS云主機的弹性IP，建議釋放。',
  '超配资源预测': '超配資源預測',
  'CPU使用率Max值小于30%或内存使用率Max值小于30%，建议降配。': 'CPU使用率Max值小於30%或内存使用率Max值小於30%，建議降配。',
  '资源扩容预测': '資源擴容預測',
  'CPU使用率Max值大于80%或内存使用率Max值大于80%，建议升配。': 'CPU使用率Max值大於80%或内存使用率Max值大於80%，建議升配。',
  '优化前': '優化前',
  '优化后': '優化后',
  '已节约': '以節約',
  '混合云资源概览': '混合雲資源概覽',
  '其他数据库': '其他數據庫',
  '云主机概况': '雲主機概況',
  '新建云主机ECS概况': '新建雲主機ECS概況',
  '柱状图': '柱狀圖',
  '折线图': '折綫圖',
  '云主机使用概况': '雲主機使用概況',
  '云数据库总数': '雲數據庫總數',
  '私有云资源概览': '私有雲資源概覽',
  '计算资源概览': '計算資源概覽',
  '云主机配置运行情况': '雲主機配置運行情況',
  '云主机系统运行情况': '雲主機系統運行情況',
  '数据库资源概览': '數據庫資源概覽',
  '数据库总数': '數據庫總數',
  '数据库分布': '數據庫分佈',
  '阿里云资源概览': '阿里雲資源概覽',
  '腾讯云资源概览': '騰訊雲資源概覽',
  '华为云资源概览': '華爲雲資源概覽',
  '招商云资源概览': '招商雲資源概覽',
  '招商私有云数据库资源概览': '招商私有雲數據庫資源概覽',
  '数据库总数(台)': '數據庫總數(台)',
  '招商私有云数据库类型': '招商私有雲數據庫類型',
  '公有云云硬盘资源概览': '公有雲云硬盤資源概覽',
  '招商公有云数据库概览': '招商公有雲數據庫概覽',
  '可优化总数': '可優化總數',
  '建议释放': '建議釋放',
  '建议降配': '建議降配',
  '建议升配': '建議升配',
  '忽略优化': '忽略優化',
  '请输入忽略原因!(不超过200字)': '請輸入忽略原因!(不超過200字)',
  '确定对': '確定對',
  '变化后成本': '變化后成本',
  '当前成本': '當前成本',
  '建议配置': '建議配置',
  '子网总数': '子網總數',
  '云主机总数': '雲主機總數',
  '总数': '總數',
  '云硬盘总数': '雲硬盤總數',
  '总运行数': '縂運行數',
  '环境': '環境',
  '云主机(台)': '雲主機(臺)',
  '数据库实例': '數據庫實例',
  '费用信息': '費用信息',
  '当月费用': '當月費用',
  '昨日总费用': '昨日總費用',
  '上月总费用': '上月總費用',
  '本月总费用（预估）': '本月總費用（預估）',
  '本月当前已产生费用': '本月當前已產生費用',
  '环比上月': '環比上月',
  '总费用趋势': '總費用趨勢',
  '消费': '消費',
  '温馨提示：目前招商云平台暂不支持Oracle、PostgreSQL自助备份功能，如需申请备份数据库数据或日志，请': '溫馨提示：目前招商雲平臺暫不支持Oracle、PostgreSQL自助備份功能，如需申請備份數據庫數據或日志，請',
  '温馨提示：目前招商云平台暂不支持MongoDB自助备份功能，如需申请备份数据库数据或日志，请': '溫馨提示：目前招商雲平臺暫不支持MongoDB自助備份功能，如需申請備份數據庫數據或日志，請',
  '到存储组人工处理。': '到存儲組人工處理。',
  '建设背景': '建設背景',
  '系统介绍': '系統介紹',
  '上线时间': '上線時間',
  '部署方式': '部署方式',
  'SLA要求': 'SLA要求',
  '采购情况': '採購情况',
  '目前状态': '目前狀態',
  '附件': '附件',
  '需上传项目架构图、立项说明等材料': '需上傳項目架構圖、立項說明等材料',
  '配置审批人': '配寘審批人',
  '部门长': '部門長',
  '手动输入': '手動輸入',
  '是否使用公有云资源': '是否使用公有雲資源',
  '选择您要使用的公有云：': '選擇您要使用的公有雲：',
  '总台数：': '總台數：',
  '总CPU：': '總CPU：',
  '总内存：': '總內存：',
  '总个数：': '總個數：',
  '总大小：': '總大小：',
  '总实例：': '總實例：',
  '设置项目信息': '設定項目信息',
  '配置公有云资源需求': '配寘公有雲資源需求',
  '请填写中文名！': '請填寫中文名！',
  '请选择项目负责人！': '請選擇項目負責人！',
  '请填写建设背景！': '請填寫建設背景！',
  '请填写系统介绍！': '請填寫系統介紹！',
  '请上传附件！': '請上傳附件！',
  '请选择/填写部门长！': '請選擇/填寫部門長！',
  '请选择/填写CDO！': '請選擇/填寫CDO！',
  '请检查输入！': '請檢查輸入！',
  '创建成功！': '創建成功！',
  '公有云资源配额': '公有雲資源配額',
  '已用：': '已用：',
  '审批进度': '審批進度',
  '无需审批': '無需審批',
  '审批中': '審批中',
  '审批不通过': '審批不通過',
  '审批成功': '審批成功',
  '扩容审批中': '擴容審批中',
  '扩容审批不通过': '擴容審批不通過',
  '账单周期：': '帳單週期：',
  '租户及日期不能为空！': '租戶及日期不能為空！',
  '混合云账单总览': '混合雲帳單總覽',
  '开始月份': '開始月份',
  '结束月份': '結束月份',
  '时间范围说明：时间可选择最大范围为12个月，当选择期间超过12个月时，以开始时间的一年为准，': '時間範圍說明：時間可選擇最大範圍為12個月，當選擇期間超過12個月時，以開始時間的一年為准，',
  '如：时间期间选择为：2018年1月到2020年10月, 则展示2018年1月到12月的账单数据': '如：時間期間選擇為：2018年1月到2020年10月，則展示2018年1月到12月的帳單數據',
  '上升': '上升',
  '下降': '下降',
  '云环境成本趋势图': '雲環境成本趨勢圖',
  '公有云账单概览': '公有雲帳單概覽',
  '选择月': '選擇月',
  '本月已消费金额': '本月已消費金額',
  '对比上月': '對比上月',
  '本月预计消费金额': '本月預計消費金額',
  '云帐号成本分析': '雲帳號成本分析',
  '资源成本分析': '資源成本分析',
  '近三月': '近三月',
  '堆叠柱状图': '堆疊柱狀圖',
  '混合云租户账单总览': '混合雲租戶帳單總覽',
  '招商云租户账单概览': '招商雲租戶帳單概覽',
  '公有云租户账单概览': '公有雲租戶帳單概覽',
  '招商云租户账单明细': '招商雲租戶帳單明細',
  '公有云租户账单明细': '公有雲租戶帳單明細',
  '招商云项目账单概览': '招商雲項目帳單概覽',
  '招商云项目账单明细': '招商雲項目帳單明細',
  'DMS数据管理': 'DMS數據管理',
  '新增实例': '新增實例',
  '输入数据库进行过滤': '輸入數據庫進行過濾',
  '暂无连接数据…': '暫無連接數據…',
  '请先连接数据库': '請先連接數據庫',
  '输入关键字进行过滤': '輸入關鍵字進行過濾',
  '当前数据库': '當前數據庫',
  '当前实例名称': '當前實例名稱',
  '当前账号': '當前帳號',
  '切换账号': '切換帳號',
  '当前窗口id': '當前視窗id',
  '注意：当前单次查询结果最多返回1,000条;': '注意：當前單次查詢結果最多返回1000條；',
  '创建表': '創建錶',
  '打开表': '打開錶',
  '编辑表': '編輯錶',
  '删除表': '删除錶',
  '对象信息': '對象資訊',
  '创建视图': '創建視圖',
  '编辑序列': '編輯序列',
  '删除序列': '刪除序列',
  '编辑视图': '編輯視圖',
  '删除视图': '删除視圖',
  '属性值': '屬性值',
  '创建语句': '創建語句',
  '打开视图(SQL)': '打開視圖(SQL)',
  '数据库类型：': '數據庫類型：',
  '数据库实例：': '數據庫實例：',
  '请选择数据库实例': '請選擇數據庫實例',
  '请选择数据库类型': '請選擇數據庫類型',
  '数据管理DMS': '數據管理DMS',
  '数据库用户名：': '數據庫用戶名：',
  '密码：': '密碼：',
  '温馨提示：切换账号登录会退出当前账号并清理当前账号的所有连接窗口': '溫馨提示：切換帳號登入會退出當前帳號並清理當前帳號的所有連接視窗',
  '表': '錶',
  '存储过程': '存儲過程',
  '请选择一个数据库': '請選擇一個數據庫',
  '当前数据库下没有表信息': '當前數據庫下沒有錶資訊',
  '当前表下没有字段信息': '當前錶下沒有字段資訊',
  '当前表下没有主键': '當前錶下沒有主鍵',
  '当前表下没有外键': '當前錶下沒有外鍵',
  '当前表下没有唯一键': '當前錶下沒有唯一鍵',
  '当前索引下没有字段': '當前索引下沒有字段',
  '当前主键下没有字段': '當前主鍵下沒有字段',
  '当前外键下没有字段': '存儲當前外鍵下沒有字段過程',
  '当前数据库下没有函数信息': '當前數據庫下沒有函數資訊',
  '当前唯一键下没有字段': '當前唯一鍵下沒有字段',
  '当前数据库下没有视图信息': '當前數據庫下沒有視圖資訊',
  '当前视图下没有字段信息': '當前視圖下沒有字段資訊',
  '已复制至剪切板': '已複製至剪切板',
  '请选择数据库': '請選擇數據庫',
  '当前数据库下没有存储过程列表': '當前數據庫下沒有存儲過程清單',
  '当前表下没有索引信息': '當前錶下沒有索引資訊',
  '视图': '視圖',
  '函数': '函数',
  '消息': '消息',
  '结果集': '結果集',
  '执行记录': '執行記錄',
  '迁移任务详情': '遷移任務詳情',
  '子任务阶段': '子任務階段',
  '源端主机': '源端主機',
  '源端镜像文件链接': '源端鏡像文件連結',
  '系统盘大小': '系統磁片大小',
  '目的端桶名称': '目的端桶名稱',
  '任务信息': '任務資訊',
  '进度': '進度',
  '长度范围为3到63个字符，支持小写字母、数字、中划线（-）、英文句号（.）': '長度範圍為3到63個字元，支持小寫字母、數位、中劃線（-）、英文句號（.）',
  '禁止两个英文句号（.）或英文句号（.）和中划线（-）相邻，禁止以英文句号（.）和中划线（-）开头或结尾。,或多个zip分卷': '禁止兩個英文句號（.）或英文句號（.）和中劃線（-）相鄰，禁止以英文句號（.）和中劃線（-）開頭或結尾。，或多個zip分卷',
  '禁止使用IP地址。': '禁止使用IP地址。',
  '如果名称中包含英文句号（.），访问桶或对象时可能会进行安全证书校验': '如果名稱中包含英文句號（.），訪問桶或對象時可能會進行安全證書校驗',
  '删除桶或并行文件系统后，需要等待30分钟才能创建同名桶或并行文件系统': '删除桶或並行檔案系統後，需要等待30分鐘才能創建同名桶或並行檔案系統',
  '云迁移': '雲遷移',
  '主机迁移': '主機遷移',
  '数据库登录': '數據庫登入',
  '请选择数据库用户': '請選擇資料庫用戶',
  '创建主机': '創建主機',
  '公有云账单明细': '公有雲帳單明細',
  '云帐号': '雲帳號',
  '共享带宽': '共亯帶寬',
  '带宽名称': '帶寬名稱',
  '该可用区暂无可用数据库规格购买!': '該可用區暫無可用數據庫規格購買!',
  '招商私有云云主机运行情况': '招商私有雲雲主機運行情况',
  '招商私有云云硬盘运行情况': '招商私有雲雲硬盤運行情況',
  '容量数据': '容量數據',
  '跨租户传输': '跨租戶傳輸',
  '审批人导入': '審批人導入',
  '增加审批流程': '增加審批流程',
  '项目审批人': '項目審批人',
  '数字化专员': '數位化專員',
  '请输入手机号、邮箱或域账号，多个账号用英文逗号分隔，最多可输入8个账号': '請輸入手機號、郵箱或域帳號，多個帳號用英文逗號分隔，最多可輸入8個帳號',
  '请选择项目审批人！': '請選擇項目審批人！',
  '请选择数字化专员！': '請選擇數字化專員！',
  '请选择CDO！': '請選擇CDO！',
  '请使用英文逗号作为分隔符！': '請使用英文逗號作為分隔符號！',
  '最多可输入8个账号！': '最多可輸入8個帳號！',
  '审批人导入成功！': '審批人導入成功！',
  '扩容公有云资源': '擴容公有雲資源',
  '扩容公有云资源需求': '擴容公有雲資源需求',
  '修改总台数：': '修改總台數：',
  '修改总CPU：': '修改總CPU：',
  '修改总内存：': '修改總內存：',
  '修改总个数：': '修改總個數：',
  '修改总大小：': '修改總大小：',
  '修改总实例：': '修改總實例：',
  '扩容公有云资源配额': '擴容公有雲資源配額',
  '扩容公有云资源配额成功！': '擴容公有雲資源配額成功！',
  '上传证书': '上傳證書',
  '已上传': '已上傳',
  '文件': '文件',
  '须由字母、数字、下划线、中划线组成，字母开头，字母或数字结尾': '須由字母、數位、底線、中劃線組成，字母開頭，字母或數位結尾',
  '请先填写目标库账号！': '請先填寫目標庫帳號！',
  '请先输入Topic！': '請先輸入Topic！',
  '请检查Topic输入格式！': '請檢查Topic輸入格式！',
  '请上传正确的文件krb5.conf！': '請上傳正確的文件krb5.conf！',
  '请上传正确的文件user.keytab！': '請上傳正確的文件user.keytab！',
  '只能上传krb5.conf文件，且只可上传一份': '只能上傳krb5.conf文件，且只可上傳一份',
  '只能上传user.keytab文件，且只可上传一份': '只能上傳user.keytab文件，且只可上傳一份',
  '字母、数字、下划线、中划线': '字母、數字、下劃線、中劃線',
  'Topic名称长度为1-249字符！': 'Topic名稱長度為1-249字符！',
  'Topic名称由字母、数字、下划线、中划线组成！': 'Topic名稱由字母、數位、下劃線、中劃線組成！',
  '源端表空间': '源端表空間',
  '表空间名长度需2-30个字符': '表空間名長度需2-30個字符',
  '表空间大小不能为空！': '表空間大小不能為空！',
  '由字母开头，小写字母和数字组成，最长为8个字符': '由字母開頭，小寫字母和數字組成，最長為8個字符',
  '云硬盘(个(GB))': '雲硬盤(個(GB))',
  'NAS(个(GB))': 'NAS(個(GB))',
  '当前用户暂无权限跳转gitLab, 请联系gitLab管理员设置相关权限': '當前用戶暫無權限跳轉gitLab, 請聯系gitLab管理員設置相關權限',
  '文件类型:': '文件類型',
  '资源共享': '資源共享',
  '名称：': '名稱：',
  '所属项目：': '所屬項目：',
  '所属租户：': '所屬租戶：',
  '未选择项目': '未選擇項目',
  '已选择项目': '已選擇項目',
  '请选择需要共享使用该资源的项目，未选择的项目则无法共享该资源。': '請選擇需要共享使用該資源的項目，未選擇的項目則無法共享該資源。',
  '请先上传指定的url!': '請先上傳指定的url!',
  '共享指令已发送成功!': '共享指令已發送成功!',
  '行政组织': '行政組織',
  '请选择行政组织！': '請選擇行政組織！',
  '共享设置': '共亯設定',
  '共享项目': '共亯項目',
  '请先选择共享项目！': '請先選擇共亯項目！',
  '共享设置成功！': '共亯設置成功！',
  '目标端大数据湖': '目標端大數據湖',
  '迁移对象选择': '遷移對象選擇',
  '源端信息': '源端信息',
  '源端库或Schema':'源端庫或Schema',
  '源端表': '源端表',
  '源端参数': '源端參數',
  '一次性读取到内存中的记录条数': '一次性讀取到內存中的記錄條數',
  '执行读取数DB数据的线程数，多线程更快': '執行讀取數DB數據的線程數，多線程更快',
  '切分表数据依赖列，需带索引或是主键，不填时自动寻找主键，没有则不切分表': '切分表數據依賴列，需帶索引或是主鍵，不填時自動尋找主鍵，沒有則不切分表',
  '增量时使用，需符合sql语法，参考：where 字段': '增量時使用，需符合sql語法，參考：where 字段',
  '目标端信息':'目標端信息',
  '目标端参数': '目標端參數',
  'Stg层库对应的Schema': 'Stg層庫對應的Schema',
  'Stg层对应的表名':'Stg層對應的表名',
  'Stg层数是否可复写。true/false': 'Stg層數是否可復寫。true/false',
  '执行入湖的线程数，多线程可能更快': '執行入湖的線程數，多線程可能更快',
  'ods层数据库schema': 'ods層數據庫schema',
  'ods层数tableName':'ods層數tableName',
  'ods层分区名称':'ods層分區名稱',
  '请先选择磁盘类型！': '請先選擇磁盤類型！',
  '请填写备注！': '請填寫備註！',
  '输入名称前缀匹配':'輸入名稱前綴匹配',
  '公司全称': '公司全稱',
  '公司税号':'公司稅號',
  '开户行':'開戶行',
  '银行卡号':'銀行卡號',
  '分机号':'分機號',
  '终端号':'終端號',
  '合同编号':'合同編號',
  '发票类型': '發票類型', 
  '发票种类':'發票種類',
  '公司性质': '公司性質',
  '银行账号': '銀行賬號',
  '开票方': '開票方',
  '合同号':'合同號',
  '联系人手机':'聯系人手機',
  '非企业':'非企業',
  '纸质专票':'紙質專票',
  '纸质普票':'紙質普票',
  '电子普票':'電子普票',
  '长度在 1 到 100 个字符':'長度在 1 到 100 個字符',
  '长度在 1 到 20 个字符':'長度在 1 到 20 個字符',
  '不能超出20个字符':'不能超出20個字符',
  '不能超出255个字符':'不能超出255個字符',
  '长度在 1 到 8 个字符': '長度在 1 到 8 個字符',
  '长度在 1 到 5 个字符':'長度在 1 到 5 個字符',
  '长度在 1 到 80 个字符':'長度在 1 到 80 個字符',
  '必填，在1-200范围内': '必填，在1-200範圍內',
  '电子发票开具后自动发送至邮箱':'電子發票開具後自動發送至郵箱',
  '请输入数字':'請輸入數字',
  '确定要删除开票信息？':'確定要刪除開票信息？',
  '删除后系统将无法开具该开票方发票':'刪除後系統將無法開具該開票方發票',
  '请输入公司名称进行查询' : '請輸入公司名稱進行査詢',
  '行政组织选择错误' : '行政組織選擇錯誤',
  '当前为全选状态，无法展开节点' : '當前為全選狀態，無法展開節點',
  '点击选择月份' : '點擊選擇月份',
  '确认账单金额' : '確認帳單金額',
  '账单金额' : '帳單金額',
  '账单行政组织' : '帳單行政組織',
  '集合' : '集合',
  '标准层级' : '標準層級',
  '账单确认' : '帳單確認',
  '账单提交' : '帳單提交',
  '账单确认成功！' : '帳單確認成功！',
  '账单提交成功！' : '帳單提交成功！',
  '请先选择账单 !' : '請先選擇帳單 !',
  '账单下载' : '帳單下載',
  '月度账单汇总' : '月度帳單匯總',
  '批量账单确认' : '批量帳單確認',
  '请至少选择一个行政组织！' : '請至少選擇一個行政組織！',
  '账单ID' : '帳單ID',
  '账单总额' : '帳單總額',
  '账单确认时间' : '帳單確認時間',
  '未确认' : '未確認',
  '已确认' : '已確認',
  '申请开票' : '申請開票',
  '开票完成' : '開票完成',
  '账单生成时间' : '帳單生成時間',
  '账单核对' : '帳單核對',
  '批量确认' : '批量確認',
  '批量下载' : '批量下載',
  '请输入关键词搜索':'請輸入關鍵詞搜索',
  '行政组织授权':'行政組織授權',
  '此节点为无效节点':'此節點為無效節點',
  '已授权用户':'已授權用戶',
  '编辑权限':'編輯權限',
  '移除用户':'移除用戶',
  '清除全部':'清除全部',
  '选择全部':'選擇全部',
  '移除失败': '移除失敗',
  '批量移除用户成功！':'批量移除用戶成功！',
  '开票':'開票',
  '11-20字符，格式：区号-固定号码':'11-20字符，格式：區號-固定號碼',
  '长度在 11 到 20 个字符':'長度在 11 到 20 個字符',
  '运营管理':'運營管理',
  '置灰的组织节点为没有挂载项目或无效的组织节点':'置灰的組織節點為沒有掛載項目或無效的組織節點',
  '触发器信息': '觸發器信息',
  '触发时机': '觸發時機',
  '事件': '事件',
  '触发表': '觸發表',
  '触发语句': '觸發語句',
  '格式化SQL': '格式化SQL',
  '导 出': '導 出',
  '创建触发器': '創建觸發器',
  '编辑触发器': '編輯觸發器',
  'SQL变更提交预览': 'SQL變更提交預覽',
  '触发器变更提交预览': '觸發器變更提交預覽',
  '编辑函数': '編輯函數',
  '设置行数':'設置行數',
  '选择格式':'選擇格式',
  'Oracle备份': 'Oracle備份',
  'Oracle实例': 'Oracle實例',
  '数据库服务IP':'數據庫服務IP',
  '数据库所在位置':'數據庫所在位置',
  '实例名称':'實例名稱',
  'IP':'IP',
  '添加Oracle实例':'添加Oracle實例',
  'oracle实例':'oracle實例',
  '请输入实例名称':'請輸入實例名稱',
  '确认要删除这个':'確認要刪除這個',
  '实例吗?':'實例嗎?',
  '确认删除后，Oracle实例不再显示在列表':'確認刪除後，Oracle實例不再顯示在列表',
  '实例删除成功！':'實例刪除成功！',
  '英文名须a-zA-Z-_0-9！':'英文名須a-zA-Z-_0-9！',
  '空表单无法提交!':'空表單無法提交',
  '无符合条件的数据库':'無符合條件的數據庫',
  '服务IP':'服務IP',
  '注册Oracle实例':'註冊Oracle實例',
  '数据库名称':'數據庫名稱',
  '请选择租户 !':'請選擇租戶 !',
  '请选择项目 !':'請選擇項目 !',
  '请输入实例名称 !':'請輸入實例名稱 !',
  '请选择数据库服务IP !':'請選擇數據庫服務IP !',
  '实例创建请求已发送成功 !':'實例創建請求已發送成功 !',
  '请先选择搜索维度 !':'請先選擇搜索維度 !',
  '请输入搜索关键字 !':'請輸入搜索關鍵字 !',
  'Oracle详情':'Oracle詳情',
  '客户端列表':'客戶端列表',
  '认证用户名':'認證用戶名',
  '认证方式':'認證方式',
  'os系统认证方式':'os系統認證方式',
  '策略已启用!':'策略已啟用!',
  '策略已禁用!':'策略已禁用!',
  '备份策略吗?':'備份策略嗎?',
  '确认删除备份策略后，备份策略下备份计划同步删除':'確認刪除備份策略後，備份策略下備份計劃同步刪除',
  '策略删除成功！':'策略刪除成功！',
  '注册Oracle实例:':'註冊Oracle實例:',
  '开启日志备份':'開啟日誌備份',
  '注册的Oracle实例':'註冊的Oracle實例',
  'Oracle备份策略详情':'Oracle備份策略詳情',
  '【创建备份计划】/【编辑备份计划】/【立即备份】/【删除备份计划】':'【創建備份計劃】/【編輯備份計劃】/【立即備份】/【刪除備份計劃】',
  '备份策略已被【':'備份策略已被【',
  '】，当前备份策略状态处于【':'】，當前備份策略狀態處於【',
  '】,【不】允许':'】,【不】允許',
  '确定启用备份策略吗?':'確定啟用備份策略嗎?',
  '确认要删除这个【':'確認要刪除這個【',
  '】备份计划吗?':'】備份計劃嗎?',
  '计划删除成功！':'計劃刪除成功！',
  '数据库实例IP地址':'數據庫實例IP地址',
  'Oracle实例名称':'Oracle實例名稱',
  '】备份策略吗?':'】備份策略嗎?',
  '当前策略已有日志备份':'當前策略已有日誌備份',
  '备份计划创建成功！':'備份計劃創建成功！',
  '策略说明最长支持256个字符！':'策略說明最長支持256個字符！',
  'oracle实例名称' : 'oracle實例名稱',
  '数据库实例IP' : '資料庫實例IP',
  '刷新账单':'刷新帳單',
  '账单刷新操作已提交，请耐心等待':'帳單刷新操作已提交，請耐心等待',
  '为保证账单的准确性，当行政组织挂载的项目发生变化时，需要在批量操作下手动执行刷新账单操作':'為保證帳單的準確性，當行政組織掛載的項目發生變化時，需要在批量操作下手動執行刷新帳單操作',
  '置灰的组织节点为没有权限、没有挂载项目或无效的组织节点':'置灰的組織節點為沒有權限、沒有掛載項目或無效的組織節點',
  '集团行政组织树，项目可挂载在组织节点上':'集團行政組織樹，項目可掛載在組織節點上',
  '该节点为无效节点': '該節點為無效節點',
  '该组织节点未挂载任何项目': '該組織節點未掛載任何項目',
  '您没有该组织节点的权限':'您沒有該組織節點的權限',
  'Windows主机信息':'Windows主機信息',
  '快照时间':'快照時間',
  '温馨提示：启动数据库备份，会按照收费标准收取费用，生产可用区的数据库强烈建议开启数据库备份，否则在数据库出现数据损坏、丢失、误删等情况下，将无法找回原始数据。':'溫馨提示：啟動數據庫備份，會按照收費標準收取費用，生產可用區的數據庫強烈建議開啟數據庫備份，否則在數據庫出現數據損壞、丟失、誤刪等情況下，將無法找回原始數據。',
  '确认不启动数据库备份吗?':'確認不啟動數據庫備份嗎?',
  '关闭数据库备份，在数据库出现数据损坏、丢失、误删等情况下，将无法找回原始数据。':'關閉數據庫備份，在數據庫出現數據損壞、丟失、誤刪等情況下，將無法找回原始數據。',
  '开票记录查看':'開票記錄查看',
  '开票申请':'開票申請',
  '合并开票申请':'合併開票申請',
  '服务版块':'服務版塊',
  '待开票金额':'待開票金額',
  '开票记录':'開票記錄',
  '消费账单':'消費帳單',
  '合计':'合計',
  '合并开票':'合併開票',
  '开票公司全称':'開票公司全稱',
  '开票金额':'開票金額',
  '开票记录ID':'開票記錄ID',
  '账单金额（含税）':'帳單金額（含稅）',
  '可开票金额（含税）':'可開票金額（含稅）',
  '云服务费':'雲服務費',
  '请至少勾选2个需要合并开票的资源':'請至少勾選2個需要合併開票的資源',
  '请先选择开票公司！':'請先選擇開票公司！',
  '请先选择发票类型！':'請先選擇發票類型！',
  '申请开票成功！':'申請開票成功！',
  '请在发票管理详情关注审批结果':'請在發票管理詳情關注審批結果',
  '开票信息':'開票信息',
  '发票信息详情':'發票信息詳情',
  '审批信息':'審批資訊',
  '业务单号':'業務單號',
  '发票代码':'發票代碼',
  '发票号码':'發票號碼',
  '详情':'詳情',
  '开票人':'開票人',
  '申请开票时间':'申請開票時間',
  '产权码':'產權碼',
  '等待GOA审批':'等待GOA審批',
  'GOA审批通过':'GOA審批通過',
  'GOA审批不通过':'GOA審批不通過',
  '发票开具成功':'發票開具成功',
  '发票开具失败':'發票開具失敗',
  '开票金额不能为0！': '開票金額不能為0！',
  '勾选项中存在待开票金额为0的资源': '勾選項中存在待開票金額為0的資源',
  '待开票金额为0，不可申请开票！': '待開票金額為0，不可申請開票！',
  '单月账单列表': '單月帳單列表',
  '审批时间': '審批時間',
  '请选择磁盘类型！':'請選擇磁盤類型！',
  '确定卸载该':'確定卸載該',
  '请选择比源端库大的数据盘':'請選擇比源端庫大的數據盤',
  '请输入与源端库RMAN备份时一致的实例名':'請輸入與源端庫RMAN備份時一致的實例名',
  'EXPDP逻辑备份':'EXPDP邏輯備份',
  'RMAN物理备份':'RMAN物理備份',
  '温馨提示：云磁盘卸载后，将变成“空闲”状态，会继续收费。 如果您不再需要该云磁盘，请到【存储】--【云磁盘CBS】的界面删除空闲状态的该盘！':'温馨提示：雲磁盤卸載後，將變成“空閑”狀態，會繼續收費。 如果您不再需要該雲磁盤，請到【存儲】--【雲磁盤CBS】的界面刪除空閑狀態的該盤！',
  '温馨提示：云磁盘卸载后，将变成“空闲”状态，会继续收费。 如果您不再需要该云磁盘，请在列表删除空闲状态的该盘！':'温馨提示：雲磁盤卸載後，將變成“空閑”狀態，會繼續收費。 如果您不再需要該雲磁盤，請在列表刪除空閑狀態的該盤！',
  '证书品牌':'證書品牌',
  '证书域名类型':'證書域名類型',
  '域名验证方式':'域名驗證方式',
  '加密算法':'加密算法',
  '密钥对参数':'密鑰對參數',
  '有效期限':'有效期限',
  '已选证书':'已選證書',
  '设置公司信息':'設置公司信息',
  '公司地址':'公司地址',
  '邮政编码':'郵政編碼',
  '公司电话':'公司電話',
  '联系人姓氏':'聯系人姓氏',
  '联系人名字':'聯系人名字',
  '联系人电话':'聯系人電話',
  '联系人邮箱':'聯系人郵箱',
  '联系人职位':'聯系人職位',
  '当首次购买OV/EV证书时，需要上传公司信息确认函':'當首次購買OV/EV證書時，需要上傳公司信息確認函',
  '公司信息确认函用于审核企业信息，请下载公司信息确认函模板，正确填写并加盖公章后，扫描成PDF上传完成审核':'公司信息確認函用於審核企業信息，請下載公司信息確認函模板，正確填寫並加蓋公章後，掃描成PDF上傳完成審核',
  '总数量':'總數量',
  '购买证书':'購買證書',
  '待域名验证':'待域名驗證',
  '待续费':'待續費',
  '确认函状态':'確認函狀態',
  '暂无公司信息确认函':'暫無公司信息確認函',
  '暂无':'',
  '点击此处下载公司信息确认函模板':'點擊此處下載公司信息確認函模板',
  '点击此处上传公司信息确认函':'點擊此處上傳公司信息確認函',
  '证书格式':'證書格式',
  '证书密码':'證書密碼',
  '续费年限':'續費年限',
  '证书吊销是指已经签发的证书从签发证书机构处注销':'證書吊銷是指已經簽發的證書從簽發證書機構處註銷',
  '证书吊销后将失去加密效果，浏览器不在信任该证书':'證書吊銷後將失去加密效果，瀏覽器不在信任該證書',
  '签发后30天内吊销，可以取消订单，签发后超过30天无法完成吊销':'簽發後30天內吊銷，可以取消訂單，簽發後超過30天無法完成吊銷',
  '吊销确认函用于审核SSL证书的吊销申请':'吊銷確認函用於審核SSL證書的吊銷申請',
  '请下载吊销信息函模板，正确填写并加盖公章后，扫描成电子文件上传完成审核':'請下載吊銷信息函模板，正確填寫並加蓋公章後，掃描成電子文件上傳完成審核',
  '上传文件类型可以是jpg、png、gif、tiff、pdf、zip、rar等':'上傳文件類型可以是jpg、png、gif、tiff、pdf、zip、rar等',
  '点击此处下载吊销确认函模板':'點擊此處下載吊銷確認函模板',
  '点击此处上传吊销确认函模板':'點擊此處上傳吊銷確認函模板',
  '您确定要吊销证书吗':'您確定要吊銷證書嗎',
  '域名验证值':'域名驗證值',
  '域名验证值为':'域名驗證值為',
  '请及时根据域名验证值到做域名验证，逾期订单可能会被拒绝，谢谢':'請及時根據域名驗證值到做域名驗證，逾期訂單可能會被拒絕，謝謝',
  '吊销验证值':'吊銷驗證值',
  '吊销验证值为':'吊銷驗證值為',
  '请及时根据吊销验证值到做吊销验证，谢谢':'請及時根據吊銷驗證值到做吊銷驗證，謝謝',
  '您确定要取消订单吗':'您確定要取消訂單嗎',
  '上传信息确认函':'上傳信息確認函',
  '公司信息确认函用于审核企业信息，请正确填写并加盖公章后，扫描成电子文件上传完成审核。上传文件类型可以是jpg、png、gif、tiff、pdf、zip、rar等':'公司信息確認函用於審核企業信息，請正確填寫並加蓋公章後，掃描成電子文件上傳完成審核。上傳文件類型可以是jpg、png、gif、tiff、pdf、zip、rar等',
  '证书所服务项目':'證書所服務項目',
  '告警历史':'告警歷史',
  '指标':'指標',
  '指标信息':'指標信息',
  '告警值':'告警值',
  '级别':'級別',
  '发生时间':'發生時間',
  '持续时长':'持續時長',
  '高':'高',
  '中':'中',
  '低':'低',
  '正在告警':'正在告警',
}


// WEBPACK FOOTER //
// ./src/locale/lang/zh-TW.js